import * as React from 'react';

export const PlaceholderDamageCloseUp = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		id="damage-closeup-placeholder"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 800 499.8"
		{...props}
	>
		<g id="damage-closeup-placeholder-original">
			<defs>
				<clipPath id="a">
					<path
						d="M0 0h800v499.7H0z"
						data-name="Rechteck 2"
						opacity=".8"
						transform="translate(0 .1)"
					/>
				</clipPath>
			</defs>
			<path fill="currentColor" d="M0 0h800v499.8H0z" data-name="Rechteck 1" opacity=".2" />
			<g data-name="Gruppe 51" opacity=".8">
				<g clipPath="url(#a)" data-name="Gruppe 10" transform="translate(0 -.1)">
					<g data-name="Gruppe 9">
						<path
							fill="currentColor"
							d="M1525.6 456.6l-238.2-17.5-8.5 1.5 247.4 18.1-.7-2.1zm-500.1-5.3l-.4 2.4.8-2.5-.4.1zM-510.2 684.6l4.6.4v-.2l-4.6-.2z"
							data-name="Pfad 1"
						/>
						<path
							fill="currentColor"
							d="M2024.5 516.9c-257.4 69.1-950.1 231-1214 290.2-321.1 72-551.1 78.7-816.3 78.7s-1059.9-71.4-1180.3-91.8 120.7-94.6 435.1-143.6l35.6-5.4a178.8 178.8 0 0038 19.8c-133.3 33.9-210.2 73.8-145.6 84.7 101.1 17.1 813.2 67.4 1035.7 67.4 151.3 0 288.9-2.6 446.2-23.3 74.1-9.7 152.6-23.4 238.9-42.8l80.8-18.3c258.6-59 744.6-173.3 938-225.2 40.2-10.8 32.5-16.1 26.2-16.8-8.3-1-65.8-5.5-148.3-11.7a9.5 9.5 0 00.9-2.1c141.5 10.6 247.6 18.7 260.2 20.3 7.6.8 16.8 7.1-31.1 19.9z"
							data-name="Pfad 2"
							opacity=".2"
						/>
						<path
							fill="currentColor"
							d="M1916.7 507.3c-193.4 51.9-679.4 166.2-938 225.2l-80.8 18.3A2651.2 2651.2 0 01659 793.6c-157.3 20.7-294.9 23.3-446.2 23.3-222.5 0-934.6-50.3-1035.7-67.4-64.6-10.9 12.3-50.8 145.6-84.7a163.3 163.3 0 0055.9 10.8l102.9 8.4h.2l8.2.7 4.6.4v-.2h3.4c48.5 0 93.2-23.7 128.7-63.5 170.5 8.3 339.8 13.7 407.1 11.8 86.5-2.5 279.8-18.3 401.8-28.8 40.9 86.3 109.6 142.9 187.4 142.9l7.7.6 129.4 9.8v-.3l5 .1c109.5 0 201.1-109.2 225-255.9a20 20 0 00.4-2.4l6.3-1.3h.1l21.7-4.6a9549.8 9549.8 0 01260.4-52.5l247.4 18.1c18.1 48.9 43.8 79.5 72.5 79.5l122.8 5.9 3.7.2c26.6 0 51-24.9 69.2-65.6 82.5 6.2 139.9 10.7 148.3 11.7 6.3.6 14 5.9-26.1 16.7z"
							data-name="Pfad 3"
							opacity=".8"
						/>
						<path fill="currentColor" d="M-505.6 684.8v.2l-4.6-.4 4.6.2z" data-name="Pfad 4" />
						<path fill="currentColor" d="M1025.8 451.2l-.8 2.5.4-2.4.4-.1z" data-name="Pfad 5" />
						<g data-name="Gruppe 2">
							<g data-name="Gruppe 1">
								<path fill="currentColor" d="M-505.6 684.8v.2l-4.6-.4 4.6.2z" data-name="Pfad 6" />
							</g>
						</g>
						<path
							fill="currentColor"
							d="M-444.9-324.4l-4 3.4q-17.6 15-34.6 30.3l-12.4.2-62.5.8a112.3 112.3 0 01-19.2-72 57.6 57.6 0 013.3-14.4c9.2-23.2 80.5-9.2 110.5 9.7a24 24 0 016.8 6.7 44.4 44.4 0 014.2 7.5 99.6 99.6 0 015.2 15.7l2.7 12.1z"
							data-name="Pfad 7"
							opacity=".6"
						/>
						<path
							fill="currentColor"
							d="M-483.5-290.7l-2.9 2.6-19.1 17.4c-7 0-14 .1-20.1.3l-13.4-4.2c-7.5-2.5-14-7.9-19.5-15.2l62.5-.8z"
							data-name="Pfad 8"
							opacity=".8"
						/>
						<path
							fill="currentColor"
							d="M1031.3 396.9a238.5 238.5 0 01-20-62 1508 1508 0 01-7.2-53c-3.7-28.5-8.3-64.8-14.2-105.8-1.7-11.4-3.3-23.1-5.2-35.1a5 5 0 01-.2-1.3c-5.3-31.1-10.5-63.3-15.7-94.5v-.5A2483 2483 0 00948-57.8a1382.3 1382.3 0 00-49.2-172.6L879.7-250 867-263a65.2 65.2 0 01-23.8 12.1 41.8 41.8 0 01-31.6-8.7 33 33 0 01-3.4-3c-10.3-10.3 5.4-23 14.6-29.1l-3.9.4-20.3 2.1-21.1 2.1-19.2 1.7.3 1.4c-103.1 25.4-311.4 89.2-352.5 101.9a27.5 27.5 0 0121.5 43.3 286.7 286.7 0 01-64.3 65.9 261.8 261.8 0 01-109.5 46.8C166-10.1 45.8-1.2-41.9 3.5l-17.5.9v1.4c-3.3.1-312.7 14.5-450 14.5l-22.3-.1C-653.9 18.3-822.8 1.9-824.5 1.7l.1-1.4c-24.1-5.3-49.4-16.7-46.3-41.1a41.1 41.1 0 011.2-5.9c-42.9 63.9-53.5 123.1-63.7 166.5-12 51-17.5 182.6 48.1 325.3a192.8 192.8 0 0028 45.2c-17.6-54.7-19.3-111.1 13.3-112.5l6.8-.2c21.1-.4 66.7.4 125.1 1.9l68.6 1.9 21.9.6 75.1 2.3 3.1.1 12 .4 33 1 9.5.3 20 .7 11.7.4 55.5 1.8a32602.3 32602.3 0 0167.2 2.3l41.6 1.4 98.6 3.4 48.3 1.6c104.5 3.4 186 34 252 70.2a926.4 926.4 0 0181.6 51.2l27.2 19c13.2 9.3 25.5 17.9 37.2 25.6 12.8 8.3 90 4 165.7-2.7 51.6-4.6 102.4-10.2 131.8-13.6l8.4-1 16.9-2h.1l5-54.2.4-3.9 2.1-20.5c4.3-40.7 9.2-80.2 15-118a.6.6 0 01.1-.4 2.8 2.8 0 01.1-.9c1.3-10.7 3.1-21.4 5.2-32.2v-.3c5.8-33.8 12.2-65.9 19.6-95.8a798.6 798.6 0 0122.9-77.5q8.6-23.7 18.1-44.1l2.6-5.4c9.4-19.2 19.8-36 31.1-50.1l-2.1 2-28.2-30-.2-.2c-.3-.2-36.9-30.4-98.8-60.3-23-11.1-52.1-18-80.8-22.4h-.1a699.4 699.4 0 00-114.6-7l-.1-2.9c.9 0 70.3-2.2 134.5 10.4h.1A262.6 262.6 0 01569.1-50c61.1 29.5 97.6 59.2 99.5 60.7l.1.1 28.9 30c24.6-30.7 53.8-48.7 88.8-50.4 57.2-2.9 96.8 46.9 123.1 119 9.8 27 17.7 57 24 88.7a355.2 355.2 0 0134.6 68.6A446.8 446.8 0 01996 417.9l.1 7.4v.8q0 16.6-1.2 33l30.6-7.8a.6.6 0 00.4-.1 147.2 147.2 0 005.2-28.6l.2-2.1.4-5.9v-.3a130.3 130.3 0 00-.4-17.4zM-143.9 266.8a2196.5 2196.5 0 01-196.8 8.6h-28.5l-45.4-.2c-20.4-.2-41.1-.4-61.7-.8l-19.2-.3-21-.4c-28.5-.6-56.6-1.3-83.6-2.1l-21.4-.7-2.2-.1a5276.3 5276.3 0 01-125-5.5c-23.7-1.4-48.2-2.1-71.3-3.3-71.6-3.4-130.4-10.8-113.2-53.8 19-47.6 76.1-135.1 201.6-138.9 96.8-2.9 287.2 2.1 401.4 4.1 91.4 1.5 170.1 17.7 241.4 51 42.3 19.8 82 45.7 120 78.1 35 30-49.1 52.7-175.1 64.3z"
							data-name="Pfad 9"
							opacity=".6"
						/>
						<path
							fill="currentColor"
							d="M603.2 314.2a1446 1446 0 00-5.3 33.2 2.8 2.8 0 01.1-.9c1.3-10.7 3.1-21.5 5.2-32.3z"
							data-name="Pfad 10"
						/>
						<path
							fill="currentColor"
							d="M994.9 459.1c.8-10.8 1.2-21.9 1.2-33v-.8l-.1-7.4a446.3 446.3 0 00-27.9-151.2 355.2 355.2 0 00-34.6-68.6 614.9 614.9 0 00-24-88.7c-26.2-72.1-65.9-122-123.1-119-35 1.8-64.2 19.8-88.8 50.4a278.5 278.5 0 00-31.1 50.1l-2.6 5.4a505.1 505.1 0 00-18.1 44.1 779.4 779.4 0 00-22.9 77.5c-7.4 30-13.8 62-19.6 95.8v.3a1446 1446 0 00-5.3 33.2.6.6 0 01-.1.4 2543.9 2543.9 0 00-17.1 138.5l-.4 3.9-5 54.2h-.1l-16.9 2-8.4 1c-29.3 3.4-80.2 9.1-131.8 13.6-75.7 6.7-152.9 11.1-165.7 2.7-11.7-7.7-24.1-16.3-37.2-25.6l-27.2-19a950.5 950.5 0 00-81.6-51.2 548.8 548.8 0 00-252-70.2l-48.3-1.6-98.6-3.4-41.6-1.4-15.2-.5-52-1.8-55.5-1.8-11.7-.4-20-.7-9.5-.3-33-1-12-.4-3.1-.1-75.1-2.3-21.9-.6-68.6-1.9a3717.8 3717.8 0 00-131.9-1.7c-32.7 1.5-31 57.8-13.3 112.5 16.2 50.4 45.9 99.4 74.7 102.9l14.2 1.7c15.6 20 33.4 37 52.9 50.1a178.8 178.8 0 0038 19.8 163.3 163.3 0 0055.9 10.8l102.9 8.4h.2l8.2.7 4.6.2h3.4c48.5 0 93.2-23.7 128.7-63.5C-202.6 629.5-33.3 634.9 34 633c86.5-2.5 279.8-18.3 401.8-28.8 40.9 86.3 109.6 142.9 187.4 142.9l7.7.6 129.4 9.8v-.3l5 .1c109.5 0 201.1-109.2 225-255.9a20 20 0 00.4-2.4l.2-1.1a58.1 58.1 0 0012.7-8.7 16.6 16.6 0 001.4-1.3 81.3 81.3 0 0020.4-34.5l.4-2.4-30.9 8.1zm-44.8-26.3a360.7 360.7 0 01-4.4 50.6 337 337 0 01-10.3 45.9c-26.6 88.7-86.3 150.4-155.6 150.4a117.5 117.5 0 01-17.8-1.3c-41.3-6.4-78.3-34.9-105.4-77.3a286 286 0 01-33.7-76.4 368.5 368.5 0 01-13.5-99.4 363.2 363.2 0 0113.5-99.3c24.9-87.5 81.7-149.9 148.6-154.7l4-.2 4.3-.1c92.2 0 167.3 109.2 170.3 245.7l.1 8.6-.1 7.5z"
							data-name="Pfad 11"
						/>
						<path
							fill="currentColor"
							d="M984.5 139.7c-5.3-31.1-10.5-63.3-15.7-94.5 5.9 32.6 11.1 64.5 15.7 94.5z"
							data-name="Pfad 12"
						/>
						<path fill="currentColor" d="M1025.8 451.2l-.8 2.5.4-2.4.4-.1z" data-name="Pfad 13" />
						<path
							fill="currentColor"
							d="M1718.1-12.5a3.8 3.8 0 01-.1.8l-1.6-.2a5.8 5.8 0 011.7-.6z"
							data-name="Pfad 14"
						/>
						<g data-name="Gruppe 3">
							<path
								fill="currentColor"
								d="M603.2 314.2a1446 1446 0 00-5.3 33.2 2.8 2.8 0 01.1-.9c1.3-10.7 3.1-21.5 5.2-32.3z"
								data-name="Pfad 15"
							/>
						</g>
						<g fill="currentColor" data-name="Gruppe 4">
							<path d="M1687.3 417.3l.6 1.5.3-1.7a3 3 0 01-.9.2z" data-name="Pfad 16" />
							<path d="M1687.3 417.3l.6 1.5.3-1.7a3 3 0 01-.9.2z" data-name="Pfad 17" />
							<path d="M1687.3 417.3l.6 1.5.3-1.7a3 3 0 01-.9.2z" data-name="Pfad 18" />
							<path
								d="M1800.3 293.1c0 37.5-4.6 72.3-12.4 100.7l-1.8 6.2-2.4-4.4-42.8-79.5a124.1 124.1 0 001.9-21v-4.6l54.8-46a423.7 423.7 0 012.7 48.6z"
								data-name="Pfad 19"
							/>
							<path d="M1688.2 417.2l-.3 1.7-.6-1.5a3 3 0 01.9-.2z" data-name="Pfad 20" />
						</g>
						<path
							fill="currentColor"
							d="M603.2 314.2a1446 1446 0 00-5.3 33.2 2.8 2.8 0 01.1-.9c1.3-10.7 3.1-21.5 5.2-32.3z"
							data-name="Pfad 21"
						/>
						<path
							fill="currentColor"
							d="M-143.9 266.8a2196.5 2196.5 0 01-196.8 8.6h-28.5l-45.4-.2c-20.4-.2-41.1-.4-61.7-.8l-19.2-.3-21-.4c-28.5-.6-56.6-1.3-83.6-2.1l-21.4-.7-2.2-.1a5276.3 5276.3 0 01-125-5.5c-23.7-1.4-48.2-2.1-71.3-3.3-71.6-3.4-130.4-10.8-113.2-53.8 19-47.6 76.1-135.1 201.6-138.9 96.8-2.9 287.2 2.1 401.4 4.1 91.4 1.5 170.1 17.7 241.4 51 42.3 19.8 82 45.7 120 78.1 35 30-49.1 52.7-175.1 64.3z"
							data-name="Pfad 22"
							opacity=".8"
						/>
						<path
							fill="currentColor"
							d="M1663.6-512.7a5 5 0 00-.7-.8 5 5 0 00.7.8z"
							data-name="Pfad 23"
							opacity=".6"
						/>
						<path
							fill="currentColor"
							d="M1839.4 232v.3a59.5 59.5 0 01-10.8 21.5l.6-57.9s-5.4-215.9-93.5-211.2a75.3 75.3 0 00-17.5 2.8 233.6 233.6 0 001.3-25.3v-12.6c-.2-13.3-1.1-30-3.3-49.8-.9-8.3-3.3-17.3-5.8-26.9a244 244 0 01-8.2-40.7 128.5 128.5 0 01.5-29.6c.4-3.3.8-7.2 1.1-11.7 3.3-50.6-3.1-167.8-3.2-169.1a1.8 1.8 0 00-.4-.9l-52.3-55.1 3.3-1.1 2.3-1 1.7-.8 2.5-1.4a21.4 21.4 0 001.9-1.3 10.6 10.6 0 001.1-.9.3.3 0 01.2-.1l2-1.9a5.7 5.7 0 00.7-.8l.7-.8.6-.7a.1.1 0 01.1-.1l1.3-1.9.2-.3a25.4 25.4 0 001.6-2.8l.8-1.7a60.4 60.4 0 002.9-7.6l1.2-3.9.8-2.9.6-2.2.3-1.3.4-1.6 1.2-5 .2-.8.7-2.9.3-1.2 1.2-5.1 1.7-7.2a597 597 0 00-10.3-12.1l-6.2-6.9a5 5 0 00-.7-.8l-.4-.4a35.8 35.8 0 00-2.6-2.9c-2.6-2.9-5.2-5.7-7.9-8.4l-1.7-1.8-9-9.1-9.1-8.9c-6.6-6.2-13.2-12.4-20-18.3a39 39 0 00-3.8-3.3l-.6-.6-8-6.8v-.1l-.5-.4-.6-.5c-3.8-3.2-7.7-6.4-11.7-9.5l-11.5-9-.8-.6c-3.7-2.9-7.5-5.7-11.3-8.4a.3.3 0 00-.2-.1l-9.7-7-5-3.5a489 489 0 00-9.1-6.2l-6.4-4.2a6.4 6.4 0 00-1.4-.8 87.8 87.8 0 00-5.6-3.6l-7.5-4.7-6.7-4.1c-7.1-4.3-14.3-8.4-21.5-12.4-4-2.2-7.9-4.4-12-6.5a971 971 0 00-20.3-10.4l-7.5-3.6q-7.5-3.6-15-6.9l-7.5-3.3-7.3-3.1-6.7-2.8c-5.2-2.2-10.4-4.2-15.6-6.1l-6.8-2.5a537.8 537.8 0 00-29.3-9.8c-2.2-.7-4.5-1.3-6.7-2.1l-7.4-2.1-7-1.9-9.6-2.5h-.1a4.3 4.3 0 01-.5-.1l-4.6-1.1-4.1-.9a3 3 0 00-.8-.2c-5-1.2-9.9-2.2-14.7-3.1l-5.6-1.1a12.9 12.9 0 01-1.9-.4l-4.6-.8a25 25 0 00-2.9-.5l-1.7-.3-3-.5a6.9 6.9 0 01-1.3-.2l-3.5-.5a4.3 4.3 0 01-1.1-.2l-2-.2-3-.4a49.5 49.5 0 00-5.4-.6h-.2a6.6 6.6 0 00-1.4-.1 170 170 0 00-9.8-.9l-.8-.1h-.3l-5.5-.4a138 138 0 00-11-.4 24.3 24.3 0 00-2.7 0h-9.9l-4.9.2c-3.9.2-7.7.5-11.3.9l-7.5.9-7.5 1.1-5.6.9c-5 .8-10 1.8-14.9 2.9l-3.7.8-1.5.3c-4.5 1-8.8 2.1-13.2 3.3l-6.5 1.8-6.5 2c-2.1.7-4.3 1.3-6.4 2.1l-6.4 2.2-6.3 2.3-6.3 2.4-5.8 2.3-.9.4-8.5 3.7-9.3 4.2-6 2.9-11.8 6.1-5.8 3.2c-3.9 2.1-7.7 4.4-11.5 6.7l-5.7 3.4-5.2 3.3a.5.5 0 00-.4.3c-3.7 2.4-7.5 4.8-11.1 7.3l-5.4 3.7a15.3 15.3 0 01-1.6 1.1l-9.3 6.7-8.6 6.4c-2.5 1.9-4.9 3.7-7.2 5.7a237 237 0 01-5.2 4.2l-5.1 4.2-10 8.6c-5 4.3-9.9 8.8-14.7 13.3l-4.8 4.5-4.7 4.6-4.7 4.6-6.9 7-4.6 4.8-6.7 7.1-4.4 4.8-5.6 6.2-6.6 7.4a710.1 710.1 0 00-21.4 25.7 1.8 1.8 0 00-.5.7l-5.3 6.7-4.6 6q-4.4 5.6-8.4 11.1l-7.3 10-7.1 9.9c-2.4 3.3-4.6 6.6-6.8 9.9l-9.9 14.7-3.2 4.9-3.1 4.8-3.1 4.8-5.9 9.5a1065 1065 0 00-21.7 36.7l-2.5 4.4-6.2 11.3-3.2 6-6.2 11.7-2.9 5.5-6.7 13.2a363.2 363.2 0 00-8.1 16.7l-.1.2-6.6 14.2v.1l-1.2 2.5-2.1 4.7-4.4 10.2-1.7 4c-2.1 5-3.1 7.8-3.1 7.8l-.4-1.4c-23.7 5.8-53 13.7-84.6 22.6-1-5-5.6-21.7-26.9-41.3l-.8.9c52.2-83.3 106.5-169.9 168.6-246.1 80.6-99 174.3-180.3 293.4-213.2h.1c25.4-5 52.5-9.2 80.9-12.7 173.5.1 344 95.7 491.2 267.3l5.9 7c54.2 42.8 93.6 71.3 93.6 71.3s70.9 301 83.7 323.9c13.2 25 .7 260.7-24.9 338.5z"
							data-name="Pfad 24"
							opacity=".6"
						/>
						<path
							fill="currentColor"
							d="M1716.6-37.9c-.2 16.9-1.3 25.6-1.4 25.8l1.1.2c-25.3 7.5-44.6 27-60.1 53.9a257.6 257.6 0 00-13 26.3c-13.6 31.5-23.7 69.3-32.6 108.7-4.1 18-7.8 37.9-11.7 58.3-6 31.3-12.2 63.5-20.2 90.6l-13.3 3.1-63 14.4c-31.9 7.3-71.3 16.1-113.6 25.4a177.1 177.1 0 006.4-37.5 1.4 1.4 0 00-.6-1.2c-.3-.3-29.6-21.1-28.8-49.8a37 37 0 01.8-7.3c16.5-78.6 25.5-185.3 26.9-319q.8-70.8-1.4-151.6c-.9-36-2.3-73.4-4.1-112.4a1.2 1.2 0 00-.5-1l-61.3-55.1 14.8-2.7 7.9-1.5 11-2.1 11.2-2.1 7.3-1.4 14.3-2.8 14.1-2.7 7.6-1.5 12.9-2.5 14.5-2.9 6.7-1.3 13-2.6 11.1-2.3 18.2-3.7 11.7-2.4 5.7-1.2 7-1.5 4.2-.9 10.5-2.2 22.9-4.9 4.9-1.1 16-3.5 4.3-1 8.3-1.9 6.5-1.5 6.3-1.5 6-1.4 3.4-.8 9.6-2.2 4.3-1.1a22.5 22.5 0 012.2-.5l3.7-.9 3.3-.8 2.5-.6 1.5-.4 6.4-1.7 1.7-.4 1.5-.4a.8.8 0 00.3.5l52.4 55.3c.5 8.6 6.3 119.3 3.3 168a216 216 0 01-1.1 11.7 130.7 130.7 0 00-.5 30.5c1.4 15 5 28.4 8.3 40.8 2.5 9.5 4.9 18.4 5.8 26.5 2.2 20.2 3 37 3.2 50.4l-.3 11.4z"
							data-name="Pfad 25"
							opacity=".6"
						/>
						<path
							fill="currentColor"
							d="M1392.2 331.6a170.2 170.2 0 01-6.7 37.5c-35.7 7.8-73.4 15.9-110.3 23.6a4820.8 4820.8 0 00-153 34.3l-6.8 1.7c-29.2 7.1-57.2 14.2-86.5 21.7a149.6 149.6 0 005-27.6 15 15 0 01.2-2.1 173 173 0 00.2-22.7v-.1a12 12 0 00-.1-1.5.8.8 0 00-.2-.5 232.3 232.3 0 01-19.8-61.4c-1.7-10-4-28-7.2-52.9-2.5-19.8-5.6-43.4-9.2-69.7v-.3a3114.3 3114.3 0 00-50.5-285.5 1348.3 1348.3 0 00-45.9-157.9.8.8 0 00-.3-.5l-18-18.4-13.7-14c2.8-2.1 5.4-4.2 7.6-6.2 45-4.5 92.9-14 114.8-19.2a72.8 72.8 0 0040.4-27.9q27.3-3.9 54.1-8l31.2-4.8 30.8-4.9 28.3-4.6 32.1-5.4 35.9-6.2 16.6-2.9 34.1-6.1 27.6-5v.1a1.6 1.6 0 00.4.7l61.7 55.4q2.7 58.2 4.1 112 2.1 80.6 1.4 151.3c-1.4 133.5-10.3 240.1-26.8 318.5a41.4 41.4 0 00-.9 8.4c-.3 27.5 25.1 47.8 29.4 51.1z"
							data-name="Pfad 26"
							opacity=".6"
						/>
						<path
							fill="currentColor"
							d="M1235.9-726.1zm50.9 4.2a6.9 6.9 0 01-1.3-.2l-3.5-.5 7.9 1.2-3.1-.5zm312.9 147.8l-.5-.4a2.2 2.2 0 01.5.4zm15.2 44.1l.1.2.2.1zm47.9 16.5a2.7 2.7 0 01.7.8 5 5 0 00-.7-.8zm-694 558.7c5.2 31.2 10.4 63.5 15.7 94.5-4.6-30-9.8-61.9-15.7-94.5zm56.7 406.1l-.4 2.4.8-2.5-.4.1z"
							data-name="Pfad 27"
						/>
						<path
							fill="currentColor"
							d="M603.2 314.2a1446 1446 0 00-5.3 33.2 2.8 2.8 0 01.1-.9c1.3-10.7 3.1-21.5 5.2-32.3z"
							data-name="Pfad 28"
							opacity=".1"
						/>
						<path
							fill="currentColor"
							d="M398.3-182.7l.4 1.3c-88.8 22-254.4 63-350.4 87.8a623 623 0 00-59.7 18.8 593.5 593.5 0 00-62 27.3C-96.7-35.4-90.8-2.8-68.6 3.3c-56.1 2.6-352 15.6-463 13.9C-633.8 15.7-768.5 4-810.9.1a30 30 0 0022.8-31.5c-4.3-54.5 3-106.4 3-106.4l-1.9 1.2c8-6.7 16.6-13.3 25.6-20 49.2-36.2 113.8-71.9 199-105.3l17.2-6.6a82.7 82.7 0 0119.6-2.1c6.1-.2 13.1-.3 20.1-.3l-2.6 2.4 26.1.4h2.6q22 .3 46.5.3h11.8c311 .7 877.8-16.1 1066.8-36.8l-.9 1c20.8 19.2 25.2 35.8 26 40a13733 13733 0 00-272.5 80.9z"
							data-name="Pfad 29"
							opacity=".6"
						/>
						<path fill="currentColor" d="M1154-776l-2.7.5 17.5-.7-14.8.2z" data-name="Pfad 30" />
						<path
							fill="currentColor"
							d="M1188.7-776.6q-42.6 5.3-80.9 12.7h-.1C988.6-731 894.9-649.7 814.4-550.7 752.3-474.5 698-387.8 645.8-304.6l-.1.1c-189 20.7-755.8 37.5-1066.8 36.8h-11.8q-24.5 0-46.5-.3l4.5-3.1c9.8-6.8 19.7-13.6 29.7-20.2l6.8-4.5 3.6-2.3 8.1-5.3C97.9-640 909.7-730.5 1151.3-775.5l17.5-.7c6.6-.3 13.2-.4 19.9-.4z"
							data-name="Pfad 31"
						/>
						<path
							fill="currentColor"
							d="M400.3-742.4A954.8 954.8 0 00231-703.8c-106.3 27.7-220.7 82.5-337 156.1-116.5 69.3-230 152-332 240.5l-2.8 2.4-10.2 8.9-5.4 4.8-3.6 3.2-18.8 16.9-3.2 2.9-26.1-.4 2.6-2.4 19.1-17.4 2.9-2.6q17.1-15.3 34.6-30.3l4-3.4a8.7 8.7 0 001-.8c256.7-218.6 575.6-389.6 749-408 29-3.1 60.9-6.1 95.2-9z"
							data-name="Pfad 32"
						/>
						<path
							fill="currentColor"
							d="M1154-776l-2.7.5C909.7-730.5 97.9-640-426.8-303.3l-8.1 5.3-3.6 2.3-6.8 4.5c-10 6.6-20 13.3-29.7 20.2l-4.5 3.1h-2.6l3.2-2.9 18.8-16.9 3.6-3.2 5.4-4.8 10.2-8.9 2.8-2.4a2331.2 2331.2 0 01332-240.5c116.2-73.5 230.7-128.3 337-156.1a952.8 952.8 0 01169.3-38.6c188.5-16 453.4-28.8 753.8-33.8z"
							data-name="Pfad 33"
							opacity=".4"
						/>
						<path
							fill="currentColor"
							d="M1829.1 195.9s-5.4-215.9-93.5-211.2a75.3 75.3 0 00-17.5 2.8 3.8 3.8 0 01-.1.8l-1.6-.2h-.1c-25.3 7.5-44.6 27-60.1 53.9a257.6 257.6 0 00-13 26.3c-13.6 31.5-23.7 69.3-32.6 108.7-4.1 18-7.8 37.9-11.7 58.3-6 31.3-12.2 63.5-20.2 90.6l-13.3 3.1-63 14.4c-31.9 7.3-71.3 16.1-113.6 25.4a63.6 63.6 0 01-1.9 6.2c-6.8 20.5-16.9 36-29.9 45.8a37.1 37.1 0 01-3.2 2.3 58.7 58.7 0 01-16.8 7.9l-.8-2.7a46.3 46.3 0 009.2-3.6 49 49 0 005-2.8c18-11.3 28.1-31.3 33.5-47.7l1.5-4.7c-35.7 7.8-73.4 15.9-110.3 23.6a4820.8 4820.8 0 00-153 34.3l-6.8 1.7c-29.2 7.1-57.2 14.2-86.5 21.7a114.3 114.3 0 01-6.1 16.6 77 77 0 01-12.9 19.7 11 11 0 01-1.5 1.6 59.6 59.6 0 01-11.6 9.4l21.7-4.6a9549.8 9549.8 0 01260.4-52.5l8.5-1.5c13.2-2.3 24.7-4.2 34.1-5.5 97.5-13.9 155.6-21.1 190.1-27.1a395.7 395.7 0 0014 50.1 19.4 19.4 0 00.8 2.2c18.1 48.9 43.8 79.5 72.5 79.5l122.8 5.9 3.7.2c26.6 0 51-24.9 69.2-65.6a9.5 9.5 0 00.9-2.1 420.8 420.8 0 0029.9-126.5v-.2a615 615 0 001.4-95.3l1.6-.8zM1797.6 389c-8.7 38.9-22.8 69.1-39.5 84.8l-2.3 2a36.7 36.7 0 01-23.7 9.7 32.5 32.5 0 01-6.9-.8 45 45 0 01-21.1-12.7l-2.2-2.4a129.7 129.7 0 01-22.1-37.2c-1.8-4.3-3.5-8.8-5.1-13.6a365.7 365.7 0 01-16.5-83.1c-1.2-13.7-1.9-28-1.9-42.6 0-56.1 9.5-106.6 24.5-141.8 11.5-26.7 26.2-44.5 42.5-49.3a32 32 0 018.7-1.2c38 0 69.4 70.9 74.9 163.5.6 9.4.8 19 .8 28.8a433 433 0 01-10.1 95.9z"
							data-name="Pfad 34"
						/>
						<path
							fill="currentColor"
							d="M1806.9 264.3c-5.5-92.6-36.9-163.5-74.9-163.5a32.6 32.6 0 00-8.7 1.2c-16.3 4.7-31 22.5-42.5 49.3-15 35.2-24.5 85.7-24.5 141.8 0 14.6.6 28.9 1.9 42.6a368 368 0 0016.5 83.1c1.6 4.8 3.3 9.3 5.1 13.6a127.4 127.4 0 0022.1 37.2l2.2 2.4c6.7 6.7 13.7 11 21.1 12.7a31.7 31.7 0 006.9.8c8.3 0 16.3-3.4 23.7-9.7a22 22 0 002.3-2c16.7-15.6 30.8-45.9 39.5-84.8 6.5-28.3 10.1-61 10.1-95.9 0-9.8-.2-19.4-.8-28.8zm-65.3-143.1c22 6.8 40.8 41.5 50.8 90.1l-54.9 45.5a49.2 49.2 0 00-6.4-13zm-55.6 51.2c9.4-25.2 21.7-43 35.6-49.5l-10.2 120.2a45.8 45.8 0 00-6.9 13.3l-8.1-6.9-24.6-20.8c3.3-21.1 8.1-40.2 14.2-56.3zm37.1 120.7a63.7 63.7 0 01-1.1 12c-1.7 8.7-5.3 14.6-9.3 14.6-2.7 0-5.1-2.5-6.9-6.7a5.8 5.8 0 01-.5-1.4 49.4 49.4 0 01-2.9-16.2v-2.2c0-14.6 4.7-26.5 10.4-26.5 5.6-.1 10.3 11.8 10.3 26.4zm-35.2 125.7l-.6-1.5-2.2-5.8c-8.1-22.3-13.8-50-16.5-80.8a457 457 0 01-.9-63.2l30 24.1 1.3 1.1v.4a127.6 127.6 0 001.8 22.1 67.6 67.6 0 002.1 9.6l-14.9 92.4zm45.8 47.5a28.2 28.2 0 01-8.6-1.4 51 51 0 01-24.5-21.4l5-28.7 11.6-66.9a10 10 0 003.8.8 8.4 8.4 0 003.5-.7 15 15 0 006-4.9l32.4 59.5 13.1 24.1c-11.5 24.8-26.2 39.6-42.3 39.6zm54.2-72.5l-1.8 6.2-2.4-4.4-42.8-79.5a124.1 124.1 0 001.9-21v-4.6l54.8-46a421.3 421.3 0 012.7 48.6c0 37.5-4.6 72.3-12.4 100.7z"
							data-name="Pfad 35"
							opacity=".8"
						/>
						<path
							fill="currentColor"
							d="M1723.1 293.1a63.7 63.7 0 01-1.1 12c-1.7 8.7-5.3 14.6-9.3 14.6-2.7 0-5.1-2.5-6.9-6.7a5.8 5.8 0 01-.5-1.4 49.4 49.4 0 01-2.9-16.2v-2.2c0-14.6 4.7-26.5 10.4-26.5 5.6-.1 10.3 11.8 10.3 26.4z"
							data-name="Pfad 36"
						/>
						<path
							fill="currentColor"
							d="M1703 324.8l-14.9 92.4-.8.1-2.2-5.8c-8.1-22.3-13.8-50-16.5-80.8a457 457 0 01-.9-63.2l30 24.1 1.3 1.1v.4a127.6 127.6 0 001.8 22.1 173 173 0 002.2 9.6z"
							data-name="Pfad 37"
						/>
						<path
							fill="currentColor"
							d="M1776.1 426.8c-11.5 24.7-26.3 39.5-42.4 39.5a28.2 28.2 0 01-8.6-1.4 51 51 0 01-24.5-21.4l5-28.7 11.6-66.9a10 10 0 003.8.8 8.4 8.4 0 003.5-.7 15 15 0 006-4.9l32.4 59.5z"
							data-name="Pfad 38"
						/>
						<path
							fill="currentColor"
							d="M1792.4 211.3l-54.9 45.5a49.2 49.2 0 00-6.4-13l10.5-122.6c22 6.8 40.8 41.5 50.8 90.1z"
							data-name="Pfad 39"
						/>
						<path
							fill="currentColor"
							d="M1721.6 122.8L1711.4 243a45.8 45.8 0 00-6.9 13.3l-8.1-6.9-24.6-20.8a289 289 0 0114.1-56.3c9.4-25.1 21.8-42.9 35.7-49.5z"
							data-name="Pfad 40"
						/>
						<path fill="currentColor" d="M1025.8 451.2l-.8 2.5.4-2.4.4-.1z" data-name="Pfad 41" />
						<g data-name="Gruppe 6">
							<g fill="currentColor" data-name="Gruppe 5">
								<path
									d="M1614.9-530l.1.2.2.1zm-15.2-44.1l-.5-.4a2.2 2.2 0 01.5.4zm63.1 60.6a2.7 2.7 0 01.7.8 5 5 0 00-.7-.8zM1229.9-726z"
									data-name="Pfad 42"
								/>
								<path
									d="M1395.2 330.9a177 177 0 01-6.4 37.5 63.6 63.6 0 01-1.9 6.2c-6.8 20.5-16.9 36-29.9 45.8a37.1 37.1 0 01-3.2 2.3 58.7 58.7 0 01-16.8 7.9l-.8-2.7a46.3 46.3 0 009.2-3.6 49 49 0 005-2.8c18-11.3 28.1-31.3 33.5-47.7l1.5-4.7a184 184 0 006.7-37.5c-4.4-3.3-29.8-23.6-29.4-51a49 49 0 01.9-8.4c16.5-78.4 25.4-185 26.8-318.5q.7-70.5-1.4-151.3c-.9-35.8-2.3-73.2-4.1-112l-61.7-55.4a1 1 0 01-.4-.7v-.1l-5.4-22.2-45.4-186.2-31.5-128.9-5.2-21.4 2.8-.7 5.4 22.1 31.4 128.6 45.4 185.9 5.3 21.7.5.4 61.3 55.1a1.6 1.6 0 01.5 1q2.7 58.3 4.1 112.4 2.1 80.8 1.4 151.6c-1.4 133.6-10.4 240.4-26.9 319a37 37 0 00-.8 7.3c-.8 28.7 28.5 49.5 28.8 49.8a1.7 1.7 0 01.7 1.2z"
									data-name="Pfad 43"
									opacity=".8"
								/>
								<path
									d="M1061.3-403.2a147.8 147.8 0 01-16.5 27.7 178 178 0 01-37.2 38.1c-1.3.9-2.6 1.9-4 2.7l-4.7 2.9-5.8 3.2a15 15 0 01-2.2 1.1 54.1 54.1 0 01-8.6 3.9l-3.7 1.5-3.5 1.3c-7 2.6-14.7 5-23.4 7.3l-10 2.5-10.8 2.5-8.1 1.7-10.6 2.1-4 .7-6.4 1-3.2.4q-4.5.6-8.4.9c-23.5 2-32.5-2.8-32.5-12.5a14.8 14.8 0 01.1-2.1 4.3 4.3 0 01.2-1.1l.3-1.3c2.4-10.6 12.2-25.3 24.7-42.6l.1-.1a123 123 0 0130.9-22.1c45.4-20.2 144.1-42 147.3-19.7z"
									data-name="Pfad 44"
									opacity=".6"
								/>
								<path
									d="M1644.9-433.4a8.3 8.3 0 01-1.5.4 8.5 8.5 0 01-1.7.4l-6.4 1.7-1.5.4-2.5.6-3.3.8-3.7.9a14.2 14.2 0 01-2.2.5l-4.3 1.1-9.6 2.2-3.4.8-6 1.4-6.3 1.5-6.5 1.5-8.3 1.9-4.3 1-16 3.5-4.9 1.1-22.9 4.9-10.5 2.2-4.2.9-7 1.5-5.7 1.2-11.7 2.4-18.2 3.7-11.1 2.3-13 2.6-6.7 1.3-14.5 2.9-12.9 2.5-7.6 1.5-14.1 2.7-14.3 2.8-7.3 1.4-11.2 2.1-11 2.1-7.9 1.5-14.8 2.7-.5-.4-5.3-21.7-45.1-185.8 6-.2c145.9-3.7 262 22.7 330.6 43.7l25.9 75.8z"
									data-name="Pfad 45"
								/>
							</g>
						</g>
						<path fill="currentColor" d="M1233.8-726h-3.8 3.8z" data-name="Pfad 46" />
						<path
							fill="currentColor"
							d="M1238.6-726h-2.7a12.2 12.2 0 012.7 0z"
							data-name="Pfad 47"
						/>
						<path
							fill="currentColor"
							d="M1289.8-721.4l-7.9-1.2 3.5.5a6.9 6.9 0 011.3.2l3.1.5z"
							data-name="Pfad 48"
						/>
						<path fill="currentColor" d="M1599.8-574.1l-.5-.5.5.5z" data-name="Pfad 49" />
						<path
							fill="currentColor"
							d="M1615.2-529.7a.3.3 0 01-.2-.1l-.1-.2z"
							data-name="Pfad 50"
						/>
						<path
							fill="currentColor"
							d="M1663.6-512.7a5 5 0 00-.7-.8 5 5 0 00.7.8z"
							data-name="Pfad 51"
						/>
						<path
							fill="currentColor"
							d="M1235.9-726.1zm50.9 4.2a6.9 6.9 0 01-1.3-.2l-3.5-.5 7.9 1.2-3.1-.5zm376 208.4a2.7 2.7 0 01.7.8 5 5 0 00-.7-.8z"
							data-name="Pfad 52"
						/>
						<path
							fill="currentColor"
							d="M1680.1-493.8l-1.7 7.2-1.2 5.1-.3 1.2a24.6 24.6 0 01-.7 2.9l-.2.8-1.2 5-.4 1.6-.3 1.3-.6 2.2-.8 2.9-1.2 3.9a55 55 0 01-2.9 7.6l-.8 1.7a25.4 25.4 0 01-1.6 2.8l-.2.3a12.7 12.7 0 01-1.3 1.9.1.1 0 01-.1.1l-.6.7a2.7 2.7 0 01-.7.8 5.7 5.7 0 01-.7.8 18 18 0 01-2 1.9.3.3 0 01-.2.1l-1.1.9-1.9 1.3-2.5 1.4-1.7.8-2.3 1a25.5 25.5 0 01-3.3 1.1l-.3-.3-7.3-21.3-25.3-73.9.2.1-.3-.3-15-44.1 8 6.8.6.6 3.8 3.3c6.7 5.9 13.4 12.1 20 18.3l9.1 8.9 9 9.1 1.7 1.8 7.9 8.4a35.8 35.8 0 012.6 2.9l.4.4a2.7 2.7 0 01.7.8l6.2 6.9 10.5 12.3z"
							data-name="Pfad 53"
						/>
						<path
							fill="currentColor"
							d="M1611.6-530.8a1045.6 1045.6 0 00-330.6-43.7l-6 .2-31.4-128.6c56.5 1.6 127.8 21.1 197.1 54A672.5 672.5 0 011610.5-534z"
							data-name="Pfad 54"
							opacity=".4"
						/>
						<path
							fill="currentColor"
							d="M1272.1-574.3c-206.5 8.5-368 130.4-449.1 206.2a1038.2 1038.2 0 0169.7-111.8c43-59.6 89.3-108.3 137.4-144.7 59.1-44.7 121.3-70.8 184.8-77.6a197.2 197.2 0 0121-1h4.7z"
							data-name="Pfad 55"
							opacity=".4"
						/>
						<g fill="currentColor" data-name="Gruppe 7">
							<path d="M1599.8-574.1l-.5-.5.5.5z" data-name="Pfad 56" />
							<path
								d="M1719.5-37.9a231.5 231.5 0 01-1.3 25.3l-1.7.5h-.1l-1.1-.2a241.8 241.8 0 001.4-25.8q.2-5.4 0-11.7c-.2-13.3-1-30.2-3.2-50.4-.9-8-3.3-17-5.8-26.5-3.3-12.5-6.9-25.9-8.3-40.8a136.5 136.5 0 01.5-30.5c.4-3.3.8-7.2 1.1-11.7 3.1-48.7-2.8-159.4-3.3-168l-52.4-55.3-.3-.5v-.1l-7.4-21.6-25.9-75.8-1.2-3.3-13.7-40.2 1.9-.7.6.5.5.5 15 44.1.1.2 25.3 73.9 7.3 21.3.3.3 52.3 55.1a1.8 1.8 0 01.4.9c0 1.3 6.5 118.5 3.2 169.1-.3 4.4-.6 8.3-1.1 11.7a128.5 128.5 0 00-.5 29.6 244 244 0 008.2 40.7c2.5 9.6 5 18.7 5.8 26.9a604.7 604.7 0 013.4 62.5z"
								data-name="Pfad 57"
								opacity=".8"
							/>
							<path
								d="M1718.1-12.5a3.8 3.8 0 01-.1.8l-1.6-.2a5.8 5.8 0 011.7-.6z"
								data-name="Pfad 58"
							/>
							<path
								d="M758.7-284c-103.1 25.4-311.4 89.2-352.5 101.9a28.2 28.2 0 00-7.5.8l-.4-1.3c1.9-.6 152.6-47.1 272.4-80.8-.8-4.1-5.2-20.7-26-40l.9-1 .1-.1.8-.9c21.2 19.6 25.9 36.3 26.9 41.3 31.6-8.8 60.8-16.7 84.6-22.6l.4 1.4z"
								data-name="Pfad 59"
								opacity=".8"
							/>
							<path
								d="M-59.3 5.8c-3.3.1-312.7 14.5-450 14.5l-22.3-.1C-653.9 18.3-822.8 1.9-824.5 1.7l.1-1.4a29.3 29.3 0 0013.5-.2c42.4 3.9 177.1 15.6 279.3 17.1 111 1.7 407-11.3 463-13.9h.4a25.4 25.4 0 008.9 1z"
								data-name="Pfad 60"
								opacity=".8"
							/>
							<path
								d="M697.6 40.8l-2.1 2L667 13.1l-.2-.2c-.3-.2-36.9-30.4-98.8-60.3-23-11.1-52.1-18-80.8-22.4h-.1a699.4 699.4 0 00-114.6-7l-.1-2.9c.9 0 70.3-2.2 134.5 10.4h.1A262.6 262.6 0 01569.1-50c61.1 29.5 97.6 59.2 99.5 60.7l.1.1z"
								data-name="Pfad 61"
								opacity=".8"
							/>
						</g>
						<path
							fill="currentColor"
							d="M1061.3-402.2c.1 15.4-4.4 38-14.1 59a125.6 125.6 0 01-6.9 13.1l-1.5 2.5-2.5 3.7-2.1 3-2.2 2.9a73.8 73.8 0 01-40.4 27.9 979 979 0 01-114.8 19.2c-2.2 2-4.8 4.1-7.6 6.2a19.5 19.5 0 00-2.3 1.7 65.2 65.2 0 01-23.8 12.1 41.8 41.8 0 01-31.6-8.7 33 33 0 01-3.4-3c-10.3-10.3 5.4-23 14.6-29.1 2.4-.2 7-5.1 7-5.1 4.3-6.2 9.2-13.1 14.6-20.2a360.5 360.5 0 0138.6-44.2c-12.5 17.3-22.3 32.1-24.7 42.6l-.3 1.3-.2 1.1a16.2 16.2 0 00-.1 2.1c0 9.6 9 14.4 32.5 12.5q3.9-.3 8.4-.9l3.2-.4a167.8 167.8 0 0010.4-1.7l10.6-2.1 8.1-1.7 10.8-2.5 10-2.5c8.7-2.3 16.4-4.7 23.4-7.3a36.2 36.2 0 003.5-1.3l3.7-1.5a83.4 83.4 0 008.6-3.9l2.2-1.1 5.8-3.2 4.7-2.9 4-2.7a178 178 0 0037.2-38.1 150.4 150.4 0 0016.5-27.6 2 2 0 01.1.8z"
							data-name="Pfad 62"
							opacity=".8"
						/>
						<path
							fill="currentColor"
							d="M1238.2-725.2l-2.8.7 5.2 21.4h-4.7a197.2 197.2 0 00-21 1c-63.5 6.8-125.7 32.9-184.8 77.6-48.2 36.4-94.4 85.1-137.4 144.7A998.2 998.2 0 00823-368c81.1-75.8 242.6-197.7 449.1-206.2l45.4 186.2 5.4 22.2-27.6 5-34.1 6.1-16.6 2.9-35.9 6.2-32.1 5.4-28.3 4.6-30.8 4.9-31.2 4.8-54.1 8a31.5 31.5 0 002.2-2.9l2.1-3 2.5-3.7 1.5-2.5a149.3 149.3 0 0021-72.1 3 3 0 00-.1-1c-3.1-22.3-101.9-.5-147.2 19.7-10 4.5-20.6 12.5-30.9 22.3a.1.1 0 00-.1.1 361.6 361.6 0 00-38.6 44.2c-5.3 7.1-10.2 14-14.6 20.2 0 0-4.6 4.9-7 5.1l-3.9.4-20.3 2.1-21.1 2.1-19.2 1.7 3.1-7.8 1.7-4 4.4-10.2 2.1-4.7 1.2-2.5v-.1l6.6-14.2.1-.2a363.2 363.2 0 016.4-13.2l1.7-3.5a844.2 844.2 0 019.6-18.7l6.2-11.7 3.2-6 6.2-11.3 2.5-4.4c4.2-7.3 8.5-14.9 13.1-22.6l8.6-14.1 5.9-9.5 3.1-4.8 3.1-4.8 3.2-4.9 9.9-14.7 6.8-9.9c2.3-3.3 4.6-6.6 7.1-9.9l7.3-10L890-514l4.6-6 5.3-6.7a1.8 1.8 0 00.5-.7 831.8 831.8 0 0133.6-39.3l4.4-4.8 6.7-7.1 4.6-4.8 6.9-7 4.7-4.6 4.7-4.6 4.8-4.5a463.8 463.8 0 0124.7-21.9l5.1-4.2a237 237 0 015.2-4.2l7.2-5.7 8.6-6.4 9.3-6.7 1.6-1.1 5.4-3.7 11.1-7.3.4-.3 5.2-3.3a431.8 431.8 0 0117.2-10.1l5.8-3.2a331 331 0 0111.8-6.1l6-2.9 9.3-4.2 8.5-3.7.9-.4 5.8-2.3 6.3-2.4 6.3-2.3 6.4-2.2 6.4-2.1 6.5-2 6.5-1.8c4.4-1.2 8.7-2.3 13.2-3.3l1.5-.3 3.7-.8c5-1.1 9.9-2 14.9-2.9l5.6-.9 7.5-1.1 7.5-.9a206.6 206.6 0 0116.2-1.1h12.5l11 .4 5.5.4h.3a2 2 0 01.8.1l9.8.9a7 7 0 011.4.1h.2l5.4.6 3 .4 2 .2a4.3 4.3 0 011.1.2l7.9 1.2 1.7.3a25 25 0 012.9.5l4.6.8a12.9 12.9 0 011.9.4l5.6 1.1c4.9.9 9.8 2 14.7 3.1a1.9 1.9 0 01.8.2l4.1.9 4.6 1.1a4.3 4.3 0 01.5.1h.1l9.6 2.5 7 1.9 7.4 2.1 6.7 2.1 14.3 4.6 15 5.2 6.8 2.5a385 385 0 0115.6 6.1l6.7 2.8 7.3 3.1 7.5 3.3q7.5 3.3 15 6.9l7.5 3.6 10 5a345 345 0 0110.3 5.4c4 2.1 8 4.2 12 6.5a978.2 978.2 0 0135.7 21.2l5.6 3.6a6.4 6.4 0 001.4.8l6.4 4.2 9.1 6.2 5 3.5 9.7 7 .2.1 11.3 8.4.8.6a975.3 975.3 0 0123.2 18.5l-1.9.7 13.7 40.2a672.5 672.5 0 00-169.8-114.9c-69.3-32.9-140.6-52.4-197.1-54z"
							data-name="Pfad 63"
						/>
						<path
							fill="currentColor"
							d="M427.7-138.8a286.7 286.7 0 01-64.3 65.9 261.8 261.8 0 01-109.5 46.8c-87.8 16-208 24.9-295.7 29.6l-17.5.9a25.6 25.6 0 01-8.9-1h-.4c-22.2-6.1-28.1-38.7-4.8-50.8a552 552 0 0161.9-27.3 581.8 581.8 0 0159.7-18.7c96-24.9 261.5-65.9 350.4-87.8a28.2 28.2 0 017.5-.8 27.4 27.4 0 0121.6 43.2z"
							data-name="Pfad 64"
							opacity=".2"
						/>
						<path
							fill="currentColor"
							d="M-788.1-31.3A30 30 0 01-810.9.2a29.2 29.2 0 01-13.5.2c-24.1-5.3-49.4-16.7-46.3-41.1a41.1 41.1 0 011.2-5.9c10.2-39.7 70.7-81.9 82.5-89.8l1.9-1.2s-7.3 51.7-3 106.3z"
							data-name="Pfad 65"
							opacity=".2"
						/>
						<g data-name="Gruppe 8">
							<path
								fill="currentColor"
								d="M603.2 314.2a1446 1446 0 00-5.3 33.2 2.8 2.8 0 01.1-.9c1.3-10.7 3.1-21.5 5.2-32.3z"
								data-name="Pfad 66"
							/>
						</g>
						<path
							fill="currentColor"
							d="M603.2 314.2a1446 1446 0 00-5.3 33.2 2.8 2.8 0 01.1-.9c1.3-10.7 3.1-21.5 5.2-32.3z"
							data-name="Pfad 67"
						/>
						<path
							fill="currentColor"
							d="M879.3 601.4c-26 33-59.4 52.9-95.8 52.9h-2.3a94.3 94.3 0 01-18.4-2.1c-18.9-4-36.6-13.3-52.6-27l11.3-30.8 35.4-96.6a31.3 31.3 0 008.6 1.2h1.2a30.6 30.6 0 0010.4-2.1 39.7 39.7 0 009.9-5.3l4.8 5.8 40.4 48.2 20.2 24.1z"
							data-name="Pfad 68"
						/>
						<path
							fill="currentColor"
							d="M950.1 416.7C947.1 280.2 872 171 779.8 171l-4.3.1-4 .2c-66.9 4.8-123.7 67.2-148.6 154.7a363.2 363.2 0 00-13.5 99.3 368.2 368.2 0 0013.5 99.4 289.2 289.2 0 0033.7 76.4c27.2 42.5 64.1 70.9 105.4 77.3a116.6 116.6 0 0017.8 1.3c69.3 0 128.9-61.7 155.6-150.4 1.9-6.3 3.6-12.7 5.1-19.3l2-9.1a337 337 0 003.2-17.5 362 362 0 004.4-50.6l.1-7.5-.1-8.6zm-149-200.8l1.5-17.7c49.1 9.5 90.9 55.4 113.3 119.5L845.5 355l-42.4 22.5a57 57 0 00-14.2-17zm-21.3 209.4a51.1 51.1 0 01-2.1 14.4c-2 6.8-5.5 12.5-9.8 16.1a17.7 17.7 0 01-11.6 4.6c-8 0-15.1-6-19.4-15.2a44.5 44.5 0 01-3.6-13.1 50.7 50.7 0 01-.4-6.8c0-19.4 10.5-35 23.5-35 4.9 0 9.4 2.2 13.2 6a41.5 41.5 0 0110.2 29zm-22.1-225.6l-13 158.9a55.9 55.9 0 00-16 17.9l-84.3-37.3c19.2-72.1 61.8-125.9 113.3-139.5zm-76.3 393.4A266.4 266.4 0 01640 492.2a294.8 294.8 0 01-4.9-33.4 334.2 334.2 0 01-1.6-33.5c0-11.8.6-23.4 1.7-34.8l81.1 34.3v.4a106.7 106.7 0 002.3 22.3 84.3 84.3 0 005.8 18l.6 1.3-9.6 27.8zm102.1 61.2h-2.3a94.3 94.3 0 01-18.4-2.1c-18.9-4-36.6-13.3-52.6-27l11.3-30.8 35.4-96.6a31.3 31.3 0 008.6 1.2h1.2a30.6 30.6 0 0010.4-2.1 39.7 39.7 0 009.9-5.3l4.8 5.8 40.4 48.2 20.2 24.1 26.7 31.9c-25.8 32.8-59.2 52.7-95.6 52.7zm149.8-219a343.4 343.4 0 01-8.4 66.4 295.2 295.2 0 01-14.4 45.5c-2.7 6.5-5.6 12.8-8.7 18.8l-8.7-10.5-46.6-56.4-2.9-3.6-33.1-40a21.7 21.7 0 00.7-2.4 97.1 97.1 0 003.2-18.3c.3-3.1.4-6.3.4-9.5V422l34.7-18.6 78-41.8a332.1 332.1 0 015.8 57.3v6.4c.2 3.3.1 6.7 0 10z"
							data-name="Pfad 69"
							opacity=".8"
						/>
						<path
							fill="currentColor"
							d="M779.8 425.3a51.1 51.1 0 01-2.1 14.4c-2 6.8-5.5 12.5-9.8 16.1a17.7 17.7 0 01-11.6 4.6c-8 0-15.1-6-19.4-15.2a44.5 44.5 0 01-3.6-13.1 50.7 50.7 0 01-.4-6.8c0-19.4 10.5-35 23.5-35 4.9 0 9.4 2.2 13.2 6a41.5 41.5 0 0110.2 29z"
							data-name="Pfad 70"
						/>
						<path
							fill="currentColor"
							d="M933.5 425.3l-.1 10a343.4 343.4 0 01-8.4 66.4 295.2 295.2 0 01-14.4 45.5c-2.7 6.5-5.6 12.8-8.7 18.8l-8.7-10.5-46.6-56.4-2.9-3.6-33.1-40a21.7 21.7 0 00.7-2.4 97.1 97.1 0 003.2-18.3c.3-3.1.4-6.3.4-9.5V422l34.7-18.6 78-41.8a332.1 332.1 0 015.8 57.3l.1 6.4z"
							data-name="Pfad 71"
						/>
						<path
							fill="currentColor"
							d="M915.9 317.6L845.5 355l-42.4 22.5a57 57 0 00-14.2-17L801 215.9l1.5-17.7c49.2 9.5 91 55.3 113.4 119.4z"
							data-name="Pfad 72"
						/>
						<path
							fill="currentColor"
							d="M757.7 199.7l-13 158.9a55.9 55.9 0 00-16 17.9l-84.3-37.3c19.2-72.1 61.8-125.9 113.3-139.5z"
							data-name="Pfad 73"
						/>
						<path
							fill="currentColor"
							d="M724.9 466.9l-9.6 27.8-34 98.4a266.4 266.4 0 01-41.4-100.9 294.8 294.8 0 01-4.9-33.4 334.2 334.2 0 01-1.6-33.5c0-11.8.6-23.4 1.7-34.8l81.1 34.3v.4a106.7 106.7 0 002.3 22.3 84.3 84.3 0 005.8 18 9.7 9.7 0 00.6 1.4z"
							data-name="Pfad 74"
						/>
						<path
							fill="currentColor"
							d="M1034.1 420.7l-.2 2.1a152.6 152.6 0 01-5 27.6 114.3 114.3 0 01-6.1 16.6 77 77 0 01-12.9 19.7 11 11 0 01-1.5 1.6 59.6 59.6 0 01-11.6 9.4h-.1l-6.3 1.3.2-1.1a58.1 58.1 0 0012.7-8.7 16.6 16.6 0 001.4-1.3 81.3 81.3 0 0020.4-34.5l.8-2.5a147.2 147.2 0 005.2-28.6l.2-2.1.4-5.9v-.3a150.4 150.4 0 00-.2-17.4 238.5 238.5 0 01-20-62 1508 1508 0 01-7.2-53c-3.7-28.5-8.3-64.8-14.2-105.8-1.7-11.4-3.3-23.1-5.2-35.1a5 5 0 01-.2-1.3c-4.6-30-9.8-61.9-15.7-94.5v-.5a2998 2998 0 00-21-102.2 1382.3 1382.3 0 00-49.2-172.6L879.7-250 867-263a19.5 19.5 0 002.3-1.7l13.7 14 18 18.4a.8.8 0 01.3.5 1362 1362 0 0145.9 157.9l3.7 16.1a3096.9 3096.9 0 0146.8 269.4v.3c3.6 26.3 6.6 50 9.2 69.7 3.2 24.9 5.5 42.8 7.2 52.9a232.3 232.3 0 0019.8 61.4l.2.5.1 1.5v.1a151.5 151.5 0 01-.1 22.7z"
							data-name="Pfad 75"
							opacity=".8"
						/>
					</g>
					<path fill="#fff" d="M-342.8 382.9l-389.9-12 20.3-95.7 386.6 8.2z" data-name="Pfad 76" />
					<path
						fill="currentColor"
						d="M-342.8 382.9l-389.9-12 20.3-95.7 386.6 8.2z"
						data-name="Pfad 77"
						opacity=".2"
					/>
				</g>
				<g clipPath="url(#a)" transform="translate(0 -.1)">
					<g data-name="Gruppe 15">
						<g data-name="Gruppe 14" opacity=".4">
							<g data-name="Gruppe 13">
								<g data-name="Gruppe 12">
									<g fill="currentColor" data-name="Gruppe 11">
										<path d="M395 280.2c.4.1-.2-2.1-.2-2.5-.6.7.3 3.1.2 2.5z" data-name="Pfad 78" />
										<path d="M389.7 286.7v-.9l-.5 2.4z" data-name="Pfad 79" />
										<path
											d="M383.8 288c1.4 3.7 2-1.1 3.4 0l.4.8-.2-3.2c-1.3.9-2.5 3.3-3.6 2.4z"
											data-name="Pfad 80"
										/>
										<path
											d="M378.8 280.5c.5 1.4-.4 1.4.8.3l-.2-.3a1.1 1.1 0 01-.6 0z"
											data-name="Pfad 81"
										/>
										<path d="M379.4 280.5c.6-.3-.7-1.2 0 0z" data-name="Pfad 82" />
										<path
											d="M376.7 281.9l.5-1.5c-.4-.8-1.1-.9-1-1.6-.7 1-.3 1.8.5 3.1z"
											data-name="Pfad 83"
										/>
										<path d="M376.5 284.9l.3-.6c-.2-.4-.3-.5-.3.6z" data-name="Pfad 84" />
										<path
											d="M377.5 282.9l-.7 1.4c.3.6.5 1.8.3-.5.2 1 .1-.1.4-.9z"
											data-name="Pfad 85"
										/>
										<path
											d="M378.1 283.3c.6.7 1.4 1.1.8 2.6 1.5-.8.7-3.5-.8-2.6z"
											data-name="Pfad 86"
										/>
										<path d="M384.3 292l.9 1 .3-1.4c-.2.7-1.5-.8-1.2.4z" data-name="Pfad 87" />
										<path
											d="M371.1 281.1a27.4 27.4 0 001 3.1l.4-1.1c-.4-.5-1.1-.8-1.4-2z"
											data-name="Pfad 88"
										/>
										<path d="M372.1 284.2l-.6 1.6c.9 0 .9-.7.6-1.6z" data-name="Pfad 89" />
										<path d="M377.3 289.1l.8-3.2-1.1 3.3z" data-name="Pfad 90" />
										<path d="M367.6 281.7l.1-2-.3 3.1z" data-name="Pfad 91" />
										<path
											d="M365.3 282.5c.1-1.6-1.1-2.5-.9-3.5-.6.4-.8 1.9-1.1 3.2.5-.8 1.1-.8 2 .3z"
											data-name="Pfad 92"
										/>
										<path
											d="M363 284.1a6.9 6.9 0 00.4-1.9 3.8 3.8 0 00-.4 1.9z"
											data-name="Pfad 93"
										/>
										<path d="M369.9 285.7a5 5 0 00-1.2-2.1l.8 2.2.4-.1z" data-name="Pfad 94" />
										<path d="M369.9 285.7c0 .2.1.3 0 0z" data-name="Pfad 96" />
										<path
											d="M374.4 287.6c-.3 1.4-1.1 3 .4 4.7.1-1.7-.8-2.6-.4-4.7z"
											data-name="Pfad 97"
										/>
										<path d="M371 288.4l1.1.3a7.1 7.1 0 01-.4-2.1z" data-name="Pfad 98" />
										<path d="M370.7 289.3l.3-.9-.4-.1z" data-name="Pfad 99" />
										<path
											d="M365.1 285.8a1.7 1.7 0 01-1.1 1.5 3.1 3.1 0 001.8.3c-.1-.6-.2-2-.7-1.8z"
											data-name="Pfad 100"
										/>
										<path d="M367.3 286l-.1.1c.1.3.2.3.1-.1z" data-name="Pfad 101" />
										<path d="M358.8 288.4l.2.4a.6.6 0 00-.1-.4z" data-name="Pfad 102" />
										<path
											d="M365.9 288.1c.5.3.6-.3.7-1a2.4 2.4 0 01-.9.6c.1.3.1.5.2.4z"
											data-name="Pfad 103"
										/>
										<path
											d="M361.7 285.4a5.2 5.2 0 001 1.1c-.3-.7-1-1.7-1-1.1z"
											data-name="Pfad 104"
										/>
										<path d="M366.9 285.6v-.1c-.2-.5-.1-.3 0 .1z" data-name="Pfad 105" />
										<path
											d="M366.9 285.6l-.3 1.5a2 2 0 00.5-.9 1.4 1.4 0 00-.2-.6z"
											data-name="Pfad 106"
										/>
										<path
											d="M360.2 303.3c-.4-2.1.3-4.3 1.8-2.2.6-1.8-1.4-8.6-3.1-12.3a4.3 4.3 0 01-.4 3.2c.6 1.1 2.7 2.3 2.3 4.3-1.1 1.3-1.2-.5-2.1-1.5 1.1 2.5-.8 4.2.2 8l.8-1.6c.3.6.1 1.6.5 2.1z"
											data-name="Pfad 107"
										/>
										<path
											d="M360.8 288.6l.3-.3a8.3 8.3 0 01-2-2.6 5.5 5.5 0 00-.3 2.7l2-.1z"
											data-name="Pfad 108"
										/>
										<path
											d="M363 287.9c.2 2.4-.6 3.5.5 5.9 1.1-.4.4-2.1.9-3.2-1.8 1 .3-1.4-1.4-2.4a1.6 1.6 0 01.9-.8 8.3 8.3 0 01-1.2-.8l.1.1.1.3v.1a2.5 2.5 0 00.1.8c-.6-.4-.2-.6-.1-.9v-.3l-1.6 1.6c.4.2.8.1 1.7-.4z"
											data-name="Pfad 109"
										/>
										<path d="M374.9 297.4l-.2-.5c-.1.3-.1.5.2.5z" data-name="Pfad 110" />
										<path
											d="M373.8 296.2c.1-.3 0-1.3.5-1.1.5.6.2 1.1.4 1.8.1-.7.6-1.8-.5-2.8l-.1.3a9.3 9.3 0 01-2.4-3.6 27.4 27.4 0 002.1 5.4z"
											data-name="Pfad 111"
										/>
										<path
											d="M368.4 292.7l-1.3 1.5 1.2 1.8-.3-1.2c1 .2.5-1.2.4-2.1z"
											data-name="Pfad 112"
										/>
										<path d="M358.4 287.3l-.3-2.5-.2 3.6z" data-name="Pfad 113" />
										<path d="M356.4 288l-.4-2.1-.2 1.4z" data-name="Pfad 114" />
										<path d="M244.7 334.7l-.4.7a5.7 5.7 0 00.4-.7z" data-name="Pfad 115" />
										<path d="M248.2 334.3l-.1-1.1c-.1.6-.1 1.1.1 1.1z" data-name="Pfad 116" />
										<path
											d="M306.3 297.9c-1-1.9-2.3-4.8-1.8-2.4l.6 2.3c.4-.6.8-.4 1.2.1z"
											data-name="Pfad 117"
										/>
										<path d="M274.1 317.6a4.9 4.9 0 01.3.7l.1-2.3-.4 1.6z" data-name="Pfad 118" />
										<path d="M275.1 327.3L274 326a6.9 6.9 0 001.1 1.3z" data-name="Pfad 119" />
										<path d="M226.4 339.8l-.2 2.5c.9-.2.3-1.3.2-2.5z" data-name="Pfad 120" />
										<path
											d="M335.7 293c-.8-.8-1.3-1.1-1.7-1.1.9 1.2 1.9 3.1 1.7 1.1z"
											data-name="Pfad 121"
										/>
										<path
											d="M242.4 309.7a2.6 2.6 0 00-.2 1.5 2.4 2.4 0 00.2-1.5z"
											data-name="Pfad 122"
										/>
										<path
											d="M332.3 292.3l.4.5c.3-.5.7-.9 1.3-.8-.7-1-1.4-1.5-1.7.3z"
											data-name="Pfad 123"
										/>
										<path d="M158.4 346.3a.8.8 0 01-.2-.3l.2.3z" data-name="Pfad 124" />
										<path d="M136.3 324.7c.2-.2.5-.2.8-.3-.2-.1-.5-.1-.8.3z" data-name="Pfad 125" />
										<path d="M348 288.7c.4-.3 0-.3 0 0z" data-name="Pfad 126" />
										<path
											d="M352 297.4a6.2 6.2 0 00.1 1.2 1.7 1.7 0 01-.1-1.2z"
											data-name="Pfad 127"
										/>
										<path d="M330.7 307.5c.2.4.2.3 0 0z" data-name="Pfad 128" />
										<path d="M348.9 289.6l-.7-.6a1.4 1.4 0 00.7.6z" data-name="Pfad 129" />
										<path d="M348.6 288.5a.8.8 0 00.4.1c0-.3-.1-.6-.4-.1z" data-name="Pfad 130" />
										<path
											d="M347.4 288.9a.9.9 0 01.7.1 1.4 1.4 0 01-.2-.3 4.2 4.2 0 01-.5.2z"
											data-name="Pfad 131"
										/>
										<path d="M194 335.8l-.1-.2c-.4 1-.2.8.1.2z" data-name="Pfad 132" />
										<path d="M299.2 324v-.1l-.1-.1z" data-name="Pfad 133" />
										<path d="M297.9 326c.2-3 .6-2.7 1.2-2.2l-1.7-6.6z" data-name="Pfad 134" />
										<path
											d="M236.7 336.5l1.4 1.9c-.9 3.6-2 2.6-.5 5.4-.9-7.3 4.2-1.4 3.3-8.7l1 1.4c-.2 0-.2.4-.4.4 1.9 3.3.3-5.4 2.3-4.7a2.3 2.3 0 011 2.4l1.2-2c.4.1.5 1.4.1 1.3l2.1-.9v.2a29.5 29.5 0 01.8-3.9c.7 1-.2.8.1 1.7l.9-1.9c.8 1.8.1 3.8-.8 3.7 2.2 7.1.7-2 3.8 1.9l-1 1.1c1.4 4 2 2.4 3.7 4.8-.5-1.3-3.6-6.1-2.5-8.1.5.5 1 .7 1.5-.9.4 2.6 1 1.8 1.8 1.6l.5 3.4c.8-1.1.4-2.9.8-4.5 1.1.2 1.7 2.8 2.3 5 1.8.3-1.8-4.1.1-5 1.6 1.1 2.3-.5 3.7-2.8 1.2 1 .2 2.1.7 3.1l.4-2.9c.2 0 .3.9.3 1.3.6-1.2-.5-3.4.5-4.5-.3-3.8 3.2 5.2 3.9.7.5.9.2 2.1.5 3.4a19 19 0 002.3-6.4l1.7 2c-1.4-2.4-.6-5.7.1-8.4l-1.3-2.7 1.5-2.1a8.4 8.4 0 01.3 3.2l.2-.9c.8 1.2.8 3.2.7 5.2l-1-2a27.8 27.8 0 00.3 6.5 2.3 2.3 0 01.4-1 5.3 5.3 0 00.1 1.4c.1.4.2-.4.3-1.4l1 3.8-.1-1.5 2.7 2c1-4.1 1.5-10 3.9-12-.2 2.9.6 4.6 1.1 7.9-1.3-3.4-1.8 1.8-3.3 1.3.8.3.9 1.9.8 2.4l1.9-3.6c.4 2.7.9 2 1.7 3-1.4-5.3 1.2-3.9 1.9-5.7.4 1.8.4 3.7-.8 3.4 2 3.8.7-6.6 2.5-3.4-.3.1-.5-.2-.5.8.4-1.7 2.3-.7 2.2.9l-.3.1a4.8 4.8 0 005.5-5.6c.1.6.7 5.5.7 6.5l.8-15.9c.4 4 3.2 13.1 1.9 15.6.6.5 1.3 1 2-.5-.4-.5-1.8-5.5-1.4-5.9 1.9 4.2 1.2 2.2 3.3 5.6-.6-.8-1.2-7-.4-6.9 0 .9 1.1 6 1 6.7l.8-6.3c-.3 1.2.8 5.1 1.5 6.7-.4-1.1 1.6-.2 2-.9l-1-1.3c2.3.5.6-8.8 2.7-8.9 0 1.3.7 7.8 1.9 8.3-.1-3.2-.5-15.2.9-17.9l.7 1.7 1-2.3a159.9 159.9 0 01-1.4 19c1 1.3.6 2 1.7 1.7a2.2 2.2 0 01-.5 2.8l3 .6c-.8-3.6 1.5-4 .8-7l-2.3 4.3c-.8-3.6-.1-10.5 1.9-10.2.8 1.3.8 6.5 1.1 7.7 0-1.3 1.4-2.7 1.8-1.8l-.5 2.1c1.3 1.2.9-5.1 2.8-1.9.5.1 2.2 4.4 1.9 2.2-1.5-4-4-16.6-4.1-19.8a32.3 32.3 0 014 5.4c1.3 3.1.3 7.9 1.5 10.5a7.4 7.4 0 01.1-2.7c.6.7.4 3.1 1.3 2.4-.5-3.7 2.1-.1-.1-3.2.8-1.2 1.2.5 2.4.2-.8-2.3-.5-8.2.3-9.4a11.5 11.5 0 00.8 2.6c2.1-.1 3.5 1.4 5.4 1.1.3.8 1.5 1.7 1.4 3.4.2-.7.2-2 .7-2.2 1.7 2.9-1.2.7.4 4.4-.3-2.1 1-3.2 1.5-4.7-.9-3.2-2.1-.2-2.6 1.2-.9-4.5-.3-9.5 1.3-12 1.4-1.4 1.3 2.8 1.4 2.1 3.1.2 1-8.4 4.1-5.6 1.5 2.7 1.2 5.7 1.8 7.7-1.1 1.3-2.3-1.4-3.2-1.1l1.3 1.1c-.2 1-.9 1.9-1.6 1.2 1.3 2.4 5.1-.5 7.9 1.4.2-1 .7-2.2.2-3.3l-.6.5c-1.1-2.2.7-3.5-.4-4.4.6-1.8 1.2-4.6 2.8-3.6l.9 3.2c-.2-.9-1.3-1.8-1.5-.7.3-1.6 3 4 2.7-.4l-1.4-2.1c.6-1.8 1.1-5.6 2.5-4.8-1.2-3.1-.2.4-1.8-3.2 1.7 4.5-3.1.4-.9 5.1-1.8-4.2-1.9-1.5-3.8-5 .3 1.1.8 2-.3 1.7v1a.1.1 0 01-.1-.1l.1.1a5.3 5.3 0 01.8 1.5c0 2.6-1.6 2.8-1.9 4.2-.7-.4 0-1.3-.6-2.4l-.4 2.1c-.6-2.4-2.4-3.7-1.3-5.3l-1.3.1c-1-1.2-2.2-1.5-2.6-.4-.7-.4-1 2.9-.8 1l-1.7 1.9-.1-.6c-2 .1-3.3 4.8-6.4.9-.5.7-1.1 1.6-2.3 1.1l-.6-2c-.7.9-3-1.6-2.9.6-2-5.4-4.4-.4-6.1-1.1l.4 2.7c-1.1 0-1.9 1-3 2.3l.5 2.4c-.7 2.2-3.2-1.2-4.9-.6 0-.9.4-.8.9-.3-3.1-5-3.7 4.7-6.3 1.1-.3 1-.7.7-1.2.2l.1-.1h-.2l-.9-1.2a8.1 8.1 0 00.8 1.2 2.4 2.4 0 00-1.3 1.2l-.7-2.5a.1.1 0 00-.1.1c-.7-.9-.2 1.3.4 3.2a4.3 4.3 0 00-.4 1.7c-1.2-4.1-1.2 1.7-2.6-2.7 0 2.2-2.4 2.1-1.9 6.7-.1-.6-.3-.8 0-.9-.7-.4-1.4-.8-1.7.5l-.8-3.2-.6 4.6a6.7 6.7 0 01-1.3-5.6c-1.3 4.2-1.3 1.7-2.3 5.9l-.3-2.1c-.6.2-1 3.2-1.7 1.5-2-3.8-6.6.6-10.6-2.6 1.7 6.1-2-2.5-1.4 2.3-.4-1.4-1-2.2-.7-3.6-1.5 1.7-3-1.9-3.5 2.4-.4-1.5 0-2.2-.3-3.1-.1.3-.3 1.4-.7.5a2.7 2.7 0 01.2-2c-1.7.5-1.2 5.1-.6 9.4-1.2-1.9-1.6-1.5-1.8 1.4-.5-1.3-1.3-2.7-.3-3.4-.6-.1-4.1-1.4-3.6 2-.3-.8-.9-.1-1 .3-1.4 0-1.6-.3-2.9.3l.5.5c.1 4.2-1 1.1-2 1.8v-.4c-3-2.6-.9 1.6-3.9-1.4l.5 2.6c.6 5.6-2.7-2.9-3.8-.6l.7 1.4c-.5 2-3.4-7.2-4.2-7.8-.2-.5.2-.8.3-1.2-2.6-2.9.2 3.4-1.2 4.4-.6-1.8-.3-4.7-1.4-4.9-.7-1.4-2.1 6.4-4 3.1.5 1.4 1 2.7.5 3.9-1 .7-3.7-4.9-4.1-.3a4.9 4.9 0 01-.4-1.1c-.7 1.3-2.4 2.3-2.6 4.8-2.1-8.8-4.6 5.1-5.8-3.1l-2.5.8-.1-.8c-1.7-.3-2 1.7-2.3 3.8-.5-.5-.3-1.3-.3-1.7-2.6-1.3-2.8-.9-4.3 3.4l-.6-2.6c-.3 1.6-4.1-3.7-6-.3a5.3 5.3 0 01.1-1.2c-2.2 3.5-7.4-6.6-7 3.3l-1.4 2.6c2.4.5.2 4.3 1.4 5.8-.8.7-2.7-2.6-1.7-3.3l.2.5c-.3-5.1-3.1-1.4-3.5-4.9-4.4.9-9.2-1.4-13.4-1.1l1 3.9h-1.5c-.5-.9-.9-3 .2-3-.8-2.2-1.5 2.1-1.4 3-2.2-1.3.2-4.7-.4-4.7l-.8.4.2.4c-.5 1.7-.3 3.4-1.6 3.4-.9-.7-.7-2.4-1-2.5 0-.3-.2-.4-.5-.1l-1.9-.1 1.1 3c-.6 1.6-1.8.1-.5 3.5-1.9-5.3-7.1-1.1-8.1-2.7-.9 2.4-2 2.5-3.4 2.4.4.6 1 4.1-.2 3.8-.4-7.3-2.6-2.9-4.2-8 1.3 3.3-3.3 1.3-1.4 6-1.1-.5-.4-2.7-1.3-4.3-2.1 3.1-5.5-1.2-8.3 0 .1 1 .7 2.4.2 3.8l-2.1-4.6c-.5.5.1 5.5-1.4 2.4.2.8.6 2 .2 2.3-6.3-4-11.5 5.1-18.3-3 1 1.8.5 2-.1 2.1.4.4.2 2.3.4 3.6l-2.8-3.3c-.1 3.6-2.6.5-2.5 4l.7-.7c-.6 4.1 2.4 8.8 2.7 14 .7-4.7 3.8 6.5 5-.3.5 1-.2 1.7.2 2.9.3-2.3.8-2.8 2-1.9l-.1.6c3-.9 4.6 1.2 8.2 2.3l-.5-2.5c.8.3 1 1 1.4 1.6.4-4-2.1 0-1.8-4.4 1.5 5.1 5.2-.5 6.5 5.3 1.1-.1-.7-2.9.5-3l.5 1.6.1-2.1c.8.3 1.4 2.2 1.6 3.6-.2-.1-.5.4-.7.6 1.2 1.8 2.7-.9 3.1-.4l-1.2-.9c2.9-1.8 7-.1 9.6-3.8l-.4-1.2c2-2.5 2 1.1 4.4-.2l-.1.3c.4-1.3 1-1.9 1.7-1.9-.5 1.5 1.5 2.6.9 4.3 2.2-2.7 1-2 2.1-6.7l.6 2c.3-1.9.3-2.8 1.5-3.5-.8 1.8 1.2 3 .3 5.4 3.2 4.1 3.4-4.9 5.4 1.4.5-5.7-2.7-2.8-2.1-4.1-.8-1.7.5-4.3 1.4-3.8.9 0 2.3 6.9 4.4 6.5-.2 0-.2.4-.4.4 1 1.3 1.3-2.1 2.6.1.1-3.4 1.3 0 .9-4.3l-1.8 1.2c1-1.3 1.4-6.4 3.5-4.2a8.2 8.2 0 01-.7 2.8c.7 1.2.9-1 1.6.3.4 4.3-2.2 1.2-3 4.6.8 1.7 1.8-3.4 1.8 1.3.1-6 2.2.5 3.1-4.2l.2 2.6c.2-.4.5-1.7.9-1.7l-.3 3.4c.8-3 2.6 2.2 3.5.5-2.3.4-.9-3-2.1-4.8 2.4-3.8 2.5 6.5 5.6 4.8-.4.4-1.8-1.3-1.3-2.6a5.9 5.9 0 012.2 2.6c2.1-.8-.7-2.6 0-4.3 1.1 3 .9-1.4 1.7-2.5l.3 2.6c2.7 1.3-.1-5.5 2.4-3.8l-.4 3.7 1-1.1.2 3c1-2.4 1.4-1.8 2.7-1.2-.5-1.8-.5-4.7.6-5 .9 1.4-.1 2.5 1.4 2-.1 1.7-.2 3.8-1.2 1.5l-.1 2.5c1 1.7 2 .1 2.6 0a1.5 1.5 0 01-.7-.5l1.7-3.9a3.4 3.4 0 01.1 2.6c.4-.3.6-1.6 1.2-1.9.1 2.1.5 4.3-.3 5.4l1.8-2.6c.3.9 1.4 2.4 1.3 3.2 1.3 1.1 2.3-4.5 4.1-3.1a2 2 0 01.4-1.2c1.5.3 3.2 2.7 4.5-.5l1.5 3.6c1.2-1-2-4.6 0-6.3 1.4-1.4 1.1 3.1 1.8 4.1.5-2 1.3-6.1 3.2-3.2-.4 1.1-.8.6-1.2.9zm16.4-4.1c-.2.6-.6 2.4-1.1.9-.1-3 .4-1.7 1.1-.9zm24.2-10.2c-.1.9-.5.5-1.1-.4.3-.2.6-.2 1.1.4zm66.4-30.5v.1c-.9-.8-.6-.5 0-.1zm1.7.8a2 2 0 00-.1-1.1c0 .7-.3.8-.7.7.2.7.4 1.1.8.4zm-158.3 26.3l.4.6c-.6.9-.5.2-.4-.6z"
											data-name="Pfad 135"
										/>
										<path
											d="M275 326.2a5.7 5.7 0 01-.4-1.4 2.3 2.3 0 00.4 1.4z"
											data-name="Pfad 136"
										/>
										<path d="M226.5 339.4c0-.1-.1-.1 0 0a.4.4 0 000 .5z" data-name="Pfad 137" />
										<path
											d="M326.7 318.7a3.2 3.2 0 01-.8-1.2c.1.7.3 1.2.8 1.2z"
											data-name="Pfad 138"
										/>
										<path
											d="M352.2 286.6l-.8.9c.4-.2.7.3 1 .7-.1-.7-.4-1.5-.2-1.6z"
											data-name="Pfad 139"
										/>
										<path
											d="M363.7 300.8c.1-.3.3-.1.4-.4l-.3-1.2a.9.9 0 00-.1 1.6z"
											data-name="Pfad 140"
										/>
										<path
											d="M354.8 295c.5 2.1 1 1.3 1.5.8h-.1c-.4-3.1-.9-2-1.4-.8z"
											data-name="Pfad 141"
										/>
										<path
											d="M356.5 295.6a1.4 1.4 0 01.6-.2c-.2-1.2-.3-.2-.6.2z"
											data-name="Pfad 142"
										/>
										<path
											d="M346.9 290.7c.4.5-.4-2.8 0-2-.2-2.7-1.4 3.8 0 2z"
											data-name="Pfad 143"
										/>
										<path d="M356.8 302l-.8-2.7.1 2.3z" data-name="Pfad 144" />
										<path
											d="M351.2 301.1l1.2.5a1.6 1.6 0 01.1-1c-.6.1-1.5-.3-1.3.5z"
											data-name="Pfad 145"
										/>
										<path d="M352.5 300.6a.7.7 0 00.8-.6 2.1 2.1 0 00-.8.6z" data-name="Pfad 146" />
										<path d="M355.5 303.1l-.4-.5-.8-.1z" data-name="Pfad 147" />
										<path
											d="M339.8 302.8l-1 1c.1.9.5 1.4.8 1a2.7 2.7 0 00.2-2z"
											data-name="Pfad 148"
										/>
										<path d="M344.7 309.4a6.7 6.7 0 01-.9-1.9l.6 3.3z" data-name="Pfad 149" />
										<path
											d="M341.5 310.9c.1.9-1.2 3 .3 2.5-.1-1 .9-2-.3-2.5z"
											data-name="Pfad 150"
										/>
										<path d="M323.3 310l.2-.1-1-5.4z" data-name="Pfad 151" />
										<path
											d="M310.2 325.8c1.6 1.1-.3-3.4 1.3-2 .1-1.3-1.3-1.1-1.1-2.3-.6 1.5-1.2.8-.2 4.3z"
											data-name="Pfad 152"
										/>
										<path
											d="M310.3 321.5a4.6 4.6 0 00.3-.9 4.7 4.7 0 00-.3.9z"
											data-name="Pfad 153"
										/>
										<path d="M132.7 322.1l-1-1.1.8 1.8z" data-name="Pfad 154" />
										<path d="M131.4 326.4l-.6-3.5-.2 3.2c.2-.2.6-.5.8.3z" data-name="Pfad 155" />
										<path d="M256.6 339.1l-.1-.9c-.3-.9-.5-.9-.9-1z" data-name="Pfad 156" />
										<path d="M244.1 338.2l.2.1-.8-3.1z" data-name="Pfad 157" />
										<path
											d="M234.5 343.7c.4.1.8-.7 1.3-.6-.9.7-2-3.3-1.3.6z"
											data-name="Pfad 158"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
					<g data-name="Gruppe 20">
						<g data-name="Gruppe 19" opacity=".4">
							<g data-name="Gruppe 18">
								<g data-name="Gruppe 17">
									<g fill="currentColor" data-name="Gruppe 16">
										<path
											d="M516 352.5c.6.2.2-2.1.2-2.5-.9.5-.2 3.1-.2 2.5z"
											data-name="Pfad 159"
										/>
										<path d="M507.3 358.3l.1-.9-1.2 2.3z" data-name="Pfad 160" />
										<path
											d="M498.7 358.9c1.1 3.8 3-.9 4.7.4l.3.9.5-3.2c-1.8.6-4.1 2.9-5.5 1.9z"
											data-name="Pfad 161"
										/>
										<path d="M493.6 350.9c.4 1.5-.9 1.4 1.1.4l-.2-.4z" data-name="Pfad 162" />
										<path d="M494.5 350.9c.9-.2-.7-1.2 0 0z" data-name="Pfad 163" />
										<path
											d="M490.4 352l1.1-1.4c-.3-.9-1.4-1-1-1.7-1.2.8-.9 1.7-.1 3.1z"
											data-name="Pfad 164"
										/>
										<path d="M489.5 354.9l.6-.6c-.2-.4-.4-.5-.6.6z" data-name="Pfad 165" />
										<path
											d="M491.3 353l-1.2 1.3c.2.6.3 1.9.6-.5-.1 1.2.1.1.6-.8z"
											data-name="Pfad 166"
										/>
										<path
											d="M492 353.6c.7.8 1.6 1.3.5 2.7 2.3-.7 1.8-3.4-.5-2.7z"
											data-name="Pfad 167"
										/>
										<path d="M498.6 362.9l1 1.1.7-1.4c-.4.7-1.9-.9-1.7.3z" data-name="Pfad 168" />
										<path
											d="M482.9 350.5a23.4 23.4 0 00.7 3.2l.8-1a3.8 3.8 0 01-1.5-2.2z"
											data-name="Pfad 169"
										/>
										<path d="M483.6 353.7l-1.2 1.5c1.2.1 1.3-.6 1.2-1.5z" data-name="Pfad 170" />
										<path d="M489.5 359.2l2-3.1-2.4 3.2z" data-name="Pfad 171" />
										<path d="M477.9 350.7l.7-2-1.2 3z" data-name="Pfad 172" />
										<path
											d="M474.7 351.2c.5-1.6-.9-2.6-.4-3.6-.9.3-1.6 1.7-2.2 3 .7-.7 1.5-.6 2.6.6z"
											data-name="Pfad 173"
										/>
										<path
											d="M471 352.4a20.6 20.6 0 001.1-1.8 5.6 5.6 0 00-1.1 1.8z"
											data-name="Pfad 174"
										/>
										<path d="M480.1 354.9a3.7 3.7 0 00-1.2-2.3l.7 2.3z" data-name="Pfad 175" />
										<path d="M479.6 355a6.6 6.6 0 00-1.1-.1 6 6 0 011.1.1z" data-name="Pfad 176" />
										<path d="M480.3 354.9h-.1c0 .2 0 .3.1 0z" data-name="Pfad 177" />
										<path
											d="M486 357.3c-.7 1.3-2.2 2.8-.5 4.7.4-1.6-.6-2.6.5-4.7z"
											data-name="Pfad 178"
										/>
										<path d="M481.1 357.8l1.4.4a3.3 3.3 0 010-2.2z" data-name="Pfad 179" />
										<path d="M480.5 358.6l.6-.8-.5-.2z" data-name="Pfad 180" />
										<path
											d="M473.5 354.5a2.6 2.6 0 01-1.9 1.4 4.3 4.3 0 002.4.5c.1-.8.4-2.1-.5-1.9z"
											data-name="Pfad 181"
										/>
										<path d="M476.5 354.9a.1.1 0 01-.1.1c.1.3.2.3.1-.1z" data-name="Pfad 182" />
										<path d="M464.3 356.2l.1.4v-.4z" data-name="Pfad 183" />
										<path
											d="M474.2 356.8c.6.4.9-.2 1.2-.9a3.4 3.4 0 01-1.4.5c0 .3 0 .5.2.4z"
											data-name="Pfad 184"
										/>
										<path
											d="M469.1 353.6a4.3 4.3 0 001.1 1.2c-.4-.7-1.1-1.8-1.1-1.2z"
											data-name="Pfad 185"
										/>
										<path d="M476.1 354.4l.1-.1c-.2-.5-.2-.2-.1.1z" data-name="Pfad 186" />
										<path
											d="M476.1 354.4a5.2 5.2 0 00-.7 1.5 2.4 2.4 0 00.9-.8 2.5 2.5 0 00-.2-.7z"
											data-name="Pfad 187"
										/>
										<path
											d="M462.9 371.2c0-2.2 1.5-4.2 3-2 1.3-1.7 0-8.7-1.4-12.6a3.4 3.4 0 01-1.3 3.1c.5 1.1 3.2 2.6 2.1 4.6-1.8 1.2-1.5-.7-2.5-1.8.9 2.6-2.1 4-1.5 7.9l1.5-1.5c.1.8-.4 1.8.1 2.3z"
											data-name="Pfad 188"
										/>
										<path
											d="M467.1 356.7l.6-.3c-.7-.3-1.2-1.2-2.1-2.8a4.5 4.5 0 00-1.1 2.6l2.8.2z"
											data-name="Pfad 189"
										/>
										<path
											d="M470.2 356.3c-.3 2.4-1.6 3.4-.6 5.9 1.7-.2 1.1-2 2-3.1-2.6.7.7-1.3-1.3-2.6a3.7 3.7 0 011.4-.7 7.1 7.1 0 01-1.4-1l.1.1c.1.3.2.5 0 .3l-.1.1a3.8 3.8 0 00-.1 1c-.8-.5-.2-.6.1-.9v-.3l-2.6 1.4a4.6 4.6 0 002.5-.2z"
											data-name="Pfad 190"
										/>
										<path d="M484.3 367.2a1 1 0 01-.1-.5c-.1.2-.2.4.1.5z" data-name="Pfad 191" />
										<path
											d="M483.1 365.8c.2-.3.3-1.3.9-1.1.6.7.1 1.1.1 1.9.3-.6 1.2-1.8 0-2.8l-.2.3c-1.1-.7-2.7-3.6-2.5-3.9a36.2 36.2 0 001.7 5.6z"
											data-name="Pfad 192"
										/>
										<path
											d="M476.6 361.7l-2.2 1.3 1.3 2-.1-1.2c1.2.3.9-1.2 1-2.1z"
											data-name="Pfad 193"
										/>
										<path d="M464 355.1l.2-2.5-1.2 3.5z" data-name="Pfad 194" />
										<path d="M461.1 355.5v-2.2l-.7 1.4z" data-name="Pfad 195" />
										<path d="M297 385.5l-.7.6a4.3 4.3 0 00.7-.6z" data-name="Pfad 196" />
										<path d="M301.8 385.7l.1-1.1c-.2.6-.3 1-.1 1.1z" data-name="Pfad 197" />
										<path
											d="M389.8 358.3c-1-2-2.1-5.1-2-2.7l.3 2.3a1.3 1.3 0 011.7.4z"
											data-name="Pfad 198"
										/>
										<path d="M341 373.1l.3.7.6-2.3-.9 1.6z" data-name="Pfad 199" />
										<path d="M340.4 382.8l-1.3-1.5a3.7 3.7 0 001.3 1.5z" data-name="Pfad 200" />
										<path d="M270.8 387.8l-.8 2.4c1.2 0 .7-1.2.8-2.4z" data-name="Pfad 201" />
										<path
											d="M431.4 357.7a3.8 3.8 0 00-2.1-1.3c1.1 1.3 1.9 3.3 2.1 1.3z"
											data-name="Pfad 202"
										/>
										<path d="M299 360.5a2 2 0 00-.6 1.4 1.8 1.8 0 00.6-1.4z" data-name="Pfad 203" />
										<path
											d="M426.9 356.5l.5.5a2.3 2.3 0 011.9-.6c-.7-1-1.6-1.6-2.4.1z"
											data-name="Pfad 204"
										/>
										<path d="M175.9 384.4l-.2-.3c0 .3.1.3.2.3z" data-name="Pfad 205" />
										<path d="M148.9 360l1.1-.2a1.2 1.2 0 00-1.1.2z" data-name="Pfad 206" />
										<path d="M449.4 355.1c.6-.2.1-.3 0 0z" data-name="Pfad 207" />
										<path
											d="M452.8 364.2a3.3 3.3 0 00-.2 1.2 7 7 0 01.2-1.2z"
											data-name="Pfad 208"
										/>
										<path d="M421.3 371.3c.2.5.1.4 0 0z" data-name="Pfad 209" />
										<path d="M450.4 356.1a2.7 2.7 0 00-.8-.7 2 2 0 00.8.7z" data-name="Pfad 210" />
										<path d="M450.2 355l.5.2c.1-.4 0-.7-.5-.2z" data-name="Pfad 211" />
										<path
											d="M448.5 355.2a1.2 1.2 0 011 .2l-.2-.4c-.1.1-.3.2-.8.2z"
											data-name="Pfad 212"
										/>
										<path d="M226.8 379l-.1-.2c-.6.9-.4.8.1.2z" data-name="Pfad 213" />
										<path d="M374.2 383.1a.1.1 0 01.1-.1l-.1-.1z" data-name="Pfad 214" />
										<path d="M372 384.9c.9-2.9 1.4-2.6 2.2-2l-.9-6.8z" data-name="Pfad 215" />
										<path
											d="M285.5 386.1l1.6 2.1c-1.9 3.5-3.3 2.3-1.8 5.3.3-7.4 6.1-.7 6.4-8.1l1 1.6c-.3-.1-.3.4-.6.3 2 3.5 1.5-5.3 4.1-4.3.9.6 1.5 1.6.9 2.5l2-1.8c.6.1.4 1.4-.1 1.3l3.1-.6v.2a21.2 21.2 0 011.9-3.7c.8 1.1-.4.8-.2 1.7l1.7-1.8c.7 1.9-.7 3.8-1.9 3.5 1.6 7.4 1.4-1.8 4.8 2.5l-1.6.9c1 4.2 2.3 2.7 4.1 5.3-.4-1.4-3.6-6.6-1.8-8.4.5.6 1.2.8 2.2-.7 0 2.6 1 2 2.2 1.8l-.1 3.5c1.3-1 1.2-2.8 2-4.3 1.5.3 1.8 3 2.1 5.3 2.3.6-1.6-4.3 1.2-5 2 1.3 3.3-.1 5.6-2.2 1.4 1.2-.2 2.1.3 3.1l1.2-2.8c.3.1.2.9.2 1.3 1-1.1.1-3.5 1.7-4.4.4-3.8 3.3 5.6 5.3 1.2.5 1-.2 2.1-.1 3.5 2.7-2.9 2.3-2.1 4.5-5.9l1.9 2.3c-1.4-2.6.4-5.7 1.9-8.2a26.1 26.1 0 00-1.2-2.9l2.5-1.9a5.4 5.4 0 01-.3 3.2 5.6 5.6 0 01.5-.8c.9 1.3.5 3.3-.2 5.2l-.9-2.1a18.7 18.7 0 00-1 6.5 2.4 2.4 0 01.8-.9 2.6 2.6 0 00-.2 1.4c.1.4.3-.4.7-1.3l.6 3.9.1-1.5 3.3 2.4c2.3-3.9 4.3-9.7 8-11.3-.9 2.8-.1 4.6-.2 8-1-3.6-2.9 1.5-4.8.8 1 .4.8 2 .6 2.5l3.4-3.3c0 2.8.7 2.1 1.7 3.2-.7-5.4 2.5-3.7 3.9-5.3.1 1.8-.2 3.7-1.9 3.3 1.9 4.1 2.4-6.4 4.2-3-.4.1-.6-.2-.8.7a1.5 1.5 0 012.8 1.2h-.4c2.8.6 8.4-.1 8.7-4.7l-.4 6.5 4.7-15.6c-.4 4 1.5 13.4-.8 15.7.7.6 1.5 1.2 2.9-.2-.5-.6-1.2-5.7-.6-6.1 1.8 4.4 1.2 2.3 3.3 6.1-.7-.8-.1-7.1 1-6.9-.1.9.2 6.1-.2 6.8l2.5-6.2c-.6 1.1 0 5.2.6 6.9-.3-1.2 2.3.1 3-.6l-1.2-1.4c3 .9 2.8-8.7 5.7-8.4-.3 1.3-.7 7.8.8 8.5.6-3.1 2.7-15.1 5.2-17.6l.5 1.8 1.9-2.1a139.8 139.8 0 01-6.2 18.6c1.2 1.4.4 2.1 2 1.9a2 2 0 01-1.3 2.7l3.9 1c-.3-3.7 2.9-3.7 2.7-6.8l-4.1 3.9c-.3-3.6 2.2-10.4 5-9.8.7 1.4-.4 6.5-.3 7.7.3-1.3 2.6-2.5 2.8-1.6l-1.1 2c1.6 1.3 2.4-4.9 4.3-1.5.6.2 2 4.6 2.1 2.5-1.2-4.1-1.7-17-1.1-20.2.2.3 3.4 3.9 4.2 5.9 1.1 3.2-1.3 7.8-.4 10.6a5.3 5.3 0 01.8-2.6c.7.8-.2 3.1 1.3 2.6.1-3.7 3 .2.6-3.1 1.4-1.1 1.5.7 3.2.5-.6-2.4 1.2-8.2 2.6-9.3a6.8 6.8 0 00.5 2.7c2.9.3 4.5 1.9 7.2 1.8.3.9 1.6 1.9 1.1 3.5.4-.7.7-1.9 1.5-2.1 1.7 3.1-1.8.6-.5 4.4 0-2.2 2.1-3.1 3.2-4.4-.5-3.3-2.8-.5-3.9.9-.2-4.6 1.7-9.5 4.5-11.7 2.2-1.2 1.1 2.9 1.5 2.3 4.3.6 3.3-8.1 6.9-5 1.5 2.9.3 5.8.7 7.9-1.8 1.2-2.9-1.7-4.1-1.6l1.6 1.3c-.5 1-1.7 1.8-2.4 1 1.3 2.6 7.2.2 10.5 2.5.5-1 1.5-2.1 1-3.2l-1 .5c-1.1-2.3 1.8-3.4.4-4.4 1.3-1.7 2.7-4.4 4.7-3.2l.5 3.3c-.1-1-1.4-1.9-1.9-.9.7-1.5 3.2 4.4 3.9 0l-1.5-2.2c1.3-1.7 2.8-5.4 4.6-4.4-.9-3.2-.4.4-1.8-3.4 1.3 4.7-4.4 0-2.5 5-1.5-4.4-2.3-1.8-4.1-5.5.1 1.1.7 2.1-.8 1.6a3.8 3.8 0 01-.3 1 .1.1 0 01-.1-.1l.1.1a3.5 3.5 0 01.8 1.6c-.6 2.6-2.9 2.6-3.6 3.9-.9-.5.3-1.3-.2-2.4l-1.1 2c-.2-2.4-2.5-4-.5-5.5h-1.8c-1.1-1.3-2.6-1.8-3.5-.7-.9-.5-2 2.8-1.4.8l-2.8 1.6-.1-.6c-2.8-.2-5.6 4.3-9 0a3.3 3.3 0 01-3.5.8l-.4-2.1c-1.2.8-3.7-2-4.2.2-1.5-5.6-5.9-1.1-8.1-2v2.8c-1.5-.1-2.9.7-4.6 1.9l.2 2.4c-1.5 2-4.1-1.6-6.6-1.3.1-.9.8-.7 1.2-.2-3.1-5.4-6.2 4.1-9 .2-.7.9-1.1.6-1.6 0l.2-.1h-.3a11.3 11.3 0 00-1-1.3 6 6 0 00.8 1.3 5.5 5.5 0 00-2.1 1l-.4-2.6-.2.1c-.8-.9-.6 1.3-.1 3.2a6.2 6.2 0 00-1 1.6c-.7-4.2-2 1.5-2.9-3-.5 2.2-3.8 1.7-4.2 6.4 0-.6-.3-.9.1-.9-.9-.5-1.7-1-2.5.3l-.4-3.3-1.8 4.5c-1.2-2-1.7-3.2-.6-5.8-2.7 4-2.2 1.5-4.5 5.4l.1-2.2c-.8.1-2.1 3-2.6 1.2-1.9-4.1-9.2-.4-14-4.2 1 6.3-2.2-2.8-2.4 2.1-.3-1.5-1-2.3-.2-3.6-2.4 1.5-3.7-2.3-5.3 1.8-.3-1.5.5-2.2.2-3.1-.2.3-.8 1.3-1 .4-.3-.9.3-1.3.7-1.9-2.5.3-2.7 4.9-2.9 9.2-1.3-2-1.9-1.7-2.8 1.1-.4-1.4-1.2-2.9.4-3.4-.9-.2-5.3-2-5.4 1.4-.3-.9-1.2-.2-1.4.2-2-.2-2.1-.5-4-.2l.5.6c-.7 4.2-1.6.9-3.1 1.4v-.4c-3.6-3-1.5 1.4-5-2l.2 2.6c-.3 5.6-3.1-3.3-5.1-1.2l.7 1.5c-1.1 1.9-3.1-7.6-4.2-8.3-.2-.5.4-.8.7-1.1-2.9-3.3-.4 3.4-2.6 4.2-.4-1.8.5-4.7-.9-5-.7-1.5-4.2 6-6.2 2.4.4 1.4.9 2.8-.1 3.9-1.6.5-4.2-5.4-5.6-.9a2.6 2.6 0 01-.3-1.1c-1.2 1.1-3.9 1.9-4.6 4.3-1-9-7.4 4.3-7.3-4l-3.6.4.1-.8c-2.3-.6-3.2 1.4-4 3.4-.5-.6-.1-1.3-.1-1.8-3.4-1.7-3.7-1.4-6.6 2.8l-.3-2.7c-.8 1.6-4.9-4.3-8.2-1.2a2.1 2.1 0 01.4-1.2c-3.8 3.1-8.9-7.6-10.4 2.2l-2.5 2.4c3.2.8-.5 4.2.8 5.9-1.3.6-3.2-3-1.7-3.5l.2.5c.6-5.1-4-1.9-3.8-5.3-6.3.2-12.4-2.7-18.3-3.1l.6 4-1.9-.2c-.5-.9-.7-3.1.8-2.9-.7-2.3-2.5 1.8-2.6 2.7-2.9-1.7 1.2-4.6.3-4.7l-1.2.3.3.5c-1 1.6-1.1 3.3-2.9 3.1-1.1-.8-.5-2.5-1-2.6 0-.3-.1-.4-.7-.1l-2.6-.4 1 3.2c-1.2 1.5-2.4-.2-1.3 3.4-1.7-5.5-9.7-2.1-10.7-3.9-1.7 2.3-3.2 2.2-5.2 1.9.5.7.7 4.2-1 3.7.8-7.3-3.1-3.2-4.3-8.5 1.2 3.5-4.8.8-3 5.7-1.4-.6 0-2.7-1.1-4.5-3.4 2.8-7.4-2-11.6-1.1-.1 1 .6 2.4-.3 3.8l-2.1-4.8c-.8.5-.9 5.5-2.3 2.2.2.8.5 2-.1 2.3-8.1-4.8-16.8 3.5-24.9-5.5 1.1 1.9.3 2-.5 2.1.5.5-.1 2.4 0 3.7l-3.4-3.7c-.7 3.6-3.7.2-4.2 3.6l1.1-.6c-1.6 4 1.9 9.1 1.5 14.3 1.7-4.6 4.2 6.9 7 .4.6 1.1-.5 1.7-.3 2.9.7-2.2 1.6-2.7 3.1-1.6l-.2.5c4.3-.5 6.1 1.8 10.9 3.4l-.3-2.6c1 .4 1.2 1.2 1.7 1.8 1.3-3.9-2.9-.3-1.7-4.6 1.3 5.3 7.3.2 8.1 6.2 1.6.1-.4-3 1.2-2.9l.4 1.6.4-2.1c1 .4 1.5 2.4 1.5 3.8-.3-.2-.7.4-1 .5 1.3 1.9 3.8-.6 4.3.1l-1.5-1c4.4-1.4 9.7.8 13.9-2.4l-.3-1.2c3.3-2.2 2.5 1.4 6.1.4l-.1.3c.7-1.2 1.7-1.8 2.6-1.6-.9 1.4 1.6 2.8.4 4.3 3.5-2.3 1.8-1.9 4.1-6.3l.5 2c.8-1.8.9-2.8 2.7-3.3-1.5 1.7 1.1 3.1-.6 5.3 3.6 4.5 5.6-4.4 7.1 2.1 1.8-5.5-3.1-3.1-2.2-4.3-.8-1.8 1.5-4.1 2.6-3.6 1.2.1 1.9 7.2 4.9 7.1-.3 0-.3.4-.6.4 1.1 1.4 2.2-1.9 3.5.4.8-3.4 1.8.2 2.1-4.1l-2.7.9c1.6-1.1 3.1-6.1 5.6-3.6a7.4 7.4 0 01-1.5 2.6c.7 1.3 1.4-.8 2.2.5-.3 4.3-3.3.9-5 4.1.8 1.8 3.2-3.1 2.3 1.6 1.3-5.9 2.9.8 5-3.7l-.2 2.6c.3-.4 1-1.6 1.6-1.5l-1.1 3.3c1.7-2.8 3.1 2.5 4.7 1-3.3 0-.7-3.1-2-5 4.1-3.4 2.2 6.8 6.8 5.6-.6.4-2.3-1.6-1.3-2.8a5.6 5.6 0 012.5 2.9c3-.5-.4-2.7.9-4.2 1 3.2 1.5-1.3 2.8-2.2v2.6c3.4 1.7 1-5.4 4-3.4l-1.3 3.6 1.6-.9-.4 3c1.8-2.2 2.3-1.6 4-.8-.4-1.9.3-4.8 1.8-4.8 1 1.6-.6 2.5 1.5 2.1-.5 1.6-1.1 3.7-2 1.3-.1.9-.5 1.6-.6 2.5 1.1 1.8 2.8.4 3.6.4-.3-.1-.7-.2-.8-.6l3.1-3.6a2.4 2.4 0 01-.3 2.5c.6-.3 1.1-1.5 2-1.7-.3 2.1-.2 4.3-1.6 5.3l3-2.3c.2.9 1.5 2.6 1.1 3.3 1.6 1.3 4.1-4.1 6.2-2.4a1.7 1.7 0 01.8-1.1c2 .5 3.8 3.1 6.3.2l1.3 3.8c1.9-.8-1.8-4.8 1.3-6.2 2.2-1.2.8 3.3 1.6 4.3 1.1-1.9 3.1-5.8 5.1-2.7-.5.8-1.1.2-1.7.5zm23.4-1.6c-.5.5-1.4 2.2-1.7.7.6-3 .9-1.5 1.7-.7zm35.6-6.4c-.3.9-.9.4-1.5-.5.5-.3.9-.2 1.5.5zm98.2-20.6v.1c-1-1-.7-.6 0-.1zm2.2 1a1.4 1.4 0 00.1-1.1c-.1.7-.6.7-1.1.6.1.7.4 1.1 1 .5zm-224.4 2.7l.4.7c-.9.8-.6.1-.4-.7z"
											data-name="Pfad 216"
										/>
										<path
											d="M340.5 381.7a5.9 5.9 0 01-.2-1.4 1.2 1.2 0 00.2 1.4z"
											data-name="Pfad 217"
										/>
										<path d="M270.9 387.4a.6.6 0 00-.1.4z" data-name="Pfad 218" />
										<path
											d="M413.3 381.9a3.8 3.8 0 01-.9-1.3c0 .6.2 1.2.9 1.3z"
											data-name="Pfad 219"
										/>
										<path
											d="M455.7 353.6l-1.3.7c.6-.2.9.4 1.2.8 0-.6-.3-1.5.1-1.5z"
											data-name="Pfad 220"
										/>
										<path
											d="M468.1 369.2c.2-.3.4-.1.6-.4l-.1-1.2c-.8.1-1.4 1.1-.5 1.6z"
											data-name="Pfad 221"
										/>
										<path
											d="M457.4 362.2c.2 2.2 1 1.4 1.9 1h-.2c.1-3.1-.8-2.1-1.7-1z"
											data-name="Pfad 222"
										/>
										<path
											d="M459.5 363.1a1.4 1.4 0 01.9-.1c0-1.3-.4-.3-.9.1z"
											data-name="Pfad 223"
										/>
										<path
											d="M447.5 357c.5.5.1-2.8.4-1.9.4-2.9-2.8 3.4-.4 1.9z"
											data-name="Pfad 224"
										/>
										<path d="M458.5 369.4l-.5-2.7-.4 2.2z" data-name="Pfad 225" />
										<path
											d="M451 367.8l1.5.7c0-.5.1-.7.4-.9-1-.1-2-.6-1.9.2z"
											data-name="Pfad 226"
										/>
										<path
											d="M452.9 367.5a1.3 1.3 0 001.2-.5 2 2 0 00-1.2.5z"
											data-name="Pfad 227"
										/>
										<path d="M456.5 370.3l-.5-.5-1.1-.2z" data-name="Pfad 228" />
										<path
											d="M434.8 367.9l-1.6.8c-.1.9.3 1.5.9 1.1.4-.6 1-1 .7-1.9z"
											data-name="Pfad 229"
										/>
										<path d="M440.1 375.2c-.5-.5-.5-1.2-.8-2l.1 3.4z" data-name="Pfad 230" />
										<path
											d="M435.3 376.2c-.1.9-2.3 2.8-.2 2.5.2-1 1.8-1.8.2-2.5z"
											data-name="Pfad 231"
										/>
										<path d="M410.5 372.8l.4-.1-.3-5.5z" data-name="Pfad 232" />
										<path
											d="M389 386.6c2 1.3.4-3.4 2.2-1.8.4-1.3-1.5-1.3-1-2.5-1.2 1.4-1.9.6-1.2 4.3z"
											data-name="Pfad 233"
										/>
										<path
											d="M390.1 382.3a3.5 3.5 0 00.6-.9 6.8 6.8 0 00-.6.9z"
											data-name="Pfad 234"
										/>
										<path d="M144.3 356.9l-1.2-1.2.8 1.9z" data-name="Pfad 235" />
										<path d="M141.9 361l-.2-3.5-.8 3.2c.2-.2.8-.5 1 .3z" data-name="Pfad 236" />
										<path d="M312.4 391.6l.1-.8c-.2-.9-.5-1-1.1-1.1z" data-name="Pfad 237" />
										<path d="M295.4 388.9l.3.1-.6-3.2z" data-name="Pfad 238" />
										<path
											d="M281.1 392.9c.6.1 1.3-.6 1.9-.4-1.3.6-2-3.5-1.9.4z"
											data-name="Pfad 239"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
					<g data-name="Gruppe 25">
						<g data-name="Gruppe 24" opacity=".8">
							<g data-name="Gruppe 23">
								<g data-name="Gruppe 22">
									<g fill="currentColor" data-name="Gruppe 21">
										<path d="M324 295.8c.3 0 0-1.1 0-1.3-.4.4.1 1.6 0 1.3z" data-name="Pfad 240" />
										<path d="M320.2 299.1l-.1-.4-.4 1.2z" data-name="Pfad 241" />
										<path
											d="M316.1 299.9c.7 1.8 1.4-.6 2.2 0l.2.4v-1.6c-.7.3-1.7 1.6-2.4 1.2z"
											data-name="Pfad 242"
										/>
										<path d="M313.2 296.1c.3.7-.3.7.5.1l-.1-.2-.4.1z" data-name="Pfad 243" />
										<path d="M313.6 296.1c.5-.1-.4-.6 0 0z" data-name="Pfad 244" />
										<path
											d="M311.8 296.9l.4-.8c-.2-.4-.7-.4-.6-.8-.5.5-.3.9.2 1.6z"
											data-name="Pfad 245"
										/>
										<path d="M311.5 298.4l.2-.3c-.1-.2-.1-.3-.2.3z" data-name="Pfad 246" />
										<path d="M312.2 297.3l-.5.7c.1.3.3.9.2-.3.1.6.1.1.3-.4z" data-name="Pfad 247" />
										<path
											d="M312.6 297.6c.4.4.8.5.4 1.3 1.1-.5.7-1.8-.4-1.3z"
											data-name="Pfad 248"
										/>
										<path d="M316.3 301.9l.5.5.2-.7c-.1.3-.8-.4-.7.2z" data-name="Pfad 249" />
										<path
											d="M308.1 296.5c0 .4.4 1 .5 1.6l.3-.5c-.2-.3-.7-.5-.8-1.1z"
											data-name="Pfad 250"
										/>
										<path d="M308.6 298.1l-.5.8c.6 0 .6-.4.5-.8z" data-name="Pfad 251" />
										<path d="M311.8 300.5l.7-1.6-.9 1.7z" data-name="Pfad 252" />
										<path d="M305.7 296.9l.2-1-.3 1.6z" data-name="Pfad 253" />
										<path
											d="M304.2 297.4c.1-.8-.6-1.3-.4-1.8-.4.2-.6 1-.9 1.6.3-.4.7-.4 1.3.2z"
											data-name="Pfad 254"
										/>
										<path
											d="M302.6 298.2a5.1 5.1 0 00.4-1 1.9 1.9 0 00-.4 1z"
											data-name="Pfad 255"
										/>
										<path d="M307.1 298.9c-.1-.2-.3-.9-.7-1.1l.5 1.1z" data-name="Pfad 256" />
										<path
											d="M310 299.8c-.2.7-.9 1.5 0 2.4.1-.9-.4-1.4 0-2.4z"
											data-name="Pfad 259"
										/>
										<path d="M307.7 300.3l.7.1a1.4 1.4 0 01-.1-1.1z" data-name="Pfad 260" />
										<path d="M307.4 300.7l.3-.4-.3-.1z" data-name="Pfad 261" />
										<path
											d="M303.9 299c-.2.5-.5.6-.8.8a1.7 1.7 0 001.2.1c-.1-.3 0-1-.4-.9z"
											data-name="Pfad 262"
										/>
										<path d="M305.3 299.1c0 .2.1.2 0 0z" data-name="Pfad 263" />
										<path d="M299.6 300.5l.1.2-.1-.2z" data-name="Pfad 264" />
										<path
											d="M304.3 300.2c.3.2.4-.1.5-.5a.9.9 0 01-.6.3.3.3 0 00.1.2z"
											data-name="Pfad 265"
										/>
										<path
											d="M301.7 298.9a2.7 2.7 0 00.6.5c-.2-.3-.6-.8-.6-.5z"
											data-name="Pfad 266"
										/>
										<path d="M305.1 298.9c-.1-.3 0-.2 0 0z" data-name="Pfad 267" />
										<path
											d="M305.1 298.9a1.9 1.9 0 00-.2.8 1 1 0 00.4-.5l-.2-.3z"
											data-name="Pfad 268"
										/>
										<path
											d="M299.9 308c-.1-1.1.4-2.2 1.3-1.2.5-.9-.6-4.3-1.5-6.2a1.8 1.8 0 01-.4 1.6c.3.5 1.7 1.1 1.3 2.1-.8.7-.8-.2-1.3-.7.6 1.3-.7 2.1-.2 4l.6-.8c.1.4 0 1 .2 1.2z"
											data-name="Pfad 269"
										/>
										<path
											d="M301 300.5l.2-.2c-.3-.1-.6-.5-1.2-1.3a2 2 0 00-.3 1.4l1.3-.1z"
											data-name="Pfad 270"
										/>
										<path
											d="M302.4 300.1c0 1.2-.5 1.8.1 3 .8-.2.4-1.1.7-1.6-1.2.5.2-.7-.8-1.2a2 2 0 01.6-.4 1.6 1.6 0 01-.7-.4v.1c.1.1.1.2 0 .1a.8.8 0 01.1.4c-.4-.2-.1-.3 0-.5v-.2l-1.1.9c.2.2.5.1 1.1-.2z"
											data-name="Pfad 271"
										/>
										<path d="M309.8 304.7a.4.4 0 01-.1-.3c0 .2-.1.3.1.3z" data-name="Pfad 272" />
										<path
											d="M309.2 304.1c.1-.2.1-.7.4-.6.3.3.1.6.2.9.1-.3.5-.9-.2-1.4l-.1.2c-.6-.3-1.5-1.6-1.4-1.8a8 8 0 001.1 2.7z"
											data-name="Pfad 273"
										/>
										<path d="M305.8 302.4l-.9.8.7.9-.1-.6c.6.1.3-.6.3-1.1z" data-name="Pfad 274" />
										<path d="M299.4 299.9l-.1-1.2-.3 1.8z" data-name="Pfad 275" />
										<path d="M298 300.3l-.1-1-.2.7z" data-name="Pfad 276" />
										<path d="M223.3 327.7l-.3.4.3-.4z" data-name="Pfad 277" />
										<path d="M225.6 327.4v0z" data-name="Pfad 278" />
										<path
											d="M264.5 306.7c-.6-.9-1.4-2.3-1.1-1.2l.4 1.1c.2-.2.4-.2.7.1z"
											data-name="Pfad 279"
										/>
										<path d="M242.8 317.8l.2.3.1-1.2z" data-name="Pfad 280" />
										<path d="M243.3 322.7l-.7-.6a4.4 4.4 0 00.7.6z" data-name="Pfad 281" />
										<path d="M211.3 331.2l-.1 1.2c.5-.1.2-.6.1-1.2z" data-name="Pfad 282" />
										<path
											d="M284.1 303.3a1.7 1.7 0 00-1.1-.5c.6.6 1.2 1.5 1.1.5z"
											data-name="Pfad 283"
										/>
										<path d="M221.9 315.3a.8.8 0 00-.1.8 1.2 1.2 0 00.1-.8z" data-name="Pfad 284" />
										<path
											d="M281.9 303l.3.2a1 1 0 01.9-.4c-.5-.4-1-.6-1.2.2z"
											data-name="Pfad 285"
										/>
										<path d="M166.5 338l-.1-.1.1.1z" data-name="Pfad 286" />
										<path d="M151.8 328.1l.5-.2c-.1-.1-.2 0-.5.2z" data-name="Pfad 287" />
										<path d="M292.4 300.8c.3-.1.1-.1 0 0z" data-name="Pfad 288" />
										<path d="M294.7 305.2a1.1 1.1 0 000 .6z" data-name="Pfad 289" />
										<path d="M280.3 310.8c.1.2.1.1 0 0z" data-name="Pfad 290" />
										<path d="M293 301.3l-.4-.3.4.3z" data-name="Pfad 291" />
										<path d="M292.8 300.7a.4.4 0 01.3.1c0-.2-.1-.3-.3-.1z" data-name="Pfad 292" />
										<path d="M292.1 301h.5l-.1-.2-.4.2z" data-name="Pfad 293" />
										<path d="M189.9 330.9c-.2.4-.1.3 0 0z" data-name="Pfad 294" />
										<path d="M259.2 320.1c0-.1-.1-.1 0 0z" data-name="Pfad 295" />
										<path d="M258.3 321.1c.2-1.5.5-1.4.9-1.2l-1-3.3z" data-name="Pfad 296" />
										<path
											d="M218 329l.9.9c-.6 1.9-1.3 1.4-.4 2.7-.6-3.6 2.8-.9 2.2-4.5l.6.7c-.1 0-.1.2-.3.2 1.3 1.6.2-2.8 1.5-2.5a1 1 0 01.7 1.2l.8-1.1c.3 0 .3.7.1.6l1.4-.6v.1a9.5 9.5 0 01.6-2c.5.5-.1.4.1.9l.6-1c.5.9 0 1.9-.6 1.9 1.4 3.5.5-1 2.5.8l-.7.6c.9 2 1.3 1.1 2.4 2.2-.3-.6-2.3-2.9-1.6-4 .3.2.6.3 1-.5.2 1.3.6.9 1.2.7l.3 1.7c.5-.6.3-1.5.5-2.3.7 0 1.1 1.3 1.5 2.4 1.1.1-1.1-2 .1-2.5 1 .5 1.5-.3 2.4-1.6.7.5.1 1.1.4 1.5l.3-1.5.2.6c.4-.6-.3-1.7.4-2.3-.1-1.9 2 2.5 2.6.2.3.4.1 1.1.3 1.7a9.2 9.2 0 001.6-3.3l1.1 1c-.9-1.2-.3-2.8.2-4.2a6 6 0 00-.8-1.3l1-1.1a2.6 2.6 0 01.1 1.6.8.8 0 00.1-.4 3.6 3.6 0 01.4 2.6l-.6-1a9 9 0 00.1 3.3.8.8 0 01.3-.5v.7c.1.2.1-.2.2-.7l.6 1.9-.1-.8 1.7.9c.7-2.1 1.2-5.1 2.7-6.2-.2 1.5.3 2.3.6 4-.8-1.7-1.2 1-2.2.8.5.1.5.9.5 1.2l1.3-1.9c.2 1.4.5 1 1 1.4-.8-2.6.9-2 1.4-2.9.2.9.2 1.8-.6 1.8 1.2 1.9.6-3.4 1.7-1.8-.2.1-.3-.1-.3.4a.7.7 0 011.4.4l-.2.1c1.3.1 3.9-.7 3.7-3a31.6 31.6 0 01.3 3.2l.9-8.1c.2 2 1.8 6.5.9 7.8.4.2.8.5 1.3-.3a6.4 6.4 0 01-.8-3c1.2 2 .8 1.1 2.1 2.7-.4-.4-.6-3.5-.1-3.5 0 .5.6 3 .5 3.4l.7-3.2a7.6 7.6 0 00.8 3.4c-.2-.6 1.1-.1 1.4-.5l-.7-.6c1.5.2.6-4.5 2-4.6-.1.7.3 3.9 1.1 4.1 0-1.6.1-7.7 1.1-9.1l.4.8.8-1.2a94.3 94.3 0 01-1.4 9.7c.6.6.3 1 1.1.8a1 1 0 01-.4 1.4l1.9.2c-.4-1.8 1.1-2.1.7-3.5l-1.6 2.2c-.4-1.8.2-5.3 1.5-5.2.5.7.3 3.2.5 3.8.1-.6 1-1.4 1.2-1l-.4 1.1c.8.5.7-2.6 1.9-1 .3.1 1.3 2.1 1.2 1.1a42.9 42.9 0 01-2.1-9.9 16.3 16.3 0 012.4 2.6c.8 1.5 0 4 .6 5.3a3 3 0 01.2-1.4c.4.4.2 1.5.8 1.2-.2-1.8 1.4-.1 0-1.6.6-.6.8.2 1.5 0-.5-1.1 0-4.1.5-4.8a4 4 0 00.4 1.3c1.4-.1 2.3.6 3.5.4.2.4.9.8.8 1.7.1-.4.2-1 .6-1.1 1 1.4-.8.4.1 2.2-.1-1.1.7-1.6 1.2-2.4-.5-1.6-1.3-.1-1.8.7a8 8 0 011.2-6.1c1-.8.7 1.4.8 1 2.1 0 1-4.2 2.9-2.9.9 1.3.6 2.9.9 3.9-.8.7-1.5-.7-2.1-.5l.8.5c-.2.5-.7 1-1.1.6.8 1.2 3.4-.4 5.1.5.2-.5.6-1.1.2-1.7l-.4.3c-.7-1.1.6-1.8-.1-2.2.5-.9 1-2.3 2-1.9l.5 1.6c-.1-.5-.8-.9-.9-.3.2-.8 1.8 2 1.8-.3l-.8-1c.5-.9 1-2.8 1.9-2.5-.7-1.5-.2.2-1.1-1.6.9 2.3-2.1.3-.8 2.6-1-2.1-1.2-.7-2.3-2.5.1.5.5 1-.3.8a.7.7 0 01-.1.5h-.1v.1a2.2 2.2 0 01.5.8c-.1 1.3-1.2 1.5-1.4 2.2-.5-.2.1-.7-.3-1.2l-.4 1.1c-.3-1.2-1.4-1.8-.6-2.7l-.9.1c-.6-.6-1.4-.7-1.7-.1-.5-.2-.8 1.5-.6.5l-1.2 1-.1-.3c-1.3.1-2.4 2.5-4.3.6a1.5 1.5 0 01-1.6.6l-.3-1c-.5.5-1.9-.7-2 .4-1.1-2.7-2.9-.1-4-.4l.2 1.4a4.5 4.5 0 00-2.1 1.3l.3 1.2c-.6 1.1-2.1-.5-3.2-.2 0-.5.3-.4.6-.2-1.9-2.4-2.6 2.5-4.2.8-.2.5-.5.4-.8.1a.1.1 0 00.1-.1h-.1l-.6-.6a3.8 3.8 0 00.5.6 2.4 2.4 0 00-.9.7l-.4-1.3a.1.1 0 00-.1.1c-.4-.4-.2.7.2 1.6a1.9 1.9 0 00-.3.9c-.7-2-.8.9-1.6-1.3 0 1.1-1.7 1.1-1.4 3.5-.1-.3-.2-.4 0-.5-.5-.2-.9-.4-1.1.3l-.5-1.6-.5 2.4a3 3 0 01-.8-2.8c-.9 2.2-.9.9-1.6 3l-.1-1.1c-.4.1-.7 1.6-1.1.8-1.2-1.8-4.4.5-7-.9 1 3-1.3-1.2-.9 1.2-.3-.7-.7-1.1-.4-1.8-1 .9-1.9-.8-2.3 1.3-.3-.7 0-1.1-.2-1.5-.1.2-.2.7-.4.3s.1-.6.2-1c-1.1.3-.8 2.6-.5 4.8-.8-.9-1-.7-1.2.8-.3-.7-.8-1.3-.1-1.7-.4 0-2.7-.6-2.4 1.2-.2-.4-.6 0-.7.2-.9.1-1-.1-1.9.3l.3.2c0 2.1-.7.6-1.3 1v-.2c-1.9-1.2-.6.8-2.5-.5l.3 1.3c.4 2.8-1.8-1.4-2.5-.1l.5.7c-.3 1-2.1-3.5-2.7-3.7-.2-.2.1-.4.2-.6-1.7-1.4.1 1.7-.8 2.3-.4-.9-.2-2.3-.9-2.4-.5-.7-1.4 3.3-2.7 1.7.3.7.7 1.3.3 1.9-.7.4-2.5-2.3-2.7 0l-.2-.5c-.4.7-1.6 1.3-1.7 2.5-1.3-4.3-3.1 2.8-3.8-1.3l-1.7.5v-.4c-1.1-.1-1.3 1-1.5 2-.3-.2-.2-.6-.2-.9-1.7-.5-1.9-.3-2.8 2l-.4-1.3c-.2.8-2.7-1.6-4 .2a1.3 1.3 0 01.1-.6c-1.5 1.9-4.9-2.9-4.6 2l-.9 1.4c1.6.1.2 2.1.9 2.8-.5.4-1.8-1.2-1.1-1.6l.2.2c-.2-2.6-2-.5-2.3-2.3-2.9.7-6.1-.2-8.8.2l.7 1.9-1 .1c-.3-.4-.6-1.5.1-1.5-.6-1-1 1.1-.9 1.6-1.5-.6.1-2.4-.3-2.3l-.5.2.2.2c-.3.9-.2 1.7-1 1.8-.6-.3-.5-1.2-.7-1.2 0-.1-.1-.2-.3 0h-1.2l.8 1.5c-.4.9-1.2.1-.3 1.8-1.3-2.6-4.7-.2-5.4-.9a2 2 0 01-2.3 1.4c.3.3.7 2-.1 1.9-.3-3.6-1.7-1.3-2.8-3.8.9 1.6-2.2.8-.9 3.1-.7-.2-.3-1.3-.9-2.1-1.4 1.6-3.6-.3-5.5.4 0 .5.5 1.1.2 1.9l-1.4-2.2c-.3.3.1 2.8-.9 1.2.2.4.4 1 .2 1.1-4.2-1.7-7.6 3-12.1-.8.6.8.3 1-.1 1.1.3.2.1 1.2.3 1.8l-1.9-1.6c-.1 1.8-1.7.3-1.7 2.1l.5-.4c-.4 2.1 1.5 4.3 1.8 6.9.5-2.4 2.5 3.1 3.3-.3.4.5-.1.9.1 1.4.2-1.1.5-1.4 1.3-1v.3c2-.5 3 .4 5.4.8l-.4-1.2c.5.1.7.5 1 .8.3-2-1.4.1-1.2-2.1 1 2.5 3.5-.5 4.3 2.4.8-.1-.4-1.4.3-1.5l.3.8V336c.5.1.9 1.1 1 1.7-.1-.1-.3.2-.4.3.8.8 1.8-.6 2-.3l-.8-.4c1.9-1.1 4.6-.4 6.4-2.4l-.2-.6c1.3-1.4 1.3.5 2.9-.3v.2c.2-.7.6-1 1.1-1-.3.8 1 1.2.6 2.1 1.4-1.5.7-1.1 1.4-3.5l.4 1c.2-1 .2-1.4 1-1.8-.5 1 .8 1.4.2 2.7 2.1 1.9 2.2-2.6 3.6.4.3-2.9-1.8-1.3-1.4-1.9-.5-.8.3-2.2.9-2 .6 0 1.6 3.3 2.9 3.1-.1 0-.1.2-.3.2.6.6.9-1.1 1.7-.1.1-1.7.8-.1.6-2.2l-1.2.7c.6-.7.9-3.3 2.3-2.3a3.4 3.4 0 01-.5 1.4c.5.6.6-.5 1.1 0 .3 2.1-1.5.7-2 2.5.5.8 1.2-1.8 1.2.6 0-3 1.4.1 2-2.3l.2 1.3c.1-.2.3-.9.6-.9l-.2 1.7c.5-1.5 1.7 1 2.3.1-1.5.3-.6-1.5-1.4-2.3 1.6-2 1.7 3.1 3.7 2.1-.3.2-1.2-.6-.9-1.2a2.7 2.7 0 011.4 1.2c1.4-.5-.5-1.3 0-2.2.8 1.5.6-.8 1.1-1.4l.2 1.3c1.7.5-.1-2.8 1.6-2l-.3 1.9.7-.6.1 1.5c.6-1.2.9-1 1.8-.7-.4-.9-.3-2.4.4-2.5.6.7 0 1.3.9.9-.1.8-.1 1.9-.8.8a5.6 5.6 0 000 1.3c.7.8 1.3 0 1.7-.1a.8.8 0 01-.4-.2l1.1-2.1a1.5 1.5 0 01.1 1.3c.3-.2.4-.8.8-1 .1 1.1.3 2.1-.2 2.8l1.2-1.4c.2.4.9 1.1.8 1.5.9.5 1.5-2.4 2.7-1.8a.9.9 0 01.3-.6c1 .1 2.1 1.2 2.9-.5l1 1.8c.8-.6-1.3-2.2 0-3.2.9-.8.7 1.5 1.1 2 .3-1 .9-3.1 2.1-1.8-.5.3-.8 0-1.1.2zm10.8-2.8c-.2.3-.4 1.2-.7.5-.1-1.5.2-.9.7-.5zm16-6.2c-.1.5-.4.3-.7-.1.2-.2.4-.2.7.1zm44.7-17.5c-.6-.4-.4-.2 0 0zm1 .3v-.5c0 .3-.2.4-.5.4.1.3.3.5.5.1zm-105.2 20l.2.3c-.3.4-.2.1-.2-.3z"
											data-name="Pfad 297"
										/>
										<path d="M243.3 322.1a1.4 1.4 0 01-.2-.7.6.6 0 00.2.7z" data-name="Pfad 298" />
										<path d="M211.3 331z" data-name="Pfad 299" />
										<path d="M277.4 316.6a1.5 1.5 0 01-.5-.6c0 .3.1.6.5.6z" data-name="Pfad 300" />
										<path
											d="M295.3 299.7l-.6.5a.5.5 0 01.6.3c0-.3-.2-.7 0-.8z"
											data-name="Pfad 301"
										/>
										<path
											d="M302.3 306.7c.1-.2.2-.1.3-.2l-.1-.6c-.5 0-.7.6-.2.8z"
											data-name="Pfad 302"
										/>
										<path
											d="M296.7 303.9c.3 1.1.6.6 1 .4h-.1c-.1-1.6-.5-1-.9-.4z"
											data-name="Pfad 303"
										/>
										<path d="M297.8 304.2a.6.6 0 01.4-.1c-.1-.7-.2-.1-.4.1z" data-name="Pfad 304" />
										<path
											d="M291.7 301.9c.3.2-.1-1.4.1-1-.1-1.4-1.2 1.9-.1 1z"
											data-name="Pfad 305"
										/>
										<path d="M297.7 307.4l-.4-1.3v1.1z" data-name="Pfad 306" />
										<path
											d="M294.1 307l.8.2a.4.4 0 01.1-.5c-.5.1-1-.1-.9.3z"
											data-name="Pfad 307"
										/>
										<path d="M294.9 306.8a.6.6 0 00.5-.3 1.5 1.5 0 00-.5.3z" data-name="Pfad 308" />
										<path d="M296.8 308l-.2-.3h-.5z" data-name="Pfad 309" />
										<path d="M286.5 308.2l-.7.5c0 .5.3.7.5.5.1-.4.4-.6.2-1z" data-name="Pfad 310" />
										<path d="M289.5 311.4c-.3-.2-.3-.5-.5-1l.3 1.7z" data-name="Pfad 311" />
										<path
											d="M287.3 312.2c0 .5-.9 1.5.1 1.2 0-.4.7-.9-.1-1.2z"
											data-name="Pfad 312"
										/>
										<path d="M275.3 312.3l.2-.1-.5-2.7z" data-name="Pfad 313" />
										<path
											d="M266.3 320.6c1 .5-.1-1.7.9-1.1.1-.7-.8-.5-.7-1.1-.4.8-.7.5-.2 2.2z"
											data-name="Pfad 314"
										/>
										<path d="M266.5 318.5l.2-.5-.2.5z" data-name="Pfad 315" />
										<path d="M149.5 326.9l-.7-.5.5.8z" data-name="Pfad 316" />
										<path d="M148.6 329l-.4-1.7-.2 1.6c.2 0 .5-.2.6.1z" data-name="Pfad 317" />
										<path d="M231.1 329.4v-.4a.7.7 0 00-.6-.5z" data-name="Pfad 318" />
										<path d="M222.9 329.5l.1.1-.5-1.6z" data-name="Pfad 319" />
										<path
											d="M216.6 332.8c.3 0 .5-.4.8-.4-.5.4-1.2-1.6-.8.4z"
											data-name="Pfad 320"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
					<g data-name="Gruppe 30">
						<g data-name="Gruppe 29" opacity=".8">
							<g data-name="Gruppe 28">
								<g data-name="Gruppe 27">
									<g fill="currentColor" data-name="Gruppe 26">
										<path
											d="M484.3 369.5c.5.1.3-1 .4-1.2-.9.2-.4 1.5-.4 1.2z"
											data-name="Pfad 321"
										/>
										<path d="M476.3 372l.1-.4-1.2 1.1z" data-name="Pfad 322" />
										<path
											d="M468.9 371.9c.7 1.9 2.7-.3 4 .4l.2.4.6-1.6c-1.6.4-3.7 1.4-4.8.8z"
											data-name="Pfad 323"
										/>
										<path d="M464.9 367.7c.2.8-.9.6.9.2l-.2-.2h-.7z" data-name="Pfad 324" />
										<path d="M465.7 367.7c.8 0-.5-.6 0 0z" data-name="Pfad 325" />
										<path
											d="M462.1 368.1l1-.7c-.2-.4-1.1-.6-.8-.9-1 .5-.8.9-.2 1.6z"
											data-name="Pfad 326"
										/>
										<path d="M461.1 369.5l.5-.3c-.1-.1-.2-.2-.5.3z" data-name="Pfad 327" />
										<path
											d="M462.8 368.7l-1.1.6c.1.3.2.9.5-.2-.2.5.1 0 .6-.4z"
											data-name="Pfad 328"
										/>
										<path
											d="M463.4 369c.6.4 1.3.7.3 1.4 1.9-.3 1.7-1.7-.3-1.4z"
											data-name="Pfad 329"
										/>
										<path d="M468.5 373.9l.8.6.7-.6c-.4.3-1.6-.6-1.5 0z" data-name="Pfad 330" />
										<path
											d="M455.7 367.1c-.1.4.3 1.1.4 1.6l.8-.5c-.5-.3-1.2-.5-1.2-1.1z"
											data-name="Pfad 331"
										/>
										<path d="M456.1 368.7l-1.1.7c.9.1 1.1-.2 1.1-.7z" data-name="Pfad 332" />
										<path d="M460.9 371.7l1.9-1.5-2.3 1.5z" data-name="Pfad 333" />
										<path d="M451.3 367l.7-1-1.2 1.4z" data-name="Pfad 334" />
										<path
											d="M448.4 367.1c.5-.8-.6-1.3-.1-1.8a4.1 4.1 0 00-2.1 1.4 1.8 1.8 0 012.2.4z"
											data-name="Pfad 335"
										/>
										<path d="M445.2 367.6a4 4 0 001-.9 2.7 2.7 0 00-1 .9z" data-name="Pfad 336" />
										<path d="M453 369.2a1.6 1.6 0 00-.9-1.2l.4 1.2h.5z" data-name="Pfad 337" />
										<path
											d="M452.6 369.2a4.6 4.6 0 00-1-.1 5.8 5.8 0 011 .1z"
											data-name="Pfad 338"
										/>
										<path d="M453.1 369.2h-.1c0 .1.1.1.1 0z" data-name="Pfad 339" />
										<path
											d="M457.9 370.6c-.7.6-2.1 1.3-.7 2.3.4-.8-.3-1.3.7-2.3z"
											data-name="Pfad 340"
										/>
										<path d="M453.6 370.6l1.2.3c0-.3-.2-.8.1-1.1z" data-name="Pfad 341" />
										<path d="M453 371l.6-.4-.4-.1z" data-name="Pfad 342" />
										<path
											d="M447.3 368.7a2.7 2.7 0 01-1.7.6 7.8 7.8 0 002.1.4c0-.4.3-1.1-.4-1z"
											data-name="Pfad 343"
										/>
										<path d="M449.8 369a.1.1 0 00-.1.1c.1.1.1.1.1-.1z" data-name="Pfad 344" />
										<path d="M439.2 369.2l.1.2v-.2z" data-name="Pfad 345" />
										<path
											d="M447.7 369.9c.5.2.8-.1 1.1-.4a5 5 0 01-1.2.2c0 .1-.1.2.1.2z"
											data-name="Pfad 346"
										/>
										<path
											d="M443.4 368.1a4.7 4.7 0 00.9.6c-.2-.3-.8-.9-.9-.6z"
											data-name="Pfad 347"
										/>
										<path
											d="M449.5 368.8a2.3 2.3 0 00-.7.7 3.6 3.6 0 00.9-.4l-.2-.3z"
											data-name="Pfad 349"
										/>
										<path
											d="M437.1 376.6a1.5 1.5 0 012.7-.9c1.2-.8.5-4.3-.5-6.3 0 .5 0 .9-1.3 1.5.4.6 2.6 1.4 1.6 2.4-1.6.5-1.3-.4-2.1-1 .6 1.3-2 1.9-1.7 3.9l1.4-.7c.1.3-.4.8-.1 1.1z"
											data-name="Pfad 350"
										/>
										<path
											d="M441.5 369.5l.5-.1c-.6-.2-1-.6-1.7-1.5a2 2 0 00-1.1 1.3l2.4.2z"
											data-name="Pfad 351"
										/>
										<path
											d="M444.2 369.4c-.4 1.2-1.6 1.6-.9 2.9 1.4-.1 1-1 1.9-1.5-2.3.3.7-.6-1-1.3a3.5 3.5 0 011.3-.3 6.1 6.1 0 01-1.2-.5l.1.1c.1.1.1.2 0 .2l-.2.4c-.7-.3-.1-.3.1-.4v-.2l-2.3.6a4 4 0 002.2 0z"
											data-name="Pfad 352"
										/>
										<path d="M455.9 375.4a.4.4 0 01-.1-.3c-.1.2-.2.3.1.3z" data-name="Pfad 353" />
										<path
											d="M454.9 374.7c.2-.2.3-.6.9-.5.5.4 0 .6 0 .9.3-.3 1.2-.8.1-1.4l-.2.2a5.2 5.2 0 01-2-2 16.9 16.9 0 001.2 2.8z"
											data-name="Pfad 354"
										/>
										<path d="M449.5 372.4l-2 .6 1 1v-.6c1.1.2.9-.6 1-1z" data-name="Pfad 355" />
										<path d="M438.9 368.6l.3-1.2-1.1 1.7z" data-name="Pfad 356" />
										<path d="M436.4 368.7l.1-1.1-.7.7z" data-name="Pfad 357" />
										<path d="M293.6 379.6l-.6.3a1.6 1.6 0 00.6-.3z" data-name="Pfad 358" />
										<path d="M297.7 379.7l.1-.5c-.2.3-.2.5-.1.5z" data-name="Pfad 359" />
										<path
											d="M374.4 367.9c-.8-1-1.7-2.6-1.6-1.4l.2 1.2a1.6 1.6 0 011.4.2z"
											data-name="Pfad 360"
										/>
										<path
											d="M331.8 374.2a.5.5 0 01.2.4 11 11 0 01.6-1.1 5 5 0 00-.8.7z"
											data-name="Pfad 361"
										/>
										<path d="M331.1 379.1l-1.1-.8a6.3 6.3 0 001.1.8z" data-name="Pfad 362" />
										<path d="M271 380.3l-.7 1.2c1 0 .6-.6.7-1.2z" data-name="Pfad 363" />
										<path
											d="M410.5 368.8a3.2 3.2 0 00-1.8-.7c.9.7 1.6 1.7 1.8.7z"
											data-name="Pfad 364"
										/>
										<path d="M295.5 367.1c-.4.2-.5.4-.5.7.4-.2.6-.4.5-.7z" data-name="Pfad 365" />
										<path
											d="M406.7 368a1.4 1.4 0 00.4.3 4.7 4.7 0 011.7-.3c-.7-.4-1.4-.8-2.1 0z"
											data-name="Pfad 366"
										/>
										<path d="M189 377.1l-.2-.1.2.1z" data-name="Pfad 367" />
										<path
											d="M165.5 364.5a2.8 2.8 0 011-.1 4.6 4.6 0 00-1 .1z"
											data-name="Pfad 368"
										/>
										<path d="M426.3 368.1c.5-.1 0-.2 0 0z" data-name="Pfad 369" />
										<path d="M428.8 372.8a.8.8 0 00-.2.6.8.8 0 01.2-.6z" data-name="Pfad 370" />
										<path d="M427.1 368.6a4.3 4.3 0 00-.7-.4c.1.2.3.3.7.4z" data-name="Pfad 372" />
										<path d="M427 368.1a.9.9 0 00.5.1c0-.2-.1-.3-.5-.1z" data-name="Pfad 373" />
										<path
											d="M425.5 368.1a2.8 2.8 0 01.9.1l-.1-.2a1.7 1.7 0 01-.8.1z"
											data-name="Pfad 374"
										/>
										<path d="M233 375.2l-.1-.1c-.5.5-.3.4.1.1z" data-name="Pfad 375" />
										<path d="M360.2 379.9c.1 0 0-.1 0 0z" data-name="Pfad 376" />
										<path d="M358.3 380.8c.8-1.5 1.3-1.3 1.9-.9l-.6-3.4z" data-name="Pfad 377" />
										<path
											d="M283.7 379.7l1.3 1.1c-1.7 1.7-2.8 1.1-1.6 2.6.3-3.7 5.3-.3 5.5-3.9l.9.8c-.3 0-.3.2-.6.1 1.7 1.8 1.3-2.6 3.6-2.1.8.3 1.3.8.8 1.3l1.8-.9c.5.1.4.7-.1.6l2.7-.2v.1a14.9 14.9 0 011.7-1.8c.7.5-.3.4-.2.8l1.5-.9c.6 1-.7 1.9-1.7 1.7 1.3 3.7 1.2-.9 4.1 1.3l-1.4.4c.8 2.1 1.9 1.4 3.5 2.7-.4-.7-3.1-3.4-1.5-4.2.4.3 1 .4 1.9-.3 0 1.3.8 1 1.9 1l-.1 1.7c1.1-.5 1.1-1.4 1.8-2.1 1.3.2 1.5 1.5 1.8 2.7 2 .3-1.4-2.2 1-2.5 1.7.7 2.9 0 4.9-1 1.2.6-.2 1.1.2 1.6l1.1-1.4c.3 0 .2.5.1.7.9-.5.1-1.7 1.5-2.2.4-1.9 2.8 2.9 4.5.7.4.5-.2 1.1-.1 1.7a12.8 12.8 0 004-2.9l1.6 1.2c-1.2-1.3.4-2.8 1.8-4.1l-1-1.5 2.2-.9c.3.3 0 .9-.3 1.6l.4-.4c.8.7.3 1.7-.2 2.6a10.5 10.5 0 01-.8-1.1 5.7 5.7 0 00-1 3.2 1.3 1.3 0 01.7-.5 2.5 2.5 0 00-.2.7c.1.2.3-.2.7-.6l.5 1.9.1-.8 2.8 1.3c2.1-1.9 3.9-4.7 7.1-5.5-.8 1.4-.2 2.3-.3 4-.8-1.8-2.5.7-4.1.3a.7.7 0 01.4 1.3l3-1.6c-.1 1.4.6 1 1.4 1.6-.5-2.7 2.2-1.8 3.5-2.6.1.9-.2 1.8-1.7 1.6 1.6 2.1 2.2-3.2 3.7-1.4-.4 0-.5-.1-.7.3.9-.8 2.9-.1 2.4.7h-.4c2.4.4 7.2.2 7.6-2.2l-.5 3.2 4.4-7.7c-.4 2 .9 6.7-1.1 7.8a2.4 2.4 0 002.5 0c-.4-.3-.9-2.9-.4-3.1 1.4 2.2 1 1.2 2.7 3.1-.6-.4.1-3.5 1-3.4-.2.5 0 3.1-.3 3.4l2.3-3c-.6.5-.1 2.6.4 3.5-.2-.6 2 .1 2.6-.2l-1-.7c2.6.5 2.6-4.3 5.2-4-.3.6-.8 3.9.5 4.3.6-1.6 2.8-7.5 5-8.6l.4.9 1.7-1a54.5 54.5 0 01-5.9 9.1c1 .7.3 1.1 1.7 1 .5.8-.8 1.3-1.2 1.3l3.4.6c-.1-1.8 2.6-1.8 2.5-3.3l-3.7 1.8c-.1-1.8 2.2-5.1 4.6-4.8.6.7-.5 3.2-.5 3.9.3-.6 2.3-1.2 2.5-.7l-1 1c1.3.7 2.2-2.4 3.8-.6.5.1 1.6 2.4 1.7 1.3-.9-2.1-.9-8.5-.3-10.1.2.1 2.9 2 3.5 3.1.9 1.6-1.4 3.9-.7 5.3 0-.5.6-1.1.8-1.3.6.4-.3 1.5 1 1.3.2-1.8 2.5.2.6-1.6 1.2-.5 1.3.4 2.7.3-.4-1.2 1.4-4.1 2.6-4.6a2.9 2.9 0 00.3 1.4c2.5.2 3.8 1.1 6.2 1.1.2.5 1.3 1 .8 1.8a2.6 2.6 0 011.4-1c1.4 1.6-1.6.2-.6 2.2.1-1.1 1.9-1.5 2.9-2.1-.3-1.7-2.4-.4-3.4.3 0-2.3 1.9-4.7 4.3-5.7 2-.5.8 1.5 1.2 1.2 3.7.5 3.2-4 6.2-2.3 1.2 1.5 0 2.9.3 4-1.6.5-2.4-1-3.5-.9l1.3.7a1.9 1.9 0 01-2.1.4c1 1.3 6.2.3 9 1.6.5-.5 1.4-1 1-1.6l-.9.2c-.8-1.2 1.7-1.6.6-2.2 1.2-.8 2.6-2.1 4.2-1.4l.3 1.7c0-.5-1.1-1-1.6-.5.7-.7 2.6 2.3 3.4.1l-1.2-1.2c1.2-.8 2.7-2.6 4.2-2-.7-1.7-.3.2-1.4-1.8.9 2.4-3.8-.1-2.4 2.4-1.1-2.2-1.9-1-3.3-2.9 0 .5.5 1.1-.8.8a2.2 2.2 0 01-.3.5h-.1l.1.1a1.6 1.6 0 01.6.8c-.6 1.3-2.6 1.2-3.3 1.8-.7-.3.3-.6-.1-1.2l-1 1c-.1-1.2-1.9-2.1-.2-2.7l-1.6-.1a2.8 2.8 0 00-3-.5c-.7-.3-1.9 1.3-1.2.4l-2.5.7v-.3c-2.4-.2-5.1 1.9-7.8-.3a4.4 4.4 0 01-3.1.3l-.3-1.1c-1.1.4-3.2-1.1-3.6 0-1.1-2.9-5.1-.7-7-1.2l-.1 1.4a11 11 0 00-4.1.8l.1 1.2c-1.4 1-3.5-.9-5.7-.8.2-.5.7-.3 1.1 0-2.5-2.8-5.5 1.9-7.8-.1a1 1 0 01-1.4 0l.1-.1h-.2l-.8-.7a4.6 4.6 0 00.7.7 5 5 0 00-1.8.5l-.3-1.3h-.2c-.6-.5-.5.6-.2 1.6a3.5 3.5 0 00-.9.8c-.5-2.1-1.8.7-2.5-1.6-.5 1.1-3.4.8-3.8 3.1 0-.3-.2-.4.1-.5-.7-.3-1.5-.6-2.2.1l-.3-1.7-1.7 2.2c-1-1-1.4-1.6-.4-2.9-2.4 1.9-1.9.7-4 2.6l.1-1.1c-.7 0-1.9 1.4-2.3.6-1.6-2.1-8-.4-12.1-2.4.7 3.2-1.9-1.5-2.1 1-.2-.8-.8-1.2-.1-1.8-2.1.7-3.2-1.2-4.7.8-.2-.8.5-1.1.3-1.5-.2.2-.7.6-.9.2s.3-.6.7-.9c-2.2.1-2.4 2.4-2.6 4.5-1.1-1-1.6-.9-2.4.5-.4-.7-1-1.5.4-1.7-.8-.1-4.6-1.1-4.7.6-.2-.4-1.1-.1-1.3 0a20.6 20.6 0 00-3.5-.2l.5.3c-.7 2.1-1.4.4-2.7.7v-.2c-3-1.6-1.3.7-4.3-1.1l.1 1.3c-.3 2.8-2.7-1.7-4.4-.7l.6.8c-1 .9-2.6-3.9-3.6-4.2-.2-.2.3-.4.6-.6-2.5-1.7-.4 1.7-2.3 2.1-.3-.9.5-2.3-.8-2.5-.6-.8-3.7 2.9-5.4 1.1.4.7.7 1.4-.2 1.9-1.3.2-3.6-2.8-4.8-.6a.7.7 0 01-.2-.6c-1 .6-3.4.9-4 2.1-.8-4.5-6.4 2-6.3-2.1l-3.2.2.1-.4c-2-.3-2.7.7-3.5 1.6-.5-.3-.1-.7-.1-.9-2.9-.9-3.2-.7-5.7 1.3l-.2-1.4c-.7.8-4.2-2.2-7.1-.7a.9.9 0 01.3-.6c-3.3 1.5-7.7-3.9-9 .9l-2.2 1.2c2.8.5-.5 2.1.7 3-1.1.3-2.8-1.6-1.4-1.8l.2.3c.6-2.5-3.4-1-3.3-2.7-5.5 0-10.7-1.6-15.9-1.8l.5 2-1.8-.2c-.5-.5-.6-1.6.7-1.5-.6-1.1-2.2.9-2.2 1.3-2.5-.9 1-2.3.3-2.4l-1 .1.2.2c-.9.8-1 1.6-2.5 1.5-1-.4-.5-1.2-.8-1.3 0-.1-.1-.2-.6-.1l-2.2-.2.9 1.6c-1 .7-2.1-.1-1.1 1.7-1.4-2.8-8.4-1.2-9.3-2.1-1.4 1.1-2.8 1-4.5.9.4.3.6 2.1-.8 1.9.6-3.6-2.7-1.7-3.8-4.3 1 1.8-4.2.3-2.6 2.8-1.2-.3 0-1.4-.9-2.2-3 1.3-6.4-1.1-10-.7-.1.5.5 1.2-.3 1.9l-1.8-2.4c-.7.2-.7 2.7-2 1 .2.4.4 1-.1 1.2-7-2.5-14.5 1.5-21.6-3.1.9 1 .3 1-.5 1 .5.2 0 1.2 0 1.8l-3-1.9c-.6 1.8-3.2 0-3.6 1.7l1-.3c-1.3 2 1.6 4.6 1.4 7.2 1.5-2.3 3.6 3.5 6.1.3.5.5-.5.8-.2 1.4.6-1.1 1.3-1.3 2.7-.8l-.2.3c3.7-.2 5.3 1 9.4 1.9l-.3-1.3a3 3 0 011.5.9c1.1-1.9-2.5-.2-1.5-2.3 1.1 2.7 6.3.2 7 3.2 1.4.1-.4-1.5 1-1.4l.3.8.4-1a2 2 0 011.3 1.9c-.2-.1-.6.2-.9.2 1.1 1 3.3-.2 3.7.1l-1.3-.5c3.8-.6 8.3.6 12-1l-.3-.6c2.8-1 2.2.7 5.3.3l-.1.1a2.7 2.7 0 012.3-.8c-.8.7 1.4 1.4.4 2.2 3-1.1 1.5-.9 3.6-3.1l.4 1c.7-.9.8-1.4 2.3-1.6-1.3.8.9 1.6-.5 2.7 3.1 2.3 4.8-2.1 6.2 1.2 1.5-2.7-2.7-1.6-1.9-2.2-.7-.9 1.3-2.1 2.3-1.7 1 .1 1.6 3.6 4.2 3.6-.3 0-.3.2-.5.2.9.7 1.9-.9 3.1.3.7-1.7 1.5.1 1.8-2l-2.4.4c1.3-.5 2.7-3 4.8-1.7a5.3 5.3 0 01-1.3 1.3c.6.7 1.2-.4 1.9.3-.2 2.1-2.9.4-4.3 2 .7.9 2.7-1.5 2 .8 1.1-2.9 2.5.4 4.3-1.8l-.1 1.3c.3-.2.9-.8 1.4-.7l-1 1.6c1.4-1.4 2.7 1.3 4.1.6-2.8 0-.6-1.6-1.8-2.5 3.5-1.6 1.9 3.4 5.8 2.9-.5.2-2-.8-1.1-1.4a4.5 4.5 0 012.1 1.5c2.6-.2-.4-1.3.8-2.1.8 1.6 1.3-.6 2.4-1.1v1.3c2.9.9.9-2.7 3.5-1.6l-1.2 1.8 1.4-.4-.3 1.5c1.5-1.1 2-.8 3.5-.3a1.9 1.9 0 011.6-2.4c.9.8-.5 1.2 1.3 1.1-.4.8-.9 1.8-1.7.6l-.5 1.2c.9.9 2.4.3 3.1.3-.3-.1-.6-.1-.7-.3l2.7-1.7c.4.5.1.9-.3 1.3.5-.1.9-.7 1.7-.8-.2 1.1-.2 2.2-1.4 2.6l2.6-1.1c.2.5 1.3 1.3.9 1.7 1.4.7 3.5-2 5.4-1.1a1 1 0 01.7-.5c1.8.3 3.3 1.6 5.4.2l1.1 1.9c1.6-.4-1.6-2.4 1.2-3.1 1.9-.6.7 1.6 1.3 2.2 1-.9 2.7-2.9 4.4-1.3h-1.4zm20.2-.4c-.4.3-1.2 1.1-1.5.3.5-1.5.8-.8 1.5-.3zm30.8-2.5c-.3.4-.7.2-1.2-.3a1.2 1.2 0 011.2.3zm85.7-7.7c-.9-.5-.6-.3 0 0zm1.8.6c.2-.2.2-.4.1-.5-.1.3-.5.3-1 .2.1.3.3.5.9.3zm-194.7-3.5l.3.4c-.7.3-.5 0-.3-.4z"
											data-name="Pfad 378"
										/>
										<path d="M331.2 378.5l-.2-.7c-.1.2-.2.4.2.7z" data-name="Pfad 379" />
										<path d="M271.1 380.1l-.1.2z" data-name="Pfad 380" />
										<path d="M393.9 380.4a1.2 1.2 0 01-.7-.7c0 .3.2.6.7.7z" data-name="Pfad 381" />
										<path
											d="M431.8 367.6l-1.2.3a1 1 0 011 .4c.1-.3-.2-.7.2-.7z"
											data-name="Pfad 382"
										/>
										<path
											d="M441.8 375.8c.2-.2.4 0 .5-.2v-.6c-.7 0-1.3.5-.5.8z"
											data-name="Pfad 383"
										/>
										<path
											d="M432.8 371.9c.1 1.1.8.7 1.6.5h-.1c.3-1.5-.6-1-1.5-.5z"
											data-name="Pfad 384"
										/>
										<path
											d="M434.6 372.4a2.2 2.2 0 01.8 0c.1-.6-.3-.1-.8 0z"
											data-name="Pfad 385"
										/>
										<path d="M424.5 369c.4.3.3-1.4.5-1 .4-1.4-2.6 1.7-.5 1z" data-name="Pfad 386" />
										<path d="M433.4 375.6l-.2-1.4-.5 1.1z" data-name="Pfad 387" />
										<path
											d="M427 374.5l1.3.4a.7.7 0 01.4-.5c-.8 0-1.7-.3-1.7.1z"
											data-name="Pfad 388"
										/>
										<path
											d="M428.7 374.4a1.5 1.5 0 001-.2 4.4 4.4 0 00-1 .2z"
											data-name="Pfad 389"
										/>
										<path d="M431.7 375.9l-.4-.2-.9-.2z" data-name="Pfad 390" />
										<path d="M413.1 374l-1.4.4c-.2.5.2.8.8.6.2-.3.8-.5.6-1z" data-name="Pfad 391" />
										<path d="M417.3 377.8c-.4-.3-.4-.6-.6-1l-.1 1.7z" data-name="Pfad 392" />
										<path
											d="M413.2 378.1c-.1.5-2.1 1.3-.3 1.2.1-.4 1.6-.7.3-1.2z"
											data-name="Pfad 393"
										/>
										<path d="M391.8 375.7h.4v-2.8z" data-name="Pfad 394" />
										<path
											d="M372.9 382c1.7.7.4-1.7 1.9-.8.4-.6-1.2-.7-.8-1.3-1.1.7-1.6.3-1.1 2.1z"
											data-name="Pfad 395"
										/>
										<path
											d="M374 379.9a1.8 1.8 0 00.5-.4 2.7 2.7 0 00-.5.4z"
											data-name="Pfad 396"
										/>
										<path d="M161.6 362.9l-1-.6.6.9z" data-name="Pfad 397" />
										<path d="M159.5 364.9l-.2-1.8-.7 1.6c.2-.1.7-.2.9.2z" data-name="Pfad 398" />
										<path d="M306.8 382.9l.1-.4c-.2-.5-.4-.5-.9-.6z" data-name="Pfad 399" />
										<path d="M292.2 381.3h.2l-.4-1.6z" data-name="Pfad 400" />
										<path
											d="M279.8 383c.5.1 1.1-.3 1.6-.2-1.1.3-1.7-1.8-1.6.2z"
											data-name="Pfad 401"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
					<g data-name="Gruppe 35">
						<g data-name="Gruppe 34">
							<g data-name="Gruppe 33">
								<g data-name="Gruppe 32">
									<g fill="currentColor" data-name="Gruppe 31">
										<path d="M324.6 299c.3 0 .1-.5.1-.6-.4.2-.1.8-.1.6z" data-name="Pfad 402" />
										<path d="M320.5 301.1l.1-.2-.6.6z" data-name="Pfad 403" />
										<path
											d="M316.5 301.8c.6.9 1.4-.4 2.2-.2l.2.2.2-.8c-.9.3-1.9 1-2.6.8z"
											data-name="Pfad 404"
										/>
										<path
											d="M314 300.2c.2.3-.4.4.5 0a.1.1 0 01-.1-.1l-.4.1z"
											data-name="Pfad 405"
										/>
										<path d="M314.4 300.1c.4-.1-.3-.2 0 0z" data-name="Pfad 406" />
										<path
											d="M312.5 300.7l.5-.4c-.2-.2-.7-.2-.5-.3-.6.2-.4.4 0 .7z"
											data-name="Pfad 407"
										/>
										<path d="M312.1 301.5l.3-.2c-.1-.1-.2-.1-.3.2z" data-name="Pfad 408" />
										<path
											d="M312.9 300.9l-.6.4c.1.1.2.4.3-.2 0 .3.1 0 .3-.2z"
											data-name="Pfad 409"
										/>
										<path d="M313.3 301c.4.1.8.2.3.6 1-.3.7-1-.3-.6z" data-name="Pfad 410" />
										<path d="M316.5 302.9l.5.2.3-.4c-.2.2-.9-.1-.8.2z" data-name="Pfad 411" />
										<path d="M308.9 300.9l.4.8.4-.3c-.3-.2-.7-.3-.8-.5z" data-name="Pfad 412" />
										<path d="M309.3 301.6l-.6.5c.6-.1.7-.3.6-.5z" data-name="Pfad 413" />
										<path d="M312.2 302.6l.8-.9-1 .9z" data-name="Pfad 414" />
										<path d="M306.5 301.3l.3-.6-.5.9z" data-name="Pfad 415" />
										<path
											d="M305 301.6c.2-.4-.5-.6-.2-.9a2.1 2.1 0 00-1 .9 1.3 1.3 0 011.2 0z"
											data-name="Pfad 416"
										/>
										<path d="M303.3 302.2l.5-.5a.8.8 0 00-.5.5z" data-name="Pfad 417" />
										<path d="M307.7 302.2a1 1 0 00-.6-.5l.3.5z" data-name="Pfad 418" />
										<path d="M307.4 302.2h-.5.5z" data-name="Pfad 419" />
										<path
											d="M310.5 302.4c-.3.4-1 .9-.2 1.2.2-.5-.3-.7.2-1.2z"
											data-name="Pfad 421"
										/>
										<path d="M308.2 302.8h.7c0-.1-.2-.3 0-.5z" data-name="Pfad 422" />
										<path d="M307.9 303.1l.3-.3h-.3z" data-name="Pfad 423" />
										<path
											d="M304.5 302.5a1.3 1.3 0 01-.9.5h1.2c0-.2.1-.6-.3-.5z"
											data-name="Pfad 424"
										/>
										<path d="M305.9 302.4c0 .1.1.1 0 0z" data-name="Pfad 425" />
										<path d="M300.2 303.6l.1.1v-.1z" data-name="Pfad 426" />
										<path d="M304.9 303.1c.3.1.4-.1.6-.3a.7.7 0 00-.6.3z" data-name="Pfad 427" />
										<path d="M302.4 302.6a1.7 1.7 0 00.5.2l-.5-.2z" data-name="Pfad 428" />
										<path d="M305.8 302.3c-.1-.1-.1 0 0 0z" data-name="Pfad 429" />
										<path d="M305.8 302.3l-.3.4a1.4 1.4 0 00.4-.3l-.1-.1z" data-name="Pfad 430" />
										<path
											d="M299.8 307.5a.8.8 0 011.3-.7c.6-.5-.2-2.2-.9-3 0 .2.1.4-.5.9.3.2 1.6.4 1.1 1-.8.4-.7-.1-1.2-.3.5.6-.9 1.2-.5 2.1l.7-.5c0 .1-.2.4 0 .5z"
											data-name="Pfad 431"
										/>
										<path
											d="M301.5 303.6l.3-.1a2.5 2.5 0 01-1.1-.5c-.4.3-.5.6-.4.7l1.2-.1z"
											data-name="Pfad 432"
										/>
										<path
											d="M303 303.2c-.1.6-.7 1-.2 1.5.8-.2.5-.6.9-.9-1.3.4.3-.4-.7-.6a2.5 2.5 0 01.7-.2l-.7-.1c.1.1.1.1 0 .1v.2c-.4-.1-.1-.1 0-.2v-.1l-1.2.5c.2.1.6 0 1.2-.2z"
											data-name="Pfad 433"
										/>
										<path d="M309.8 304.9l-.1-.1c0 .1 0 .2.1.1z" data-name="Pfad 434" />
										<path
											d="M309.3 304.7c.1-.1.1-.3.4-.3.3.1 0 .3.1.5.2-.2.6-.5-.1-.7l-.1.1a2.9 2.9 0 01-1.3-.8 9 9 0 001 1.2z"
											data-name="Pfad 435"
										/>
										<path d="M306.1 304.1l-1 .5.6.4-.1-.3c.7 0 .5-.3.5-.6z" data-name="Pfad 436" />
										<path d="M300 303.4v-.7l-.4 1z" data-name="Pfad 437" />
										<path d="M298.7 303.7l-.1-.5-.3.4z" data-name="Pfad 438" />
										<path d="M222.7 324.5l-.3.2c.2 0 .3-.1.3-.2z" data-name="Pfad 439" />
										<path d="M225 324.2v-.3q-.2.3 0 .3z" data-name="Pfad 440" />
										<path
											d="M265.1 310c-.5-.4-1.2-1.1-1-.5l.2.6a.8.8 0 01.8-.1z"
											data-name="Pfad 441"
										/>
										<path d="M242.7 317.7l.2.2.2-.6z" data-name="Pfad 442" />
										<path d="M242.9 320.2l-.7-.3a4.9 4.9 0 00.7.3z" data-name="Pfad 443" />
										<path d="M210.6 327.4l-.3.7c.6-.1.3-.4.3-.7z" data-name="Pfad 444" />
										<path d="M284.7 306.5a2.2 2.2 0 00-1-.2c.5.3 1 .7 1 .2z" data-name="Pfad 445" />
										<path d="M222.5 318.2a.4.4 0 00-.2.4.5.5 0 00.2-.4z" data-name="Pfad 446" />
										<path
											d="M282.5 306.5a.3.3 0 01.2.1 2.4 2.4 0 01.9-.3 1 1 0 00-1.1.2z"
											data-name="Pfad 447"
										/>
										<path d="M166 334.7a.1.1 0 01-.1-.1l.1.1z" data-name="Pfad 448" />
										<path d="M152.1 330.6a.7.7 0 01.5-.1 1.8 1.8 0 00-.5.1z" data-name="Pfad 449" />
										<path d="M293.1 304.5c.3-.1.1-.1 0 0z" data-name="Pfad 450" />
										<path d="M295 306.5l-.1.3a.4.4 0 01.1-.3z" data-name="Pfad 451" />
										<path d="M293.6 304.7a.6.6 0 00-.4-.1.8.8 0 01.4.1z" data-name="Pfad 453" />
										<path d="M293.5 304.4h.3c0-.1-.1-.2-.3 0z" data-name="Pfad 454" />
										<path d="M292.7 304.6h.5a.1.1 0 01-.1-.1.8.8 0 00-.4.1z" data-name="Pfad 455" />
										<path d="M257.7 318c.3-.8.6-.8.9-.7l-.7-1.6z" data-name="Pfad 458" />
										<path
											d="M217.4 325.7l.8.4c-.7 1-1.4.8-.6 1.4-.2-1.8 2.8-.7 2.6-2.5l.6.3-.3.1c1.1.7.5-1.4 1.7-1.4.4.1.8.3.5.5l.9-.6c.3 0 .3.3 0 .3l1.4-.4v.1l.7-1.1c.4.2-.1.2 0 .4l.7-.6c.4.4-.2 1-.7 1 1.1 1.7.6-.6 2.4.2l-.7.4c.7.9 1.2.5 2.2.9-.3-.3-2-1.3-1.2-1.9.3.1.6.1 1-.4.1.6.5.4 1.1.3l.1.9c.6-.4.4-.8.7-1.2.7 0 1 .6 1.2 1.1 1.1-.1-1-.9.3-1.3 1 .2 1.5-.3 2.5-1 .7.2 0 .5.3.7l.4-.8.1.3c.4-.4-.1-.9.6-1.2 0-1 1.8 1.1 2.5-.1.3.2 0 .5.1.9a8.1 8.1 0 001.9-1.8l1 .4c-.8-.5-.1-1.4.5-2.2a3.2 3.2 0 00-.7-.6l1.1-.7c.2.1.1.4 0 .8l.2-.2c.5.2.4.8.1 1.3l-.5-.4a2.6 2.6 0 00-.2 1.7l.3-.3c0 .2-.1.3 0 .4s.1-.1.3-.4l.4.9v-.4l1.6.3c.9-1.2 1.6-2.7 3.3-3.5-.3.8.1 1.2.2 2-.6-.8-1.3.6-2.2.6a.4.4 0 01.4.6l1.5-1.1c.1.7.4.4.9.6-.6-1.3 1-1.1 1.6-1.6.1.4.1.9-.8 1 1.1.8.8-1.8 1.9-1.1-.2 0-.3 0-.3.2.4-.5 1.5-.4 1.4.1h-.2c1.3-.1 3.9-.7 3.9-1.9a8.5 8.5 0 010 1.6l1.6-4.2c0 1 1.2 3.2.2 3.9a1.2 1.2 0 001.3-.3c-.2-.1-.8-1.3-.5-1.5 1 .9.7.5 1.8 1.2-.4-.2-.3-1.7.2-1.8a9.9 9.9 0 01.2 1.7l1-1.7c-.3.3.2 1.3.5 1.7-.2-.3 1.1-.2 1.4-.4l-.6-.3c1.4 0 1-2.4 2.4-2.5-.1.3-.1 2 .7 2 .2-.8.7-4 1.9-4.8l.3.4.8-.7a29.4 29.4 0 01-2.3 5.1c.6.3.2.5 1 .3.4.4-.3.7-.5.8l1.9-.1c-.2-.9 1.2-1.2 1-1.9l-1.8 1.3c-.2-.9.7-2.8 2-2.8.4.3.1 1.6.1 1.9.1-.3 1.1-.8 1.3-.6l-.5.6c.8.2.9-1.4 2-.7.3 0 1.1 1 1.1.5a10.1 10.1 0 01-1.2-4.9 11 11 0 012.2 1.1c.6.7-.4 2.1.2 2.7a1.5 1.5 0 01.3-.7c.4.2 0 .8.7.5-.1-.9 1.4-.2.2-.8.6-.4.7.1 1.5-.1-.4-.5.3-2.1.9-2.5a1.1 1.1 0 00.3.6c1.4-.2 2.2.1 3.5-.1.2.2.8.4.6.8.2-.2.3-.5.7-.6.9.6-.8.3-.1 1.1 0-.5.9-.9 1.4-1.4-.3-.8-1.3.1-1.8.5a3.5 3.5 0 011.8-3.3c1-.5.6.6.7.4 2-.2 1.3-2.3 3.1-1.8.8.6.3 1.4.5 1.9-.8.4-1.4-.2-2-.1l.8.2c-.2.3-.8.6-1.1.4.7.5 3.4-.5 5-.2.2-.3.6-.6.4-.9l-.5.2c-.6-.5.8-1 .1-1.1.6-.5 1.2-1.3 2.2-1.1l.3.8c-.1-.2-.7-.4-.9-.1.3-.4 1.6.8 1.8-.3l-.7-.4c.6-.5 1.2-1.5 2.1-1.4-.5-.7-.2.1-.9-.7.7 1.1-2.1.3-1 1.4-.8-1-1.1-.3-2.1-1.1.1.3.4.5-.3.5l-.1.3a1.4 1.4 0 01.4.3c-.2.7-1.3.9-1.6 1.3-.4-.1.1-.3-.2-.6l-.5.6c-.2-.6-1.3-.8-.4-1.3l-.9.1a2 2 0 00-1.7.1c-.4-.1-.9.9-.6.3l-1.3.6v-.1c-1.3.2-2.5 1.5-4.2.7a3 3 0 01-1.6.5l-.2-.5c-.5.3-1.8-.2-2 .4-.9-1.3-2.8.2-3.9.1l.1.7a6.9 6.9 0 00-2.1.8l.2.6c-.6.6-2-.1-3.1.2 0-.2.3-.2.6-.1-1.6-1.1-2.8 1.5-4.2.8-.3.3-.5.2-.8.1l-.5-.2a1.4 1.4 0 01.4.3 6.3 6.3 0 00-.9.4l-.3-.6h-.1c-.4-.2-.2.4 0 .8a1 1 0 00-.4.5c-.5-1-.9.5-1.5-.5-.1.6-1.7.7-1.7 1.9 0-.1-.2-.2 0-.2a1.1 1.1 0 00-1.2.3l-.3-.8-.7 1.3c-.6-.4-.9-.6-.5-1.4-1.1 1.2-1 .6-1.9 1.7v-.5c-.4.1-.9.9-1.2.5-1.1-.8-4.3.7-6.8.1.7 1.5-1.2-.5-1 .7-.2-.3-.5-.5-.2-.9-1.1.6-1.8-.3-2.4.9-.2-.3.1-.6 0-.8-.1.1-.3.4-.5.2s.1-.3.3-.5c-1.2.3-1.1 1.4-1 2.5-.7-.4-1-.3-1.3.5-.3-.3-.7-.6 0-.9-.4 0-2.6 0-2.5.8-.2-.2-.6 0-.7.2a12.5 12.5 0 00-1.9.3l.3.1c-.2 1.1-.7.4-1.4.6v-.1c-1.8-.4-.7.5-2.5-.1l.2.6c.1 1.4-1.6-.5-2.5.2l.4.3c-.4.6-1.8-1.6-2.4-1.7-.1-.1.1-.2.3-.3-1.5-.6 0 .9-1 1.3-.3-.4 0-1.2-.7-1.2-.4-.3-1.7 1.8-2.8 1.1.3.3.5.6.1 1-.7.3-2.2-1-2.7.3l-.2-.2c-.5.4-1.7.8-1.9 1.5-.9-2.1-3.3 1.7-3.6-.3l-1.7.4v-.2a1.8 1.8 0 00-1.7 1.2c-.3-.1-.1-.3-.1-.4-1.7-.1-1.8 0-3 1.3l-.3-.6c-.3.5-2.5-.6-3.9.4a.4.4 0 01.1-.3c-1.6 1.1-4.5-1.1-4.7 1.5l-1.1.8c1.5-.1 0 1.1.7 1.4-.6.2-1.7-.4-1-.7l.1.1c0-1.3-1.9-.1-2.1-1-2.9.6-5.9.4-8.7.9l.5.9-1 .1c-.3-.2-.5-.7.2-.8-.5-.5-1.1.7-1.1.9-1.4-.2.3-1.2-.1-1.2l-.5.2.1.1c-.4.5-.4.9-1.2 1-.6-.1-.4-.6-.6-.6q0-.2-.3 0l-1.2.1.6.7c-.5.5-1.2.2-.4.9-1.1-1.2-4.6.3-5.2 0a3.3 3.3 0 01-2.3.9c.3.1.5 1-.3 1 0-1.8-1.6-.5-2.4-1.7.7.8-2.2.6-1.1 1.7-.7 0-.1-.7-.7-1-1.5.9-3.6.1-5.5.6 0 .2.4.6 0 1l-1.2-1c-.4.2-.1 1.4-1 .7.1.2.3.5.1.6-4-.6-7.7 2.1-11.9.5.6.4.2.5-.2.6.3.1.1.6.2.9l-1.8-.7c-.2.9-1.7.3-1.8 1.2l.5-.2c-.6 1.1 1.3 2.1 1.3 3.4.6-1.2 2.3 1.4 3.3-.4.3.2-.2.4 0 .7.2-.6.6-.8 1.4-.6l-.1.1c2-.4 3 0 5.3 0l-.3-.6c.5 0 .6.2.9.3.4-1-1.4.1-1-1 .8 1.2 3.5-.5 4.1.9.8-.1-.3-.7.4-.8l.3.4.1-.5c.5 0 .8.5.9.8a1.7 1.7 0 00-.5.2c.7.4 1.8-.4 2-.3l-.8-.1c2-.7 4.6-.6 6.4-1.7l-.2-.3c1.4-.8 1.3.1 2.9-.4v.1a1.4 1.4 0 011.2-.6c-.4.4.9.5.4 1 1.5-.9.7-.6 1.6-1.9l.3.5c.3-.5.3-.8 1.1-1-.6.5.7.7 0 1.4 1.9.8 2.4-1.5 3.5-.1.6-1.5-1.6-.5-1.2-.9-.5-.4.5-1.1 1-1.1.6-.1 1.2 1.6 2.6 1.3l-.3.1c.6.3.9-.7 1.7-.2.2-.9.8-.1.8-1.2l-1.2.5c.7-.4 1.1-1.8 2.4-1.4a4.2 4.2 0 01-.6.8c.4.3.6-.3 1.1-.1.1 1.1-1.5.5-2.1 1.5.5.4 1.3-1 1.1.2.3-1.6 1.4-.1 2.2-1.3l.1.6c.1-.1.4-.5.7-.5l-.4.9c.6-.8 1.6.3 2.2-.2-1.5.3-.5-.7-1.2-1 1.7-1.2 1.4 1.5 3.4.8-.3.1-1.1-.2-.7-.6a3 3 0 011.3.5c1.4-.4-.3-.6.2-1.1.6.7.6-.4 1.2-.8l.1.6c1.7.1.2-1.4 1.7-1.2l-.4 1 .7-.4v.8c.7-.7 1-.6 1.8-.5a.9.9 0 01.6-1.3c.6.3-.2.7.8.4-.2.4-.3 1-.9.5a2.5 2.5 0 01-.2.7c.6.3 1.3-.1 1.7-.2a.6.6 0 01-.4-.1l1.3-1.2c.3.2.1.4 0 .7.3-.1.4-.5.9-.6 0 .5.1 1.1-.5 1.4l1.3-.8c.1.2.8.5.7.7.8.2 1.7-1.4 2.8-1.1q0-.2.3-.3c1-.1 1.9.4 2.9-.5l.8.8c.8-.4-1.1-1 .3-1.6 1-.5.5.7 1 .9.4-.6 1.2-1.7 2.3-1.1a.7.7 0 00-.8-.3zm10.8-2.4c-.2.2-.5.7-.8.3.2-.8.4-.5.8-.3zm16.4-4.7c-.1.2-.4.2-.7 0a.8.8 0 01.7 0zm45.4-13c-.5-.1-.3-.1 0 0zm1.1.1a.2.2 0 000-.3c0 .2-.3.2-.5.2.1.2.2.3.5.1zm-105.3 19.6l.2.1c-.4.3-.3.1-.2-.1z"
											data-name="Pfad 459"
										/>
										<path d="M242.9 319.9l-.2-.3c-.1.1 0 .2.2.3z" data-name="Pfad 460" />
										<path d="M210.7 327.3z" data-name="Pfad 461" />
										<path d="M276.9 314a2.2 2.2 0 01-.5-.3c0 .2.2.3.5.3z" data-name="Pfad 462" />
										<path
											d="M296.1 303.6l-.6.3a.6.6 0 01.6.1c-.1-.1-.2-.3 0-.4z"
											data-name="Pfad 463"
										/>
										<path d="M302.3 306.6l.3-.1-.1-.3c-.4.1-.7.3-.2.4z" data-name="Pfad 464" />
										<path d="M297 305.7c.2.5.5.3.9.1h-.1c.1-.8-.3-.5-.8-.1z" data-name="Pfad 465" />
										<path d="M298.1 305.7a.6.6 0 01.4-.1c0-.3-.2 0-.4.1z" data-name="Pfad 466" />
										<path d="M292.2 305.1c.2.1 0-.7.2-.5.1-.8-1.2 1.1-.2.5z" data-name="Pfad 467" />
										<path d="M297.7 307.4l-.3-.7-.1.6z" data-name="Pfad 468" />
										<path
											d="M294.2 307.5l.7.1a.4.4 0 01.1-.3c-.4.1-.9 0-.8.2z"
											data-name="Pfad 469"
										/>
										<path d="M295 307.3a.8.8 0 00.5-.2 4.7 4.7 0 00-.5.2z" data-name="Pfad 470" />
										<path d="M296.8 307.8l-.2-.1h-.5z" data-name="Pfad 471" />
										<path
											d="M286.6 308.8l-.7.3c0 .2.2.3.5.2.1-.2.3-.3.2-.5z"
											data-name="Pfad 472"
										/>
										<path d="M289.2 310.2a.8.8 0 01-.4-.4l.1.8z" data-name="Pfad 473" />
										<path d="M287 310.8c0 .2-1 .9 0 .6 0-.2.8-.5 0-.6z" data-name="Pfad 474" />
										<path d="M275.3 311.9h.2l-.3-1.4z" data-name="Pfad 475" />
										<path
											d="M265.7 317c1 .2.1-.9 1-.6.2-.4-.7-.2-.6-.5-.5.4-.8.3-.4 1.1z"
											data-name="Pfad 476"
										/>
										<path d="M266.1 315.9l.2-.3-.2.3z" data-name="Pfad 477" />
										<path d="M149.9 330.2l-.6-.2.4.4z" data-name="Pfad 478" />
										<path d="M148.9 331.3l-.2-.9-.3.8c.1.1.4-.1.5.1z" data-name="Pfad 479" />
										<path d="M230.2 324.7v-.2c-.1-.2-.3-.2-.6-.2z" data-name="Pfad 480" />
										<path d="M222.1 325.5h.2l-.4-.7z" data-name="Pfad 481" />
										<path d="M215.7 327.8c.3 0 .6-.3.8-.3-.6.2-1.1-.7-.8.3z" data-name="Pfad 482" />
									</g>
								</g>
							</g>
						</g>
					</g>
					<g data-name="Gruppe 40">
						<g data-name="Gruppe 39" opacity=".8">
							<g data-name="Gruppe 38">
								<g data-name="Gruppe 37">
									<g fill="currentColor" data-name="Gruppe 36">
										<path d="M336.5 331.5c.2.1 0-.8 0-.9-.3.2 0 1.1 0 .9z" data-name="Pfad 483" />
										<path d="M333.8 333.8v-.4l-.3.9z" data-name="Pfad 484" />
										<path
											d="M331.1 334.1c.4 1.4 1-.4 1.5.1l.1.3.1-1.2c-.6.3-1.2 1.1-1.7.8z"
											data-name="Pfad 485"
										/>
										<path d="M329.2 331.2c.2.5-.3.5.4.1a.1.1 0 00-.1-.1z" data-name="Pfad 486" />
										<path d="M329.5 331.2c.3-.1-.2-.5 0 0z" data-name="Pfad 487" />
										<path
											d="M328.2 331.7l.3-.5c-.1-.3-.5-.4-.4-.6-.3.2-.2.6.1 1.1z"
											data-name="Pfad 488"
										/>
										<path d="M328 332.8l.2-.2c-.1-.2-.1-.3-.2.2z" data-name="Pfad 489" />
										<path d="M328.5 332l-.4.5c.1.2.2.7.2-.2.1.5.1 0 .2-.3z" data-name="Pfad 490" />
										<path d="M328.8 332.2c.3.3.6.4.2 1 .7-.3.5-1.3-.2-1z" data-name="Pfad 491" />
										<path d="M331.1 335.6l.3.4.2-.5c0 .2-.5-.3-.5.1z" data-name="Pfad 492" />
										<path
											d="M325.8 331.2a7 7 0 00.3 1.2l.2-.4c-.1-.2-.4-.3-.5-.8z"
											data-name="Pfad 493"
										/>
										<path d="M326.1 332.4l-.4.6c.4 0 .5-.3.4-.6z" data-name="Pfad 494" />
										<path d="M328.1 334.4l.6-1.2-.7 1.2z" data-name="Pfad 495" />
										<path d="M324.2 331.4l.1-.7-.3 1.1z" data-name="Pfad 496" />
										<path
											d="M323.1 331.7c.1-.6-.4-1-.2-1.3-.3.1-.5.7-.6 1.2.2-.4.4-.4.8.1z"
											data-name="Pfad 497"
										/>
										<path
											d="M322 332.2a4.9 4.9 0 00.3-.7 1.5 1.5 0 00-.3.7z"
											data-name="Pfad 498"
										/>
										<path d="M325 332.9c-.1-.2-.2-.7-.4-.8l.3.8z" data-name="Pfad 499" />
										<path d="M324.8 333h-.4c.1-.1.2-.1.4 0z" data-name="Pfad 500" />
										<path
											d="M326.9 333.7c-.2.5-.6 1.1 0 1.8.1-.6-.2-1 0-1.8z"
											data-name="Pfad 502"
										/>
										<path d="M325.4 334l.5.1c0-.2-.2-.5-.1-.8z" data-name="Pfad 503" />
										<path d="M325.2 334.3l.2-.3-.2-.1z" data-name="Pfad 504" />
										<path
											d="M322.9 332.9a.6.6 0 01-.6.5 3 3 0 00.8.2c0-.3 0-.8-.2-.7z"
											data-name="Pfad 505"
										/>
										<path d="M323.8 333c0 .1.1.1 0 0z" data-name="Pfad 506" />
										<path d="M319.9 333.7a.3.3 0 00.1.2l-.1-.2z" data-name="Pfad 507" />
										<path d="M323.1 333.7c.2.1.3-.1.4-.4a.8.8 0 01-.4.2z" data-name="Pfad 508" />
										<path d="M321.4 332.7l.4.4c-.1-.3-.4-.7-.4-.4z" data-name="Pfad 509" />
										<path d="M323.7 332.8c-.1-.2 0-.1 0 0z" data-name="Pfad 510" />
										<path d="M323.7 332.8l-.2.6.3-.3-.1-.3z" data-name="Pfad 511" />
										<path
											d="M319.9 339.3c-.1-.8.3-1.6.9-.8.4-.7-.3-3.2-.8-4.7a1.5 1.5 0 01-.3 1.2c.2.4 1.1.9.8 1.7-.5.5-.5-.2-.9-.6.4 1-.6 1.5-.2 3l.4-.6.1.8z"
											data-name="Pfad 512"
										/>
										<path d="M320.8 333.8l.2-.1-.8-1a1.4 1.4 0 00-.3 1h.9z" data-name="Pfad 513" />
										<path
											d="M321.8 333.6c0 .9-.4 1.3 0 2.2.5-.1.3-.8.5-1.2-.8.4.2-.5-.5-1l.5-.2-.5-.3v.1c.1.1.1.2 0 .1v.3c-.3-.2-.1-.2 0-.3v-.1l-.8.6a1.5 1.5 0 00.8-.2z"
											data-name="Pfad 514"
										/>
										<path d="M326.7 337.4l-.1-.2.1.2z" data-name="Pfad 515" />
										<path
											d="M326.3 336.9c0-.1.1-.5.3-.4.2.2.1.4.1.7.1-.2.3-.7-.1-1v.1c-.4-.3-1-1.3-.9-1.4a4.7 4.7 0 00.6 2z"
											data-name="Pfad 516"
										/>
										<path d="M324.1 335.5l-.7.5.5.7-.1-.4c.4.1.2-.4.3-.8z" data-name="Pfad 517" />
										<path d="M319.8 333.3v-.9l-.3 1.3z" data-name="Pfad 518" />
										<path d="M318.9 333.5l-.1-.8-.2.5z" data-name="Pfad 519" />
										<path d="M267.8 350.1l-.2.3.2-.3z" data-name="Pfad 520" />
										<path d="M269.3 350v-.4c0 .2-.1.4 0 .4z" data-name="Pfad 521" />
										<path
											d="M296.1 336.5c-.4-.7-.9-1.8-.7-.9l.2.9c.2-.2.3-.1.5 0z"
											data-name="Pfad 522"
										/>
										<path d="M281.2 343.8l.1.3.1-.9a.8.8 0 00-.2.6z" data-name="Pfad 523" />
										<path d="M281.4 347.4l-.5-.5z" data-name="Pfad 524" />
										<path d="M259.6 352.1l-.1.9c.4 0 .1-.4.1-.9z" data-name="Pfad 525" />
										<path d="M309.4 335.1c-.3-.3-.5-.4-.7-.4.4.4.7 1.1.7.4z" data-name="Pfad 526" />
										<path
											d="M267.2 340.8a1.3 1.3 0 00-.1.6 1.3 1.3 0 00.1-.6z"
											data-name="Pfad 527"
										/>
										<path
											d="M307.9 334.7l.2.2a.9.9 0 01.6-.3c-.3-.3-.6-.5-.8.1z"
											data-name="Pfad 528"
										/>
										<path d="M219.7 346.7l.4-.1a.6.6 0 00-.4.1z" data-name="Pfad 530" />
										<path d="M315.1 333.6c.2-.1 0-.1 0 0z" data-name="Pfad 531" />
										<path d="M316.5 337z" data-name="Pfad 532" />
										<path d="M315.5 334l-.3-.2a1.2 1.2 0 00.3.2z" data-name="Pfad 534" />
										<path d="M315.4 333.6l.2.1c0-.2-.1-.3-.2-.1z" data-name="Pfad 535" />
										<path d="M314.8 333.7h.3a.1.1 0 00-.1-.1l-.2.1z" data-name="Pfad 536" />
										<path d="M245.2 350.8c-.2.3-.1.3 0 0z" data-name="Pfad 537" />
										<path d="M292.1 346.3c.1 0 .1-.1 0 0z" data-name="Pfad 538" />
										<path d="M291.5 347c.2-1.1.3-1 .6-.8l-.6-2.5z" data-name="Pfad 539" />
										<path
											d="M264.2 350.9l.6.7c-.4 1.4-.9 1-.3 2-.3-2.7 1.9-.5 1.6-3.3l.4.5-.2.1c.8 1.2.2-2 1.1-1.8.3.2.6.5.4.9l.6-.8c.2 0 .2.5 0 .5l.9-.3v.1l.4-1.5c.3.4-.1.3 0 .6l.5-.7c.3.7 0 1.4-.4 1.4.9 2.7.4-.7 1.6.7l-.5.4c.5 1.5.9.9 1.5 1.8-.2-.5-1.5-2.3-1-3 .2.2.4.3.7-.3.1 1 .4.7.8.6l.1 1.3c.4-.4.3-1.1.4-1.7.5.1.7 1.1.9 1.9.8.1-.7-1.5.1-1.9.7.4 1-.2 1.7-1 .5.4 0 .8.2 1.1l.3-1.1.1.5c.3-.4-.1-1.3.3-1.7 0-1.4 1.3 1.9 1.7.2.2.3 0 .8.1 1.3a10.7 10.7 0 001.2-2.4l.7.8c-.6-.9-.1-2.1.2-3.1l-.5-1 .7-.8a2.4 2.4 0 010 1.2l.1-.3a2.9 2.9 0 01.2 1.9 6 6 0 01-.4-.8 6.5 6.5 0 000 2.4.5.5 0 01.2-.4v.5l.2-.5.4 1.4v-.6l1.2.8c.6-1.5.9-3.7 2-4.5-.2 1.1.2 1.7.3 3-.5-1.3-.8.7-1.5.5.3.1.3.7.3.9l.9-1.3c.1 1 .3.7.7 1.1-.5-2 .6-1.4 1-2.1.1.7.1 1.4-.5 1.3.8 1.4.5-2.5 1.2-1.3-.1 0-.2-.1-.2.3.2-.6 1-.3.9.4h-.1c.9.1 2.7-.3 2.6-2.1a18.5 18.5 0 01.1 2.4l.8-6c.1 1.5 1 4.9.4 5.8.2.2.5.4.9-.2a6.3 6.3 0 01-.5-2.2c.7 1.6.5.8 1.3 2.1-.3-.3-.3-2.6 0-2.6a25 25 0 01.2 2.5l.5-2.4a4.9 4.9 0 00.5 2.5c-.1-.4.7-.1.9-.3l-.4-.5c1 .2.5-3.3 1.5-3.3-.1.5.1 2.9.6 3.1.1-1.2.3-5.7 1-6.7l.2.6.5-.8a70 70 0 01-1.2 7.1c.4.5.2.8.7.6a.7.7 0 01-.3 1l1.3.2c-.2-1.3.8-1.5.6-2.6l-1.2 1.6c-.2-1.3.3-3.9 1.2-3.8.3.5.1 2.4.2 2.9.1-.5.7-1 .8-.7l-.3.8c.6.4.6-1.9 1.3-.7.2.1.8 1.7.8.9a34.9 34.9 0 01-1.1-7.5 12 12 0 011.6 2.1c.5 1.2-.1 2.9.3 4l.1-1c.3.3.1 1.2.5.9-.1-1.4 1 0 .1-1.2.4-.4.5.2 1 .1a5.6 5.6 0 01.5-3.5 2.4 2.4 0 00.3 1c.9 0 1.5.6 2.4.5.1.3.6.7.5 1.3.1-.3.1-.7.4-.8.7 1.1-.6.3 0 1.6-.1-.8.5-1.2.9-1.7-.3-1.2-.9-.1-1.2.4a6.3 6.3 0 011-4.5c.7-.5.5 1.1.5.8 1.4.1.8-3.1 2-2 .6 1 .3 2.2.5 2.9-.5.5-1-.6-1.4-.5l.6.4c-.1.4-.5.7-.7.4.5.9 2.3-.1 3.4.7.1-.4.4-.8.2-1.2l-.3.2c-.4-.8.5-1.3 0-1.6.4-.7.7-1.7 1.4-1.3l.3 1.2c-.1-.4-.5-.7-.6-.3.2-.6 1.2 1.5 1.2-.1l-.5-.8c.4-.7.7-2.1 1.3-1.7-.4-1.2-.1.2-.7-1.2.6 1.7-1.4.1-.6 1.9-.6-1.6-.8-.6-1.5-2 .1.4.3.8-.2.6a.6.6 0 01-.1.4l.3.6c-.1 1-.8 1-1 1.5-.3-.2.1-.5-.2-.9l-.3.8c-.2-.9-.9-1.4-.3-2h-.6c-.4-.5-.9-.6-1.1-.2-.3-.2-.6 1.1-.4.4l-.8.7v-.2c-.9 0-1.7 1.7-2.9.2-.3.3-.5.6-1.1.4l-.2-.8c-.4.3-1.3-.6-1.3.2-.7-2-1.9-.2-2.7-.5l.1 1a2 2 0 00-1.4.8l.2.9c-.4.8-1.4-.5-2.2-.3 0-.4.2-.3.4-.1-1.2-1.9-1.8 1.7-2.9.4-.2.4-.3.3-.5.1v-.1h-.1l-.4-.4a2.2 2.2 0 00.3.5c-.2 0-.4.2-.6.4l-.2-1h-.1c-.3-.3-.1.5.1 1.2l-.3.6c-.4-1.5-.6.6-1.1-1-.1.8-1.2.8-1.1 2.5v-.3c-.3-.2-.6-.3-.8.2l-.3-1.2-.4 1.7a2 2 0 01-.4-2.1c-.7 1.6-.6.6-1.2 2.2l-.1-.8c-.3.1-.5 1.2-.8.5-.8-1.4-3 .2-4.7-1 .6 2.3-.8-1-.7.9-.2-.5-.4-.8-.2-1.3-.7.6-1.3-.7-1.6.9-.2-.5.1-.8-.1-1.2 0 .1-.2.5-.3.2s.1-.5.1-.7c-.8.2-.6 1.9-.5 3.5-.5-.7-.7-.6-.8.5-.2-.5-.5-1 0-1.3-.3 0-1.8-.6-1.7.7-.1-.3-.4 0-.5.1a2.9 2.9 0 00-1.3.1l.2.2c0 1.6-.5.4-.9.7v-.2c-1.3-1-.4.6-1.7-.5l.2 1c.2 2.1-1.1-1.1-1.7-.2l.3.5c-.3.8-1.4-2.7-1.7-2.9-.1-.2.1-.3.2-.5-1.1-1.1 0 1.3-.6 1.7-.2-.7-.1-1.8-.5-1.8-.3-.5-1.1 2.4-1.9 1.2a1.6 1.6 0 01.1 1.5c-.5.3-1.6-1.8-1.8-.1a.6.6 0 01-.1-.4c-.3.5-1.1.9-1.2 1.8-.8-3.3-2.1 1.9-2.5-1.2l-1.1.3v-.3c-.8-.1-.9.7-1.1 1.4-.2-.2-.1-.5-.1-.7-1.2-.5-1.3-.3-2 1.3l-.2-1c-.2.6-1.8-1.4-2.7-.1a1 1 0 01.1-.5c-1 1.3-3.2-2.4-3.2 1.3l-.7 1c1.1.2 0 1.6.5 2.1-.4.3-1.2-1-.7-1.2l.1.2c-.1-1.9-1.4-.5-1.5-1.8-2 .3-4.1-.5-6-.3l.4 1.4h-.7c-.2-.3-.4-1.1.1-1.1-.3-.8-.7.8-.7 1.1-1-.5.2-1.8-.1-1.8l-.4.2.1.2c-.2.6-.2 1.3-.8 1.3-.4-.3-.3-.9-.4-.9 0-.1-.1-.1-.2 0h-.8l.5 1.1c-.3.6-.8 0-.3 1.3-.8-2-3.2-.4-3.6-1-.4.9-.9.9-1.6.9.2.2.4 1.5-.1 1.4-.1-2.7-1.1-1.1-1.7-3 .5 1.3-1.5.5-.7 2.2-.5-.2-.1-1-.5-1.6-1 1.2-2.4-.4-3.7 0 0 .4.3.9 0 1.4l-.9-1.7c-.2.2-.1 2.1-.6.9a1.5 1.5 0 01.1.9c-2.7-1.5-5.2 1.9-8.1-1.2.4.7.2.8-.1.8.2.2.1.9.1 1.4l-1.2-1.3c-.1 1.4-1.2.2-1.2 1.4l.3-.3c-.4 1.5.9 3.3.9 5.3.4-1.7 1.6 2.5 2.3-.1.2.4-.1.6 0 1.1.2-.8.4-1 .9-.7v.2c1.4-.3 2 .5 3.6.9l-.2-.9c.3.1.4.4.6.6.3-1.5-.9 0-.7-1.6.6 1.9 2.4-.2 2.8 2 .5 0-.2-1.1.3-1.1l.2.6.1-.8c.3.1.6.8.6 1.3-.1-.1-.2.2-.3.2.5.7 1.2-.4 1.4-.1l-.5-.3c1.4-.7 3.1-.1 4.4-1.4l-.1-.4c.9-.9.9.4 2-.1v.1c.2-.5.5-.7.8-.7-.2.6.6 1 .3 1.6 1-1 .5-.8 1-2.5l.3.7c.2-.7.2-1.1.7-1.3-.4.7.5 1.1.1 2 1.4 1.5 1.6-1.8 2.4.5.3-2.1-1.2-1-.9-1.5-.3-.6.3-1.6.7-1.4.4 0 .9 2.6 1.9 2.4l-.2.2c.4.5.6-.8 1.1 0 .1-1.3.6 0 .5-1.6l-.8.5c.4-.5.7-2.4 1.6-1.6a1.8 1.8 0 01-.4 1c.3.4.4-.4.7.1.1 1.6-1 .5-1.4 1.8.3.6.9-1.3.8.5.1-2.2 1 .2 1.4-1.6l.1 1c.1-.2.2-.6.4-.6l-.2 1.3c.4-1.1 1.1.8 1.5.2-1 .2-.4-1.1-.9-1.8 1.1-1.4 1 2.4 2.4 1.8-.2.2-.8-.5-.6-1a2.2 2.2 0 01.9 1c.9-.3-.3-1 .1-1.6.5 1.1.4-.5.8-1l.1 1c1.2.5 0-2.1 1.1-1.4l-.2 1.4.5-.4v1.1c.5-.9.6-.7 1.2-.5-.2-.7-.2-1.8.3-1.9.4.5-.1.9.6.7-.1.6-.1 1.4-.6.6l-.1.9c.4.6.9 0 1.2 0l-.3-.2.8-1.5a1.2 1.2 0 010 1c.2-.1.3-.6.6-.7 0 .8.1 1.6-.2 2l.8-1c.1.3.6.9.5 1.2.6.4 1.1-1.7 1.8-1.2a.5.5 0 01.2-.4c.7.1 1.4 1 2-.2l.6 1.4c.6-.4-.8-1.7.1-2.4.7-.5.4 1.2.7 1.5.3-.8.7-2.3 1.5-1.2.6.6.4.4.2.6zm7.3-1.6c-.1.2-.3.9-.5.3 0-1.1.2-.6.5-.3zm11-3.8c-.1.3-.3.2-.5-.1.1-.2.3-.1.5.1zm30.6-10.8c-.4-.3-.3-.2 0 0zm.7.3v-.4c0 .3-.2.3-.3.2 0 .3.1.5.3.2zm-71.5 9.5l.2.2c-.3.4-.2.1-.2-.2z"
											data-name="Pfad 540"
										/>
										<path d="M281.4 347a.9.9 0 01-.1-.5c-.1.1-.1.3.1.5z" data-name="Pfad 541" />
										<path d="M259.6 352z" data-name="Pfad 542" />
										<path d="M304.5 344.6a.6.6 0 01-.3-.5.5.5 0 00.3.5z" data-name="Pfad 543" />
										<path d="M317.1 332.9l-.4.3c.2-.1.3.1.4.3v-.6z" data-name="Pfad 544" />
										<path d="M321.6 338.5l.2-.2-.1-.4c-.3 0-.4.4-.1.6z" data-name="Pfad 545" />
										<path
											d="M317.9 336.1c.1.8.4.5.7.3h-.1c-.1-1.1-.3-.7-.6-.3z"
											data-name="Pfad 546"
										/>
										<path d="M318.6 336.4a.4.4 0 01.3-.1c0-.4-.1-.1-.3.1z" data-name="Pfad 547" />
										<path
											d="M314.5 334.4c.2.2 0-1.1.1-.7 0-1.1-.8 1.3-.1.7z"
											data-name="Pfad 548"
										/>
										<path d="M318.5 338.8l-.3-1v.8z" data-name="Pfad 549" />
										<path d="M316 338.3l.5.2.1-.4c-.3.1-.6-.1-.6.2z" data-name="Pfad 550" />
										<path d="M316.6 338.2c.2 0 .3 0 .4-.2a.4.4 0 00-.4.2z" data-name="Pfad 551" />
										<path d="M317.9 339.1l-.2-.1-.3-.1z" data-name="Pfad 552" />
										<path
											d="M310.9 338.8l-.5.4c0 .4.2.5.3.4.1-.3.3-.5.2-.8z"
											data-name="Pfad 553"
										/>
										<path d="M312.8 341.3c-.2-.2-.2-.4-.3-.7l.1 1.3z" data-name="Pfad 554" />
										<path d="M311.3 341.8c0 .4-.6 1.1 0 .9.1-.3.5-.6 0-.9z" data-name="Pfad 555" />
										<path d="M303.3 341.3l.1-.1-.3-2z" data-name="Pfad 556" />
										<path
											d="M297 347.1c.7.4 0-1.3.6-.7.1-.5-.5-.4-.4-.9-.3.5-.6.2-.2 1.6z"
											data-name="Pfad 557"
										/>
										<path d="M297.2 345.4l.2-.3c-.2.1-.2.2-.2.3z" data-name="Pfad 558" />
										<path d="M218.2 345.7l-.5-.4.3.6z" data-name="Pfad 559" />
										<path d="M217.5 347.3l-.2-1.3-.2 1.2c.1-.1.3-.2.4.1z" data-name="Pfad 560" />
										<path d="M273 351.8v-.3c-.1-.3-.2-.3-.4-.4z" data-name="Pfad 561" />
										<path d="M267.4 351.5h.1l-.3-1.2z" data-name="Pfad 562" />
										<path d="M263.1 353.6c.2 0 .4-.3.6-.2-.4.2-.8-1.3-.6.2z" data-name="Pfad 563" />
									</g>
								</g>
							</g>
						</g>
					</g>
					<g data-name="Gruppe 45">
						<g data-name="Gruppe 44">
							<g data-name="Gruppe 43">
								<g data-name="Gruppe 42">
									<g fill="currentColor" data-name="Gruppe 41">
										<path d="M336.8 333.9c.2 0 .1-.4.1-.5-.3.2-.1.6-.1.5z" data-name="Pfad 564" />
										<path d="M334 335.3v-.2l-.3.5z" data-name="Pfad 565" />
										<path
											d="M331.3 335.6c.4.7 1-.2 1.5 0l.1.2.1-.6c-.6.1-1.3.5-1.7.4z"
											data-name="Pfad 566"
										/>
										<path d="M329.6 334.2c.1.3-.3.3.4 0l-.1-.1-.3.1z" data-name="Pfad 567" />
										<path d="M329.9 334.2c.3 0-.2-.2 0 0z" data-name="Pfad 568" />
										<path
											d="M328.6 334.5l.3-.3c-.1-.2-.4-.1-.3-.3-.4.2-.3.4 0 .6z"
											data-name="Pfad 569"
										/>
										<path d="M328.3 335.1l.2-.1c0-.1-.1-.1-.2.1z" data-name="Pfad 570" />
										<path
											d="M328.9 334.7l-.4.3c.1.1.1.3.2-.1 0 .2 0 0 .2-.2z"
											data-name="Pfad 571"
										/>
										<path d="M329.1 334.8c.2.1.5.2.2.5.7-.2.5-.7-.2-.5z" data-name="Pfad 572" />
										<path d="M331.2 336.4l.3.2.2-.3c0 .1-.5-.2-.5.1z" data-name="Pfad 573" />
										<path d="M326.2 334.5l.2.6.3-.2c-.2-.1-.5-.2-.5-.4z" data-name="Pfad 574" />
										<path d="M326.4 335.1l-.4.3c.4 0 .5-.2.4-.3z" data-name="Pfad 575" />
										<path d="M328.3 335.9l.7-.6-.8.6z" data-name="Pfad 576" />
										<path d="M324.6 334.7l.2-.4-.4.6z" data-name="Pfad 577" />
										<path
											d="M323.5 334.9c.1-.3-.3-.5-.1-.7-.3.1-.5.4-.7.6a.8.8 0 01.8.1z"
											data-name="Pfad 578"
										/>
										<path
											d="M322.4 335.2a1.4 1.4 0 00.3-.4 1.4 1.4 0 00-.3.4z"
											data-name="Pfad 579"
										/>
										<path d="M325.3 335.4c0-.1-.1-.3-.4-.4l.2.4z" data-name="Pfad 580" />
										<path d="M327.2 335.7c-.2.3-.7.6-.2.9.2-.3-.1-.5.2-.9z" data-name="Pfad 583" />
										<path d="M325.6 335.9h.5c0-.1-.1-.3 0-.4z" data-name="Pfad 584" />
										<path d="M325.4 336.1l.2-.2h-.1z" data-name="Pfad 585" />
										<path
											d="M323.2 335.5a.9.9 0 01-.6.3 1.1 1.1 0 00.8 0c0-.1.1-.4-.2-.3z"
											data-name="Pfad 586"
										/>
										<path d="M324.2 335.5c-.1.1 0 .1 0 0z" data-name="Pfad 587" />
										<path d="M320.2 336.1l.1.1v-.1z" data-name="Pfad 588" />
										<path d="M323.4 335.9c.2.1.3-.1.4-.2l-.4.2z" data-name="Pfad 589" />
										<path d="M321.8 335.5l.4.2-.4-.2z" data-name="Pfad 590" />
										<path d="M324 335.4l-.2.3.3-.2z" data-name="Pfad 592" />
										<path
											d="M319.9 339a.6.6 0 01.9-.5c.4-.4-.1-1.6-.5-2.3 0 .2 0 .3-.4.6.2.2 1 .4.7.8-.6.3-.5-.1-.8-.3.3.5-.6.8-.4 1.5l.5-.3c0 .2-.2.4 0 .5z"
											data-name="Pfad 593"
										/>
										<path
											d="M321.1 336.1l.2-.1c-.2 0-.4-.2-.7-.5a.5.5 0 00-.3.5l.8.1z"
											data-name="Pfad 594"
										/>
										<path
											d="M322.1 335.9c-.1.5-.5.7-.2 1.1.5-.1.3-.4.6-.6-.8.2.3-.2-.4-.5l.5-.1-.5-.1s.1.1 0 .1v.1c-.3-.1-.1-.1 0-.2v-.1l-.8.3c.2.2.4.1.8 0z"
											data-name="Pfad 595"
										/>
										<path d="M326.7 337.6c-.1-.1-.1 0 0 0z" data-name="Pfad 596" />
										<path
											d="M326.3 337.3c.1-.1.1-.2.3-.2.2.1 0 .2.1.3.1-.1.4-.4 0-.5l-.1.1c-.4-.1-.9-.6-.8-.7a2 2 0 00.5 1z"
											data-name="Pfad 597"
										/>
										<path d="M324.2 336.8l-.7.3.4.3v-.2c.4 0 .3-.3.3-.4z" data-name="Pfad 598" />
										<path d="M320.1 335.9l.1-.5-.4.7z" data-name="Pfad 599" />
										<path d="M319.2 336.1v-.4l-.2.2z" data-name="Pfad 600" />
										<path d="M267.5 347.7l-.2.1.2-.1z" data-name="Pfad 601" />
										<path d="M269 347.6v-.2c0 .1-.1.2 0 .2z" data-name="Pfad 602" />
										<path
											d="M296.4 339.1c-.4-.3-.8-.9-.7-.4l.1.4a.4.4 0 01.6 0z"
											data-name="Pfad 603"
										/>
										<path d="M281.2 343.7l.1.1.2-.4a.3.3 0 00-.3.3z" data-name="Pfad 604" />
										<path d="M281.2 345.5l-.4-.2.4.2z" data-name="Pfad 605" />
										<path d="M259.2 349.3l-.2.5c.4-.1.2-.3.2-.5z" data-name="Pfad 606" />
										<path d="M309.7 337.5a2.5 2.5 0 00-.7-.2c.4.2.7.5.7.2z" data-name="Pfad 607" />
										<path d="M267.5 343c-.1.1-.2.2-.1.3a.4.4 0 00.1-.3z" data-name="Pfad 608" />
										<path
											d="M308.3 337.4l.2.1a1.4 1.4 0 01.6-.2c-.3-.2-.6-.3-.8.1z"
											data-name="Pfad 609"
										/>
										<path d="M219.8 348.6a.8.8 0 00.4-.1l-.4.1z" data-name="Pfad 611" />
										<path d="M315.5 336.4c.2-.1 0-.1 0 0z" data-name="Pfad 612" />
										<path d="M316.6 338l-.1.2a.3.3 0 00.1-.2z" data-name="Pfad 613" />
										<path d="M315.8 336.5l-.3-.1.3.1z" data-name="Pfad 615" />
										<path d="M315.7 336.3h.2s0-.1-.2 0z" data-name="Pfad 616" />
										<path d="M315.2 336.4h.3a.1.1 0 01-.1-.1l-.2.1z" data-name="Pfad 617" />
										<path d="M245.1 349.5c-.3.2-.2.1 0 0z" data-name="Pfad 618" />
										<path d="M291.2 344.7c.2-.6.4-.5.7-.5l-.4-1.2z" data-name="Pfad 620" />
										<path
											d="M263.9 348.3l.5.3c-.5.7-1 .6-.4 1-.1-1.4 1.9-.4 1.8-1.8l.4.2-.2.1c.7.6.3-1 1.2-1 .3.1.5.2.4.4l.6-.4c.2 0 .2.2 0 .2l1-.2.5-.8c.3.2-.1.2 0 .3l.5-.4c.3.3-.1.7-.5.7.7 1.3.4-.4 1.6.3l-.5.2c.4.7.8.4 1.4.8-.2-.2-1.3-1.1-.8-1.5.2.1.4.1.7-.2.1.5.4.3.7.2l.1.6c.4-.2.3-.6.5-.9.5 0 .6.5.8.9.8 0-.6-.7.2-1 .6.2 1-.2 1.7-.6.5.2 0 .4.2.6l.3-.6.1.2c.3-.2-.1-.6.4-.9 0-.7 1.2.9 1.7 0 .2.2 0 .4.1.6a4 4 0 001.3-1.3l.7.3c-.5-.4 0-1.1.4-1.6l-.5-.5.7-.4v.6l.1-.2c.3.2.2.6.1 1a1.4 1.4 0 01-.3-.4 2.7 2.7 0 00-.2 1.2.2.2 0 01.2-.2v.3l.2-.3.3.7v-.3l1.1.3c.6-.8 1.2-2 2.3-2.4-.2.6 0 .9.1 1.5-.4-.6-.9.4-1.5.3a.2.2 0 01.2.4l1-.7c0 .5.3.4.6.5-.3-1 .7-.8 1.1-1.1a.5.5 0 01-.5.7c.7.7.6-1.3 1.3-.7-.1 0-.2 0-.2.2.3-.3 1.1-.2.9.1h-.1c.9 0 2.7-.3 2.7-1.2v1.2l1.2-3.1c0 .8.7 2.4 0 2.9a.8.8 0 00.9-.1c-.2-.1-.5-1-.3-1.1.6.8.4.4 1.2 1-.2-.1-.1-1.3.2-1.3a5.7 5.7 0 01.1 1.3l.7-1.2c-.2.2.1 1 .3 1.3-.1-.2.7-.1.9-.2l-.4-.2c1 0 .7-1.7 1.7-1.8-.1.2-.1 1.5.4 1.6.1-.6.6-2.9 1.4-3.5l.2.3.6-.5a24.8 24.8 0 01-1.7 3.7c.4.2.1.4.7.3.2.3-.2.5-.4.5h1.3c-.1-.7.9-.8.7-1.4l-1.2.9c-.1-.7.5-2 1.4-2 .3.2 0 1.2 0 1.4.1-.2.8-.6.9-.4l-.3.4c.5.2.7-1 1.3-.4.2 0 .7.8.7.4a10 10 0 01-.7-3.7 3.7 3.7 0 011.4 1c.4.6-.3 1.5 0 2a.8.8 0 01.2-.5c.2.1 0 .6.4.4 0-.7.9-.1.1-.6.4-.3.5.1 1 0a2 2 0 01.7-1.8.8.8 0 00.2.5c.9-.1 1.5.2 2.3.1.1.2.5.3.4.6.1-.1.2-.4.5-.4.6.5-.6.2-.1.8 0-.4.6-.6 1-.9-.2-.6-.9 0-1.2.3a2.5 2.5 0 011.3-2.3c.7-.3.4.5.5.4 1.4 0 1-1.6 2.1-1.2.5.5.2 1.1.3 1.5-.6.3-.9-.2-1.3-.2l.5.2a.8.8 0 01-.8.3c.4.4 2.3-.2 3.4.1.2-.2.5-.4.3-.6l-.3.1c-.4-.4.5-.7.1-.8.4-.4.8-.9 1.5-.7l.2.6c0-.2-.5-.3-.6-.1.2-.3 1.1.7 1.2-.1l-.5-.4c.4-.4.9-1.1 1.4-1-.3-.6-.1.1-.6-.6.5.8-1.4.1-.7 1-.5-.8-.7-.3-1.4-.9 0 .2.2.4-.2.3l-.1.2.3.3c-.2.5-.9.6-1.1.8-.3-.1.1-.2-.1-.4l-.3.4c-.1-.4-.8-.7-.2-1l-.6.1c-.4-.2-.9-.3-1.1 0-.3-.1-.6.6-.4.2l-.9.4v-.1c-.9.1-1.8 1-2.9.3a1.8 1.8 0 01-1.1.3l-.1-.4c-.4.2-1.2-.2-1.3.2-.6-1-1.9 0-2.6-.1v.5a3.3 3.3 0 00-1.5.5l.1.4c-.5.4-1.3-.2-2.1 0 0-.2.2-.2.4-.1-1.1-.9-1.9 1-2.9.4-.2.2-.4.2-.5.1l-.3-.2.3.2a.9.9 0 00-.6.3l-.2-.5h-.1c-.3-.1-.2.3 0 .6l-.3.3c-.3-.8-.6.3-1-.5-.1.4-1.2.5-1.2 1.3 0-.1-.1-.2 0-.2a.8.8 0 00-.8.1l-.2-.6-.5.9c-.4-.3-.6-.5-.3-1-.8.8-.7.4-1.3 1.2v-.4c-.3 0-.6.6-.8.3-.7-.7-2.9.3-4.6-.2.4 1.1-.8-.4-.7.5-.1-.3-.4-.4-.1-.7-.7.4-1.2-.3-1.7.5v-.6c-.1.1-.2.3-.3.1s.1-.2.2-.4c-.8.1-.8 1-.7 1.8-.5-.3-.6-.2-.9.3-.2-.2-.4-.5 0-.6-.3 0-1.7-.2-1.7.5-.1-.2-.4 0-.5.1a5.7 5.7 0 00-1.3.1l.2.1c-.1.8-.5.2-1 .4v-.1c-1.2-.4-.5.3-1.7-.2l.1.5c0 1.1-1.1-.5-1.7 0l.3.2c-.3.4-1.2-1.3-1.5-1.4-.1-.1.1-.2.2-.2-1-.5 0 .6-.7.9-.2-.3.1-.9-.4-.9-.3-.2-1.2 1.3-1.9.7a.5.5 0 01.1.7c-.5.2-1.5-.8-1.8.1l-.1-.2c-.3.3-1.2.5-1.3 1-.6-1.6-2.2 1.1-2.4-.4l-1.1.2v-.2a1.1 1.1 0 00-1.2.8c-.2-.1-.1-.2-.1-.3-1.1-.2-1.2-.1-2 .8l-.2-.5c-.2.3-1.7-.6-2.7.1l.1-.2c-1.1.7-3-1-3.2.9l-.7.5c1 0-.1.8.4 1.1-.4.2-1.1-.4-.6-.6l.1.1c.1-1-1.3-.2-1.4-.8-2 .3-4 0-5.9.2l.3.7h-.7c-.2-.2-.3-.5.2-.6-.3-.4-.7.4-.7.6-1-.2.3-.9 0-.9l-.4.1.1.1c-.3.3-.3.7-.8.7-.4-.1-.2-.4-.4-.4 0-.1-.1-.1-.2 0h-.8l.4.5c-.3.3-.8.1-.3.7-.7-1-3.1 0-3.5-.3a2 2 0 01-1.6.5c.2.1.3.7-.2.7.1-1.4-1.1-.5-1.6-1.4.5.6-1.5.3-.8 1.2-.5-.1-.1-.5-.5-.8-1 .6-2.4-.1-3.7.2 0 .2.2.4 0 .7l-.8-.8c-.3.1-.2 1-.7.5.1.1.2.4 0 .4-2.7-.6-5.3 1.2-8-.3.4.3.1.4-.1.4.2.1 0 .4.1.7l-1.1-.6c-.2.7-1.2.1-1.3.8l.3-.1c-.4.8.8 1.6.7 2.6.5-.9 1.5 1.2 2.3-.1.2.2-.1.3 0 .5.2-.4.4-.5 1-.4v.1c1.4-.2 2 .2 3.6.3l-.2-.5c.3 0 .4.2.6.3.3-.8-.9 0-.7-.8.5.9 2.3-.2 2.7.9.5 0-.2-.5.3-.6l.2.3.1-.4c.3 0 .5.4.6.6l-.3.1c.5.3 1.2-.2 1.4-.1l-.5-.1c1.4-.4 3.1-.2 4.4-.9l-.1-.2c1-.5.8.2 2-.1v.1a1.2 1.2 0 01.8-.4c-.3.3.6.5.2.8 1.1-.6.5-.4 1.2-1.3l.2.4c.2-.4.2-.5.8-.7-.4.4.4.5 0 1 1.3.7 1.7-1 2.3.1.4-1.1-1.1-.5-.8-.7-.3-.3.4-.8.7-.8.4 0 .8 1.2 1.7 1.1l-.2.1c.4.2.7-.4 1.1-.1.2-.7.6 0 .5-.8l-.8.3c.5-.3.8-1.3 1.7-.9 0 .2-.3.4-.4.5.3.2.4-.2.7 0 0 .8-1 .3-1.5 1 .3.3.9-.7.8.2.2-1.1.9 0 1.5-.9v.5a.8.8 0 01.5-.3l-.3.7c.5-.6 1.1.3 1.5 0-1 .1-.3-.5-.8-.8 1.2-.8.9 1.2 2.3.8-.2.1-.8-.2-.5-.5a2.5 2.5 0 01.9.4c.9-.2-.2-.5.2-.8.4.5.4-.3.8-.5l.1.5c1.1.2.2-1 1.2-.8l-.3.7.5-.2v.6c.5-.5.7-.4 1.2-.3a.7.7 0 01.4-1c.4.2-.1.5.5.3-.1.3-.2.7-.6.3l-.1.5c.4.3.9 0 1.1-.1a.4.4 0 01-.3-.1l.9-.8c.2.2.1.3 0 .5l.6-.4c0 .4 0 .8-.3 1l.9-.6c.1.2.5.4.4.6.6.2 1.2-.9 1.9-.7a.2.2 0 01.2-.2c.7 0 1.3.4 2-.2l.5.7c.6-.2-.7-.8.3-1.2.7-.3.3.6.6.7.3-.4.8-1.2 1.6-.7-.8.6-1 .6-1.1.6zm7.3-1.2c-.1.1-.4.5-.5.2.1-.6.3-.4.5-.2zm11.2-2.6c-.1.2-.3.1-.5 0a.4.4 0 01.5 0zm31-7.5c-.4-.1-.3 0 0 0zm.6.2c.1-.1 0-.1 0-.2 0 .1-.2.2-.4.1.2.1.3.2.4.1zm-71.4 9.3l.1.1c-.3.2-.2 0-.1-.1z"
											data-name="Pfad 621"
										/>
										<path d="M281.2 345.3a.4.4 0 01-.1-.3c-.1.1-.1.2.1.3z" data-name="Pfad 622" />
										<path d="M304.3 342.6l-.3-.2c0 .1 0 .2.3.2z" data-name="Pfad 624" />
										<path
											d="M317.5 335.9l-.4.2c.2-.1.3 0 .4.1-.1-.1-.2-.3 0-.3z"
											data-name="Pfad 625"
										/>
										<path d="M321.6 338.4l.2-.1v-.2c-.4 0-.5.3-.2.3z" data-name="Pfad 626" />
										<path
											d="M318.1 337.4c.1.4.3.2.6.1h-.1c.1-.5-.2-.3-.5-.1z"
											data-name="Pfad 627"
										/>
										<path d="M318.8 337.5h.3c-.1-.2-.2 0-.3 0z" data-name="Pfad 628" />
										<path d="M314.9 336.8c.2.1 0-.5.1-.4.1-.5-.9.8-.1.4z" data-name="Pfad 629" />
										<path d="M318.5 338.8l-.2-.5-.1.4z" data-name="Pfad 630" />
										<path d="M316.1 338.7l.5.1.1-.2c-.3 0-.7-.1-.6.1z" data-name="Pfad 631" />
										<path d="M316.7 338.6l.4-.1a.6.6 0 00-.4.1z" data-name="Pfad 632" />
										<path d="M317.9 339l-.2-.1h-.3z" data-name="Pfad 633" />
										<path
											d="M310.9 339.3l-.5.2c0 .2.1.3.3.2.2-.2.3-.3.2-.4z"
											data-name="Pfad 634"
										/>
										<path d="M312.7 340.4c-.2-.1-.2-.2-.3-.4l.1.6z" data-name="Pfad 635" />
										<path d="M311.2 340.8c0 .2-.7.6 0 .5 0-.2.5-.4 0-.5z" data-name="Pfad 636" />
										<path d="M303.2 341h.2l-.2-1.1z" data-name="Pfad 637" />
										<path
											d="M296.6 344.3c.6.2.1-.7.7-.4.1-.3-.5-.2-.4-.4-.3.3-.5.2-.3.8z"
											data-name="Pfad 638"
										/>
										<path d="M296.9 343.5l.2-.2z" data-name="Pfad 639" />
										<path d="M218.3 348.2l-.4-.2.3.3z" data-name="Pfad 640" />
										<path d="M217.6 349l-.1-.7-.2.6a.2.2 0 01.3.1z" data-name="Pfad 641" />
										<path d="M272.5 348.2v-.2c-.1-.2-.2-.2-.4-.2z" data-name="Pfad 642" />
										<path d="M267.1 348.4l.1.1-.3-.6z" data-name="Pfad 643" />
										<path d="M262.6 349.8l.6-.2c-.4.2-.7-.5-.6.2z" data-name="Pfad 644" />
									</g>
								</g>
							</g>
						</g>
					</g>
					<g data-name="Gruppe 50">
						<g data-name="Gruppe 49">
							<g data-name="Gruppe 48">
								<g data-name="Gruppe 47">
									<g fill="currentColor" data-name="Gruppe 46">
										<path d="M484.2 372.8c.5.1.3-.5.4-.6-.8.1-.4.8-.4.6z" data-name="Pfad 645" />
										<path d="M476.3 374l.1-.2-1.2.6z" data-name="Pfad 646" />
										<path
											d="M468.8 374c.7 1 2.7-.1 4 .2l.2.2.6-.8c-1.5.1-3.6.6-4.8.4z"
											data-name="Pfad 647"
										/>
										<path d="M464.9 371.8c.2.4-.9.3.9.1l-.2-.1z" data-name="Pfad 648" />
										<path d="M465.6 371.8c.8 0-.5-.3 0 0z" data-name="Pfad 649" />
										<path
											d="M462 372l1-.3c-.2-.2-1.1-.3-.8-.4-1 .1-.8.3-.2.7z"
											data-name="Pfad 650"
										/>
										<path d="M461 372.7l.5-.1c0-.1-.2-.1-.5.1z" data-name="Pfad 651" />
										<path
											d="M462.7 372.3l-1.1.3c.1.2.2.5.5-.1-.1.3.1 0 .6-.2z"
											data-name="Pfad 652"
										/>
										<path
											d="M463.4 372.4c.6.2 1.3.4.3.7 1.9-.1 1.6-.8-.3-.7z"
											data-name="Pfad 653"
										/>
										<path d="M468.4 375l.8.3.7-.3c-.3.1-1.5-.4-1.5 0z" data-name="Pfad 654" />
										<path
											d="M455.6 371.4c-.1.2.3.6.4.8l.8-.2c-.4-.1-1.1-.2-1.2-.6z"
											data-name="Pfad 655"
										/>
										<path d="M456 372.3l-1.1.3c1 .1 1.2-.1 1.1-.3z" data-name="Pfad 656" />
										<path d="M460.9 373.8l1.8-.7-2.2.7z" data-name="Pfad 657" />
										<path d="M451.3 371.4l.6-.5-1.1.7z" data-name="Pfad 658" />
										<path
											d="M448.4 371.4c.5-.4-.6-.7-.1-.9a6.5 6.5 0 00-2.1.7 3.5 3.5 0 012.2.2z"
											data-name="Pfad 659"
										/>
										<path d="M445.2 371.6l1-.4a3 3 0 00-1 .4z" data-name="Pfad 660" />
										<path d="M452.9 372.5a1.4 1.4 0 00-.9-.6l.4.6z" data-name="Pfad 661" />
										<path d="M452.5 372.5l-1-.1 1 .1z" data-name="Pfad 662" />
										<path d="M453.1 372.5h-.1s0 .1.1 0z" data-name="Pfad 663" />
										<path
											d="M457.9 373.2c-.7.3-2.1.6-.7 1.2.4-.4-.3-.7.7-1.2z"
											data-name="Pfad 664"
										/>
										<path d="M453.6 373.2l1.2.1c0-.2-.2-.4.1-.5z" data-name="Pfad 665" />
										<path d="M453 373.4l.6-.2h-.4z" data-name="Pfad 666" />
										<path
											d="M447.2 372.2a4.7 4.7 0 01-1.7.3 15 15 0 002.1.2c.1-.2.4-.5-.4-.5z"
											data-name="Pfad 667"
										/>
										<path d="M449.8 372.4h-.1c0 .1.1.1.1 0z" data-name="Pfad 668" />
										<path d="M439.1 372.4l.1.1v-.1z" data-name="Pfad 669" />
										<path
											d="M447.7 372.8a1.3 1.3 0 001.1-.2 4.9 4.9 0 01-1.2.1c-.1.1-.1.1.1.1z"
											data-name="Pfad 670"
										/>
										<path d="M443.4 371.9l.9.3c-.3-.2-.8-.5-.9-.3z" data-name="Pfad 671" />
										<path d="M449.5 372.3c-.1-.2-.1-.1 0 0z" data-name="Pfad 672" />
										<path
											d="M449.5 372.3a4.9 4.9 0 00-.7.3 3 3 0 00.9-.2.3.3 0 01-.2-.1z"
											data-name="Pfad 673"
										/>
										<path
											d="M437.1 376.1c.1-.5 1.5-1 2.6-.4 1.2-.4.4-2.2-.6-3.2 0 .2 0 .5-1.2.8.4.3 2.6.7 1.6 1.2-1.6.3-1.3-.2-2.1-.5.6.7-2 .9-1.7 1.9l1.4-.3c.2.1-.3.4 0 .5z"
											data-name="Pfad 674"
										/>
										<path
											d="M441.5 372.6l.5-.1a3.7 3.7 0 01-1.7-.8c-.8.3-1 .4-1.1.6l2.4.1z"
											data-name="Pfad 675"
										/>
										<path
											d="M444.2 372.6c-.4.6-1.6.8-.9 1.5 1.4 0 1-.5 1.9-.7-2.3 0 .7-.4-1-.8l1.3-.1-1.2-.3h.1c.1.1.1.1 0 .1l-.2.3c-.7-.1-.1-.2.1-.2v-.1l-2.3.3z"
											data-name="Pfad 676"
										/>
										<path d="M455.9 375.6l-.1-.1c-.1.1-.2.1.1.1z" data-name="Pfad 677" />
										<path
											d="M454.9 375.3a1 1 0 01.9-.2c.5.2 0 .3 0 .5.3-.2 1.2-.4.1-.7l-.2.1a5.6 5.6 0 01-2-1l1.2 1.3z"
											data-name="Pfad 678"
										/>
										<path d="M449.5 374.1l-1.9.3 1 .5v-.3c1 .1.8-.3.9-.5z" data-name="Pfad 679" />
										<path d="M438.9 372.1l.3-.6-1.2.9z" data-name="Pfad 680" />
										<path d="M436.4 372.2l.1-.6-.7.3z" data-name="Pfad 681" />
										<path d="M293.7 376.3l-.6.1a1 1 0 00.6-.1z" data-name="Pfad 682" />
										<path d="M297.8 376.5l.1-.3c-.2.1-.3.3-.1.3z" data-name="Pfad 683" />
										<path
											d="M374.3 371.3c-.8-.5-1.7-1.3-1.6-.7l.2.6a3 3 0 011.4.1z"
											data-name="Pfad 684"
										/>
										<path d="M331.8 374.1l.2.2.6-.6a3 3 0 00-.8.4z" data-name="Pfad 685" />
										<path d="M331.1 376.5l-1.1-.4 1.1.4z" data-name="Pfad 686" />
										<path d="M271.1 376.4l-.7.6c1 0 .6-.3.7-.6z" data-name="Pfad 687" />
										<path d="M410.5 372l-1.8-.4c.9.4 1.6.9 1.8.4z" data-name="Pfad 688" />
										<path d="M295.4 370.1c-.4.1-.5.2-.5.3.4 0 .6-.1.5-.3z" data-name="Pfad 689" />
										<path
											d="M406.6 371.6l.4.1a4.7 4.7 0 011.7-.1 2.6 2.6 0 00-2.1 0z"
											data-name="Pfad 690"
										/>
										<path d="M189.1 373.8l-.2-.1.2.1z" data-name="Pfad 691" />
										<path d="M165.5 367.1h1a1.6 1.6 0 00-1 0z" data-name="Pfad 692" />
										<path d="M426.2 371.8c.5-.1.1-.1 0 0z" data-name="Pfad 693" />
										<path d="M428.8 374.1c-.1.1-.2.1-.2.3l.2-.3z" data-name="Pfad 694" />
										<path d="M401.2 375.2c.2.1.1.1 0 0z" data-name="Pfad 695" />
										<path d="M427 372.1a6.4 6.4 0 00-.7-.2l.7.2z" data-name="Pfad 696" />
										<path d="M426.9 371.8a.9.9 0 01.5.1c0-.2 0-.2-.5-.1z" data-name="Pfad 697" />
										<path d="M425.5 371.8a2.8 2.8 0 01.9.1.1.1 0 01-.1-.1z" data-name="Pfad 698" />
										<path d="M233.1 373.4a.1.1 0 01-.1-.1c-.6.3-.3.3.1.1z" data-name="Pfad 699" />
										<path d="M358.3 377.6a1.9 1.9 0 011.9-.5l-.6-1.7z" data-name="Pfad 701" />
										<path
											d="M283.8 376.3l1.3.6c-1.7.8-2.8.5-1.6 1.3.2-1.8 5.3-.1 5.5-1.9l.9.4-.6.1c1.7.9 1.3-1.3 3.5-1 .8.2 1.3.4.8.6l1.7-.4c.5 0 .4.4-.1.3l2.6-.1v.1a9.1 9.1 0 011.7-.9c.7.3-.3.2-.2.4l1.5-.4c.6.5-.6.9-1.6.8 1.3 1.9 1.2-.4 4.2.7l-1.4.2c.9 1.1 2 .7 3.5 1.4-.4-.3-3.1-1.7-1.5-2.1a3.2 3.2 0 001.9-.1c0 .7.8.5 1.9.5l-.1.9c1.1-.2 1.1-.7 1.7-1a1.9 1.9 0 011.8 1.4c2 .2-1.4-1.1 1-1.2 1.7.4 2.9 0 4.9-.4 1.2.3-.2.5.2.8l1.1-.7c.3 0 .2.2.1.3.9-.2.1-.9 1.5-1.1.4-.9 2.8 1.5 4.5.4.4.3-.2.5-.1.9a18.7 18.7 0 004-1.4l1.6.6c-1.2-.7.4-1.4 1.7-2a9.8 9.8 0 00-1-.7l2.2-.4c.3.1 0 .4-.3.8l.4-.2c.8.3.4.8-.2 1.3l-.8-.6c-.5.5-1.1 1.1-1 1.6a1.2 1.2 0 01.7-.2.8.8 0 00-.2.4c.1.1.3-.1.7-.3l.5 1 .1-.4 2.8.7c2-.9 3.8-2.3 7-2.7-.8.7-.2 1.2-.3 2-.9-.9-2.5.3-4.1.1.9.1.7.5.4.6l3-.8c-.1.7.6.5 1.4.8-.6-1.4 2.2-.9 3.4-1.3.1.5-.2.9-1.7.8 1.6 1.1 2.1-1.6 3.7-.7-.4 0-.6-.1-.7.2.8-.4 2.9 0 2.4.4h-.4c2.4.2 7.2.1 7.6-1a5.8 5.8 0 01-.5 1.6l4.3-3.8c-.4 1 1 3.4-1 3.9a4.1 4.1 0 002.5 0c-.4-.1-.9-1.5-.4-1.5 1.4 1.1 1 .6 2.8 1.6-.6-.2.1-1.8 1-1.7-.1.2 0 1.5-.3 1.7l2.3-1.5c-.6.3-.1 1.3.4 1.7-.2-.3 2 .1 2.6-.1l-1-.4c2.6.3 2.6-2.1 5.1-2-.3.3-.8 1.9.5 2.1.6-.8 2.7-3.7 5-4.3l.4.5 1.7-.5a33.1 33.1 0 01-5.8 4.5c1 .4.3.5 1.7.5.5.4-.8.6-1.2.6l3.4.3c-.1-.9 2.6-.9 2.5-1.6l-3.7.9c-.1-.9 2.2-2.6 4.5-2.4.6.4-.5 1.6-.4 1.9.3-.3 2.3-.6 2.5-.3l-1 .5c1.3.4 2.2-1.2 3.8-.3.5.1 1.6 1.2 1.7.7-.9-1.1-1-4.3-.4-5.1a17 17 0 013.5 1.6c.9.8-1.4 1.9-.6 2.6 0-.2.5-.5.8-.6.6.2-.3.8 1 .7.2-.9 2.5.1.6-.8 1.2-.2 1.3.2 2.7.2-.4-.6 1.3-2 2.6-2.3-.1.2.2.5.3.7 2.5.1 3.9.6 6.2.6.2.2 1.3.5.9.9a2.3 2.3 0 011.4-.5c1.4.8-1.6.1-.6 1.1.1-.5 1.9-.7 2.9-1-.3-.8-2.4-.2-3.4.1 0-1.1 1.8-2.3 4.3-2.8 2-.3.8.8 1.2.6 3.7.3 3.1-2 6.2-1.1 1.2.7 0 1.5.3 2-1.6.3-2.4-.5-3.5-.5l1.3.4a3.8 3.8 0 01-2.1.2c1 .7 6.2.2 9 .9.5-.2 1.4-.5 1-.8l-.9.1c-.8-.6 1.7-.8.6-1.1a8.1 8.1 0 014.2-.7l.3.8c0-.2-1.1-.5-1.6-.3.7-.4 2.6 1.2 3.4.1l-1.2-.6c1.2-.4 2.7-1.3 4.2-1-.7-.8-.3.1-1.4-.9.9 1.2-3.8-.1-2.4 1.2-1.1-1.1-1.9-.5-3.3-1.5 0 .3.5.5-.8.4l-.3.2a1.5 1.5 0 01.6.4c-.6.6-2.6.6-3.3.9-.7-.1.3-.3-.1-.6l-1 .5c-.1-.6-2-1-.2-1.4h-1.6a5.3 5.3 0 00-3-.3c-.7-.1-1.9.6-1.2.2l-2.5.3v-.2c-2.4-.1-5 .9-7.8-.2a9.4 9.4 0 01-3 .1l-.3-.5c-1.1.2-3.2-.6-3.6 0-1.1-1.4-5.1-.4-7-.7l-.1.7a15.3 15.3 0 00-4.1.4l.1.6c-1.4.5-3.5-.5-5.7-.5a1 1 0 011.1 0c-2.6-1.4-5.5.9-7.8-.1a2.2 2.2 0 01-1.4 0h-.1l-.8-.3a1 1 0 00.7.3 14 14 0 00-1.8.2l-.3-.7h-.2c-.7-.3-.5.3-.2.8a3.6 3.6 0 00-.9.4c-.5-1.1-1.8.3-2.5-.8-.5.5-3.4.4-3.7 1.5 0-.2-.2-.2.1-.2a4.1 4.1 0 00-2.2 0l-.3-.8-1.6 1.1c-1-.5-1.4-.8-.4-1.4-2.4.9-1.9.3-4 1.3l.1-.5c-.7 0-1.9.7-2.3.3-1.6-1.1-8-.3-12.1-1.3.8 1.6-1.9-.7-2.1.5-.2-.4-.8-.6-.1-.9-2.1.3-3.2-.7-4.6.3-.2-.4.5-.5.3-.8-.2.1-.7.3-.9.1s.3-.3.7-.5c-2.2 0-2.4 1.2-2.6 2.2-1.1-.5-1.6-.5-2.4.2-.4-.4-1-.7.3-.8-.8-.1-4.6-.6-4.7.3-.2-.2-1.1-.1-1.3 0a20.5 20.5 0 00-3.5-.1l.5.2c-.7 1-1.4.2-2.7.3v-.1c-3.1-.8-1.3.3-4.4-.6l.2.7c-.3 1.4-2.7-.9-4.4-.4l.6.4c-1 .5-2.6-2-3.6-2.2-.2-.1.3-.2.6-.3-2.5-.9-.3.8-2.2 1-.3-.5.5-1.2-.8-1.3-.6-.4-3.7 1.4-5.4.5.4.4.7.7-.1 1-1.3.1-3.6-1.4-4.8-.3-.2-.1-.2-.2-.2-.3-1 .3-3.3.4-4 1-.9-2.3-6.4.9-6.3-1.1h-3.2l.1-.2a4.5 4.5 0 00-3.5.8c-.5-.2-.1-.3-.1-.4-2.9-.5-3.2-.4-5.7.6l-.2-.7c-.7.4-4.2-1.2-7.1-.4q0-.2.3-.3c-3.3.7-7.7-2.1-9 .4l-2.2.5c2.8.3-.4 1.1.7 1.5-1.1.1-2.8-.8-1.5-.9l.2.1c.5-1.3-3.4-.5-3.3-1.4-5.5-.1-10.8-.9-15.9-1.1l.6 1-1.8-.1c-.5-.2-.6-.8.7-.7-.7-.6-2.1.4-2.2.6-2.5-.5 1-1.1.2-1.2h-1l.2.1c-.9.4-.9.8-2.5.7-1-.2-.5-.6-.9-.7h-.6l-2.2-.1.9.8c-1 .4-2.1-.1-1.1.8-1.5-1.4-8.4-.7-9.3-1.2a11 11 0 01-4.5.4c.4.2.6 1.1-.8.9.6-1.8-2.7-.9-3.8-2.2 1 .9-4.2.1-2.6 1.4-1.2-.2-.1-.7-1-1.1-2.9.6-6.4-.6-10-.5-.1.2.5.6-.3 1l-1.9-1.3c-.7.1-.7 1.4-2 .5.2.2.4.5 0 .6-7-1.4-14.5.5-21.6-1.9 1 .5.3.5-.4.5.5.1 0 .6.1.9l-3-1c-.6.9-3.2 0-3.6.8l1-.1c-1.3 1 1.7 2.3 1.5 3.6 1.5-1.1 3.7 1.8 6.1.2.5.3-.5.4-.2.7.6-.5 1.3-.6 2.6-.3l-.2.1c3.7 0 5.3.6 9.4 1.1l-.3-.7a3.2 3.2 0 011.5.5c1.1-.9-2.5-.1-1.5-1.2 1.1 1.3 6.3.2 7.1 1.7 1.4 0-.4-.8 1-.7l.4.4.4-.5a1.5 1.5 0 011.4 1l-.9.1c1.2.5 3.3-.1 3.7.1l-1.3-.3c3.8-.3 8.3.4 12-.3l-.3-.3c2.8-.5 2.2.4 5.3.2l-.1.1a5.3 5.3 0 012.3-.4c-.8.3 1.4.7.4 1.1 3-.5 1.5-.4 3.5-1.5l.4.5a3.6 3.6 0 012.3-.8c-1.3.4.9.8-.5 1.3 3.2 1.2 4.8-1 6.2.7 1.5-1.4-2.7-.8-1.9-1.1-.7-.5 1.2-1 2.2-.8 1 .1 1.7 1.8 4.3 1.9l-.5.1c1 .4 1.9-.4 3.1.2.7-.8 1.5.1 1.7-1l-2.4.2c1.3-.2 2.6-1.5 4.8-.8a3.2 3.2 0 01-1.3.6c.6.3 1.2-.2 1.9.2-.2 1.1-2.9.2-4.3.9.7.5 2.7-.7 2 .4 1.1-1.5 2.5.3 4.3-.8l-.1.6a4.7 4.7 0 011.4-.4l-.9.8c1.4-.7 2.7.7 4.1.3-2.8-.1-.6-.8-1.8-1.3 3.5-.8 2 1.7 5.9 1.5-.5.1-2-.4-1.1-.7a7.2 7.2 0 012.2.8c2.6-.1-.4-.7.7-1 .9.8 1.3-.3 2.4-.5v.7c2.9.5.8-1.3 3.5-.8l-1.1.9 1.4-.2-.3.7a5.3 5.3 0 013.5-.1c-.3-.5.2-1.2 1.5-1.2.9.4-.5.6 1.3.6-.4.4-.9.9-1.7.3l-.5.6c.9.5 2.4.2 3.1.2a1.2 1.2 0 01-.7-.2l2.7-.8c.4.3.1.4-.3.6a14.6 14.6 0 011.7-.4c-.2.5-.2 1.1-1.3 1.3l2.6-.5c.2.2 1.3.7 1 .9 1.4.3 3.5-.9 5.4-.5a1.5 1.5 0 01.7-.3c1.8.2 3.3.9 5.4.2l1.2 1c1.6-.2-1.6-1.2 1.2-1.5 1.9-.3.7.8 1.4 1.1 1-.5 2.7-1.4 4.4-.6a11.3 11.3 0 00-2.2-.2zm20.2 0c-.4.1-1.2.5-1.5.1.5-.7.8-.3 1.5-.1zm30.7-.9c-.3.2-.7.1-1.2-.2a2.7 2.7 0 011.2.2zm85.6-3.2c-.9-.2-.6-.1 0 0zm1.8.3c.2-.1.2-.2.1-.3-.1.2-.5.2-1 .1.2.3.4.4.9.2zm-194.6-3.6l.3.2c-.8.1-.6-.1-.3-.2z"
											data-name="Pfad 702"
										/>
										<path d="M331.2 376.2l-.2-.4c-.1.1-.1.3.2.4z" data-name="Pfad 703" />
										<path d="M271.2 376.3a.1.1 0 00-.1.1z" data-name="Pfad 704" />
										<path d="M394 377.7a1.5 1.5 0 01-.7-.3c-.1.1.1.2.7.3z" data-name="Pfad 705" />
										<path
											d="M431.8 371.6l-1.2.2a1.9 1.9 0 011 .2c0-.2-.2-.4.2-.4z"
											data-name="Pfad 706"
										/>
										<path d="M441.8 375.7l.5-.1v-.3c-.7.1-1.3.3-.5.4z" data-name="Pfad 707" />
										<path
											d="M432.8 373.7c.1.6.8.4 1.6.3h-.1c.2-.7-.6-.5-1.5-.3z"
											data-name="Pfad 708"
										/>
										<path d="M434.6 374h.8c.1-.3-.3-.1-.8 0z" data-name="Pfad 709" />
										<path d="M424.4 372.2c.4.1.3-.7.5-.5.5-.7-2.6.8-.5.5z" data-name="Pfad 710" />
										<path d="M433.4 375.6l-.2-.7-.5.5z" data-name="Pfad 711" />
										<path
											d="M427 375l1.3.2c0-.1.1-.2.4-.2-.8-.1-1.7-.2-1.7 0z"
											data-name="Pfad 712"
										/>
										<path d="M428.7 375a2.8 2.8 0 001-.1 3.8 3.8 0 00-1 .1z" data-name="Pfad 713" />
										<path d="M431.7 375.7l-.4-.1-.9-.1z" data-name="Pfad 714" />
										<path
											d="M413.1 374.7l-1.4.2c-.1.2.2.4.8.3.2-.2.8-.3.6-.5z"
											data-name="Pfad 715"
										/>
										<path d="M417.3 376.6c-.4-.1-.4-.3-.6-.5l-.1.8z" data-name="Pfad 716" />
										<path
											d="M413.2 376.7c-.1.2-2.1.6-.3.6.2-.2 1.6-.4.3-.6z"
											data-name="Pfad 717"
										/>
										<path d="M391.8 375.3h.4l-.1-1.4z" data-name="Pfad 718" />
										<path
											d="M372.9 378.3c1.7.4.4-.8 1.9-.4.4-.3-1.2-.4-.8-.6-1 .3-1.5.1-1.1 1z"
											data-name="Pfad 719"
										/>
										<path d="M374 377.3l.5-.2-.5.2z" data-name="Pfad 720" />
										<path d="M161.5 366.2l-1.1-.3.7.5z" data-name="Pfad 721" />
										<path d="M159.4 367.2l-.2-.9-.7.8a1 1 0 01.9.1z" data-name="Pfad 722" />
										<path d="M306.9 378.2l.1-.2a1 1 0 00-.9-.3z" data-name="Pfad 723" />
										<path d="M292.3 377.2h.2l-.4-.8z" data-name="Pfad 724" />
										<path d="M280 377.9l1.6-.1c-1.1.2-1.8-.9-1.6.1z" data-name="Pfad 725" />
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
